/* eslint-disable */
export const region2Barangays = [
    {
        CITY: 'ABULUG',
        BARANGAY: 'ALINUNU',
    },
    {
        CITY: 'ABULUG',
        BARANGAY: 'BAGU',
    },
    {
        CITY: 'ABULUG',
        BARANGAY: 'BANGUIAN',
    },
    {
        CITY: 'ABULUG',
        BARANGAY: 'CALOG NORTE',
    },
    {
        CITY: 'ABULUG',
        BARANGAY: 'CALOG SUR',
    },
    {
        CITY: 'ABULUG',
        BARANGAY: 'CANAYUN',
    },
    {
        CITY: 'ABULUG',
        BARANGAY: 'CENTRO (POB.)',
    },
    {
        CITY: 'ABULUG',
        BARANGAY: 'DANA-ILI',
    },
    {
        CITY: 'ABULUG',
        BARANGAY: 'GUIDDAM',
    },
    {
        CITY: 'ABULUG',
        BARANGAY: 'LIBERTAD',
    },
    {
        CITY: 'ABULUG',
        BARANGAY: 'LUCBAN',
    },
    {
        CITY: 'ABULUG',
        BARANGAY: 'PINILI',
    },
    {
        CITY: 'ABULUG',
        BARANGAY: 'SAN AGUSTIN',
    },
    {
        CITY: 'ABULUG',
        BARANGAY: 'SAN JULIAN',
    },
    {
        CITY: 'ABULUG',
        BARANGAY: 'SANTA FILOMENA',
    },
    {
        CITY: 'ABULUG',
        BARANGAY: 'SANTA ROSA',
    },
    {
        CITY: 'ABULUG',
        BARANGAY: 'SANTO TOMAS',
    },
    {
        CITY: 'ABULUG',
        BARANGAY: 'SIGUIRAN',
    },
    {
        CITY: 'ABULUG',
        BARANGAY: 'SIMAYUNG',
    },
    {
        CITY: 'ABULUG',
        BARANGAY: 'SIRIT',
    },
    {
        CITY: 'ALLACAPAN',
        BARANGAY: 'BESSANG',
    },
    {
        CITY: 'ALLACAPAN',
        BARANGAY: 'BINOBONGAN',
    },
    {
        CITY: 'ALLACAPAN',
        BARANGAY: 'BULO',
    },
    {
        CITY: 'ALLACAPAN',
        BARANGAY: 'BUROT',
    },
    {
        CITY: 'ALLACAPAN',
        BARANGAY: 'CAPAGARAN (BRIGIDA)',
    },
    {
        CITY: 'ALLACAPAN',
        BARANGAY: 'CAPALUTAN',
    },
    {
        CITY: 'ALLACAPAN',
        BARANGAY: 'CAPANICKIAN NORTE',
    },
    {
        CITY: 'ALLACAPAN',
        BARANGAY: 'CAPANICKIAN SUR',
    },
    {
        CITY: 'ALLACAPAN',
        BARANGAY: 'CATARATAN',
    },
    {
        CITY: 'ALLACAPAN',
        BARANGAY: 'CENTRO EAST (POB.)',
    },
    {
        CITY: 'ALLACAPAN',
        BARANGAY: 'CENTRO WEST (POB.)',
    },
    {
        CITY: 'ALLACAPAN',
        BARANGAY: 'DAAN-ILI',
    },
    {
        CITY: 'ALLACAPAN',
        BARANGAY: 'DAGUPAN',
    },
    {
        CITY: 'ALLACAPAN',
        BARANGAY: 'DALAYAP',
    },
    {
        CITY: 'ALLACAPAN',
        BARANGAY: 'GAGADDANGAN',
    },
    {
        CITY: 'ALLACAPAN',
        BARANGAY: 'IRINGAN',
    },
    {
        CITY: 'ALLACAPAN',
        BARANGAY: 'LABBEN',
    },
    {
        CITY: 'ALLACAPAN',
        BARANGAY: 'MALUYO',
    },
    {
        CITY: 'ALLACAPAN',
        BARANGAY: 'MAPURAO',
    },
    {
        CITY: 'ALLACAPAN',
        BARANGAY: 'MATUCAY',
    },
    {
        CITY: 'ALLACAPAN',
        BARANGAY: 'NAGATTATAN',
    },
    {
        CITY: 'ALLACAPAN',
        BARANGAY: 'PACAC',
    },
    {
        CITY: 'ALLACAPAN',
        BARANGAY: 'SAN JUAN (MAGUININANGO)',
    },
    {
        CITY: 'ALLACAPAN',
        BARANGAY: 'SILANGAN',
    },
    {
        CITY: 'ALLACAPAN',
        BARANGAY: 'TAMBOLI',
    },
    {
        CITY: 'ALLACAPAN',
        BARANGAY: 'TUBEL',
    },
    {
        CITY: 'ALLACAPAN',
        BARANGAY: 'UTAN',
    },
    {
        CITY: 'AMULUNG',
        BARANGAY: 'ABOLO',
    },
    {
        CITY: 'AMULUNG',
        BARANGAY: 'AGGUIRIT',
    },
    {
        CITY: 'AMULUNG',
        BARANGAY: 'ALITUNGTUNG',
    },
    {
        CITY: 'AMULUNG',
        BARANGAY: 'ANNABUCULAN',
    },
    {
        CITY: 'AMULUNG',
        BARANGAY: 'ANNAFATAN',
    },
    {
        CITY: 'AMULUNG',
        BARANGAY: 'ANQUIRAY',
    },
    {
        CITY: 'AMULUNG',
        BARANGAY: 'BABAYUAN',
    },
    {
        CITY: 'AMULUNG',
        BARANGAY: 'BACCUIT',
    },
    {
        CITY: 'AMULUNG',
        BARANGAY: 'BACRING',
    },
    {
        CITY: 'AMULUNG',
        BARANGAY: 'BACULUD',
    },
    {
        CITY: 'AMULUNG',
        BARANGAY: 'BALAUINI',
    },
    {
        CITY: 'AMULUNG',
        BARANGAY: 'BAUAN',
    },
    {
        CITY: 'AMULUNG',
        BARANGAY: 'BAYABAT',
    },
    {
        CITY: 'AMULUNG',
        BARANGAY: 'CALAMAGUI',
    },
    {
        CITY: 'AMULUNG',
        BARANGAY: 'CALINTAAN',
    },
    {
        CITY: 'AMULUNG',
        BARANGAY: 'CARATACAT',
    },
    {
        CITY: 'AMULUNG',
        BARANGAY: 'CASINGSINGAN NORTE',
    },
    {
        CITY: 'AMULUNG',
        BARANGAY: 'CASINGSINGAN SUR',
    },
    {
        CITY: 'AMULUNG',
        BARANGAY: 'CATARAUAN',
    },
    {
        CITY: 'AMULUNG',
        BARANGAY: 'CENTRO',
    },
    {
        CITY: 'AMULUNG',
        BARANGAY: 'CONCEPCION',
    },
    {
        CITY: 'AMULUNG',
        BARANGAY: 'CORDOVA',
    },
    {
        CITY: 'AMULUNG',
        BARANGAY: 'DADDA',
    },
    {
        CITY: 'AMULUNG',
        BARANGAY: 'DAFUNGANAY',
    },
    {
        CITY: 'AMULUNG',
        BARANGAY: 'DUGAYUNG',
    },
    {
        CITY: 'AMULUNG',
        BARANGAY: 'ESTEFANIA',
    },
    {
        CITY: 'AMULUNG',
        BARANGAY: 'GABUT',
    },
    {
        CITY: 'AMULUNG',
        BARANGAY: 'GANGAUAN',
    },
    {
        CITY: 'AMULUNG',
        BARANGAY: 'GORAN',
    },
    {
        CITY: 'AMULUNG',
        BARANGAY: 'JURISDICCION',
    },
    {
        CITY: 'AMULUNG',
        BARANGAY: 'LA SUERTE',
    },
    {
        CITY: 'AMULUNG',
        BARANGAY: 'LOGUNG',
    },
    {
        CITY: 'AMULUNG',
        BARANGAY: 'MAGOGOD',
    },
    {
        CITY: 'AMULUNG',
        BARANGAY: 'MANALO',
    },
    {
        CITY: 'AMULUNG',
        BARANGAY: 'MAROBBOB',
    },
    {
        CITY: 'AMULUNG',
        BARANGAY: 'MASICAL',
    },
    {
        CITY: 'AMULUNG',
        BARANGAY: 'MONTE ALEGRE',
    },
    {
        CITY: 'AMULUNG',
        BARANGAY: 'NABBIALAN',
    },
    {
        CITY: 'AMULUNG',
        BARANGAY: 'NAGSABARAN',
    },
    {
        CITY: 'AMULUNG',
        BARANGAY: 'NANGALASAUAN',
    },
    {
        CITY: 'AMULUNG',
        BARANGAY: 'NANUCCAUAN',
    },
    {
        CITY: 'AMULUNG',
        BARANGAY: 'PACAC-GRANDE',
    },
    {
        CITY: 'AMULUNG',
        BARANGAY: 'PACAC-PEQUENO',
    },
    {
        CITY: 'AMULUNG',
        BARANGAY: 'PALACU',
    },
    {
        CITY: 'AMULUNG',
        BARANGAY: 'PALAYAG',
    },
    {
        CITY: 'AMULUNG',
        BARANGAY: 'TANA',
    },
    {
        CITY: 'AMULUNG',
        BARANGAY: 'UNAG',
    },
    {
        CITY: 'APARRI',
        BARANGAY: 'BACKILING',
    },
    {
        CITY: 'APARRI',
        BARANGAY: 'BANGAG',
    },
    {
        CITY: 'APARRI',
        BARANGAY: 'BINALAN',
    },
    {
        CITY: 'APARRI',
        BARANGAY: 'BISAGU',
    },
    {
        CITY: 'APARRI',
        BARANGAY: 'BUKIG',
    },
    {
        CITY: 'APARRI',
        BARANGAY: 'BULALA NORTE',
    },
    {
        CITY: 'APARRI',
        BARANGAY: 'BULALA SUR',
    },
    {
        CITY: 'APARRI',
        BARANGAY: 'CAAGAMAN',
    },
    {
        CITY: 'APARRI',
        BARANGAY: 'CENTRO 1 (POB.)',
    },
    {
        CITY: 'APARRI',
        BARANGAY: 'CENTRO 10 (POB.)',
    },
    {
        CITY: 'APARRI',
        BARANGAY: 'CENTRO 11 (POB.)',
    },
    {
        CITY: 'APARRI',
        BARANGAY: 'CENTRO 12 (POB.)',
    },
    {
        CITY: 'APARRI',
        BARANGAY: 'CENTRO 13 (POB.)',
    },
    {
        CITY: 'APARRI',
        BARANGAY: 'CENTRO 14 (POB.)',
    },
    {
        CITY: 'APARRI',
        BARANGAY: 'CENTRO 15 (POB.)',
    },
    {
        CITY: 'APARRI',
        BARANGAY: 'CENTRO 2 (POB.)',
    },
    {
        CITY: 'APARRI',
        BARANGAY: 'CENTRO 3 (POB.)',
    },
    {
        CITY: 'APARRI',
        BARANGAY: 'CENTRO 4 (POB.)',
    },
    {
        CITY: 'APARRI',
        BARANGAY: 'CENTRO 5 (POB.)',
    },
    {
        CITY: 'APARRI',
        BARANGAY: 'CENTRO 6 (POB.)',
    },
    {
        CITY: 'APARRI',
        BARANGAY: 'CENTRO 7 (POB.)',
    },
    {
        CITY: 'APARRI',
        BARANGAY: 'CENTRO 8 (POB.)',
    },
    {
        CITY: 'APARRI',
        BARANGAY: 'CENTRO 9 (POB.)',
    },
    {
        CITY: 'APARRI',
        BARANGAY: 'DODAN',
    },
    {
        CITY: 'APARRI',
        BARANGAY: 'FUGA ISLAND',
    },
    {
        CITY: 'APARRI',
        BARANGAY: 'GADDANG',
    },
    {
        CITY: 'APARRI',
        BARANGAY: 'LINAO',
    },
    {
        CITY: 'APARRI',
        BARANGAY: 'MABANGUC',
    },
    {
        CITY: 'APARRI',
        BARANGAY: 'MACANAYA (PESCARIA)',
    },
    {
        CITY: 'APARRI',
        BARANGAY: 'MAURA',
    },
    {
        CITY: 'APARRI',
        BARANGAY: 'MINANGA',
    },
    {
        CITY: 'APARRI',
        BARANGAY: 'NAVAGAN',
    },
    {
        CITY: 'APARRI',
        BARANGAY: 'PADDAYA',
    },
    {
        CITY: 'APARRI',
        BARANGAY: 'PARUDDUN NORTE',
    },
    {
        CITY: 'APARRI',
        BARANGAY: 'PARUDDUN SUR',
    },
    {
        CITY: 'APARRI',
        BARANGAY: 'PLAZA',
    },
    {
        CITY: 'APARRI',
        BARANGAY: 'PUNTA',
    },
    {
        CITY: 'APARRI',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'APARRI',
        BARANGAY: 'SANJA',
    },
    {
        CITY: 'APARRI',
        BARANGAY: 'TALLUNGAN',
    },
    {
        CITY: 'APARRI',
        BARANGAY: 'TORAN',
    },
    {
        CITY: 'APARRI',
        BARANGAY: 'ZINARAG',
    },
    {
        CITY: 'BAGGAO',
        BARANGAY: 'ADAOAG',
    },
    {
        CITY: 'BAGGAO',
        BARANGAY: 'AGAMAN (PROPER)',
    },
    {
        CITY: 'BAGGAO',
        BARANGAY: 'AGAMAN NORTE',
    },
    {
        CITY: 'BAGGAO',
        BARANGAY: 'AGAMAN SUR',
    },
    {
        CITY: 'BAGGAO',
        BARANGAY: 'ALBA',
    },
    {
        CITY: 'BAGGAO',
        BARANGAY: 'ANNAYATAN',
    },
    {
        CITY: 'BAGGAO',
        BARANGAY: 'ASASSI',
    },
    {
        CITY: 'BAGGAO',
        BARANGAY: 'ASINGA-VIA',
    },
    {
        CITY: 'BAGGAO',
        BARANGAY: 'AWALLAN',
    },
    {
        CITY: 'BAGGAO',
        BARANGAY: 'BACAGAN',
    },
    {
        CITY: 'BAGGAO',
        BARANGAY: 'BAGUNOT',
    },
    {
        CITY: 'BAGGAO',
        BARANGAY: 'BARSAT EAST',
    },
    {
        CITY: 'BAGGAO',
        BARANGAY: 'BARSAT WEST',
    },
    {
        CITY: 'BAGGAO',
        BARANGAY: 'BITAG GRANDE',
    },
    {
        CITY: 'BAGGAO',
        BARANGAY: 'BITAG PEQUENO',
    },
    {
        CITY: 'BAGGAO',
        BARANGAY: 'BUNUGAN',
    },
    {
        CITY: 'BAGGAO',
        BARANGAY: 'C. VERZOSA (VALLEY COVE)',
    },
    {
        CITY: 'BAGGAO',
        BARANGAY: 'C. VERZOSA (VALLEY COVE*)',
    },
    {
        CITY: 'BAGGAO',
        BARANGAY: 'CANAGATAN',
    },
    {
        CITY: 'BAGGAO',
        BARANGAY: 'CARUPIAN',
    },
    {
        CITY: 'BAGGAO',
        BARANGAY: 'CATUGAY',
    },
    {
        CITY: 'BAGGAO',
        BARANGAY: 'DABBAC GRANDE',
    },
    {
        CITY: 'BAGGAO',
        BARANGAY: 'DALIN',
    },
    {
        CITY: 'BAGGAO',
        BARANGAY: 'DALLA',
    },
    {
        CITY: 'BAGGAO',
        BARANGAY: 'HACIENDA INTAL',
    },
    {
        CITY: 'BAGGAO',
        BARANGAY: 'IBULO',
    },
    {
        CITY: 'BAGGAO',
        BARANGAY: 'IMURONG',
    },
    {
        CITY: 'BAGGAO',
        BARANGAY: 'J. PALLAGAO',
    },
    {
        CITY: 'BAGGAO',
        BARANGAY: 'LASILAT',
    },
    {
        CITY: 'BAGGAO',
        BARANGAY: 'MABINI',
    },
    {
        CITY: 'BAGGAO',
        BARANGAY: 'MASICAL',
    },
    {
        CITY: 'BAGGAO',
        BARANGAY: 'MOCAG',
    },
    {
        CITY: 'BAGGAO',
        BARANGAY: 'NANGALINAN',
    },
    {
        CITY: 'BAGGAO',
        BARANGAY: 'POBLACION (CENTRO)',
    },
    {
        CITY: 'BAGGAO',
        BARANGAY: 'REMUS',
    },
    {
        CITY: 'BAGGAO',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'BAGGAO',
        BARANGAY: 'SAN FRANCISCO',
    },
    {
        CITY: 'BAGGAO',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'BAGGAO',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'BAGGAO',
        BARANGAY: 'SAN MIGUEL',
    },
    {
        CITY: 'BAGGAO',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'BAGGAO',
        BARANGAY: 'SANTA MARGARITA',
    },
    {
        CITY: 'BAGGAO',
        BARANGAY: 'SANTOR',
    },
    {
        CITY: 'BAGGAO',
        BARANGAY: 'TAGUING',
    },
    {
        CITY: 'BAGGAO',
        BARANGAY: 'TAGUNTUNGAN',
    },
    {
        CITY: 'BAGGAO',
        BARANGAY: 'TALLANG',
    },
    {
        CITY: 'BAGGAO',
        BARANGAY: 'TAYTAY',
    },
    {
        CITY: 'BAGGAO',
        BARANGAY: 'TEMBLIQUE',
    },
    {
        CITY: 'BAGGAO',
        BARANGAY: 'TUNGEL',
    },
    {
        CITY: 'BALLESTEROS',
        BARANGAY: 'AMMUBUAN',
    },
    {
        CITY: 'BALLESTEROS',
        BARANGAY: 'BARAN',
    },
    {
        CITY: 'BALLESTEROS',
        BARANGAY: 'CABARITAN EAST',
    },
    {
        CITY: 'BALLESTEROS',
        BARANGAY: 'CABARITAN WEST',
    },
    {
        CITY: 'BALLESTEROS',
        BARANGAY: 'CABAYU',
    },
    {
        CITY: 'BALLESTEROS',
        BARANGAY: 'CABULUAN EAST',
    },
    {
        CITY: 'BALLESTEROS',
        BARANGAY: 'CABULUAN WEST',
    },
    {
        CITY: 'BALLESTEROS',
        BARANGAY: 'CENTRO EAST (POB.)',
    },
    {
        CITY: 'BALLESTEROS',
        BARANGAY: 'CENTRO WEST (POB.)',
    },
    {
        CITY: 'BALLESTEROS',
        BARANGAY: 'FUGU',
    },
    {
        CITY: 'BALLESTEROS',
        BARANGAY: 'MABUTTAL EAST',
    },
    {
        CITY: 'BALLESTEROS',
        BARANGAY: 'MABUTTAL WEST',
    },
    {
        CITY: 'BALLESTEROS',
        BARANGAY: 'NARARAGAN',
    },
    {
        CITY: 'BALLESTEROS',
        BARANGAY: 'PALLOC',
    },
    {
        CITY: 'BALLESTEROS',
        BARANGAY: 'PAYAGAN EAST',
    },
    {
        CITY: 'BALLESTEROS',
        BARANGAY: 'PAYAGAN WEST',
    },
    {
        CITY: 'BALLESTEROS',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'BALLESTEROS',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'BALLESTEROS',
        BARANGAY: 'ZITANGA',
    },
    {
        CITY: 'BUGUEY',
        BARANGAY: 'ALUCAO WESTE (SAN LORENZO)',
    },
    {
        CITY: 'BUGUEY',
        BARANGAY: 'ALUCAO WESTE (SAN LORENZO*)',
    },
    {
        CITY: 'BUGUEY',
        BARANGAY: 'ANTIPORDA',
    },
    {
        CITY: 'BUGUEY',
        BARANGAY: 'BALLANG',
    },
    {
        CITY: 'BUGUEY',
        BARANGAY: 'BALZA',
    },
    {
        CITY: 'BUGUEY',
        BARANGAY: 'CABARITAN',
    },
    {
        CITY: 'BUGUEY',
        BARANGAY: 'CALAMEGATAN',
    },
    {
        CITY: 'BUGUEY',
        BARANGAY: 'CENTRO (POB.)',
    },
    {
        CITY: 'BUGUEY',
        BARANGAY: 'CENTRO WEST',
    },
    {
        CITY: 'BUGUEY',
        BARANGAY: 'DALAYA',
    },
    {
        CITY: 'BUGUEY',
        BARANGAY: 'FULA',
    },
    {
        CITY: 'BUGUEY',
        BARANGAY: 'LERON',
    },
    {
        CITY: 'BUGUEY',
        BARANGAY: 'MADDALERO',
    },
    {
        CITY: 'BUGUEY',
        BARANGAY: 'MALA ESTE',
    },
    {
        CITY: 'BUGUEY',
        BARANGAY: 'MALA WESTE',
    },
    {
        CITY: 'BUGUEY',
        BARANGAY: 'MINANGA ESTE',
    },
    {
        CITY: 'BUGUEY',
        BARANGAY: 'MINANGA WESTE',
    },
    {
        CITY: 'BUGUEY',
        BARANGAY: 'PADDAYA ESTE',
    },
    {
        CITY: 'BUGUEY',
        BARANGAY: 'PADDAYA WESTE',
    },
    {
        CITY: 'BUGUEY',
        BARANGAY: 'PATTAO',
    },
    {
        CITY: 'BUGUEY',
        BARANGAY: 'QUINAWEGAN',
    },
    {
        CITY: 'BUGUEY',
        BARANGAY: 'REMEBELLA',
    },
    {
        CITY: 'BUGUEY',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'BUGUEY',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'BUGUEY',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'BUGUEY',
        BARANGAY: 'SANTA ISABEL',
    },
    {
        CITY: 'BUGUEY',
        BARANGAY: 'SANTA MARIA',
    },
    {
        CITY: 'BUGUEY',
        BARANGAY: 'TABBAC',
    },
    {
        CITY: 'BUGUEY',
        BARANGAY: 'VILLA CIELO',
    },
    {
        CITY: 'BUGUEY',
        BARANGAY: 'VILLA GRACIA',
    },
    {
        CITY: 'BUGUEY',
        BARANGAY: 'VILLA LEONORA',
    },
    {
        CITY: 'ALCALA',
        BARANGAY: 'ABBEG',
    },
    {
        CITY: 'ALCALA',
        BARANGAY: 'AFUSING BATO',
    },
    {
        CITY: 'ALCALA',
        BARANGAY: 'AFUSING DAGA',
    },
    {
        CITY: 'ALCALA',
        BARANGAY: 'AGANI',
    },
    {
        CITY: 'ALCALA',
        BARANGAY: 'BACULOD',
    },
    {
        CITY: 'ALCALA',
        BARANGAY: 'BAYBAYOG',
    },
    {
        CITY: 'ALCALA',
        BARANGAY: 'CABULUAN',
    },
    {
        CITY: 'ALCALA',
        BARANGAY: 'CALANTAC',
    },
    {
        CITY: 'ALCALA',
        BARANGAY: 'CARALLANGAN',
    },
    {
        CITY: 'ALCALA',
        BARANGAY: 'CENTRO NORTE (POB.)',
    },
    {
        CITY: 'ALCALA',
        BARANGAY: 'CENTRO SUR (POB.)',
    },
    {
        CITY: 'ALCALA',
        BARANGAY: 'DALAOIG',
    },
    {
        CITY: 'ALCALA',
        BARANGAY: 'DAMUROG',
    },
    {
        CITY: 'ALCALA',
        BARANGAY: 'JURISDICTION',
    },
    {
        CITY: 'ALCALA',
        BARANGAY: 'MALALATAN',
    },
    {
        CITY: 'ALCALA',
        BARANGAY: 'MARABURAB',
    },
    {
        CITY: 'ALCALA',
        BARANGAY: 'MASIN',
    },
    {
        CITY: 'ALCALA',
        BARANGAY: 'PAGBANGKERUAN',
    },
    {
        CITY: 'ALCALA',
        BARANGAY: 'PARED',
    },
    {
        CITY: 'ALCALA',
        BARANGAY: 'PIGGATAN',
    },
    {
        CITY: 'ALCALA',
        BARANGAY: 'PINOPOC',
    },
    {
        CITY: 'ALCALA',
        BARANGAY: 'PUSSIAN',
    },
    {
        CITY: 'ALCALA',
        BARANGAY: 'SAN ESTEBAN',
    },
    {
        CITY: 'ALCALA',
        BARANGAY: 'TAMBAN',
    },
    {
        CITY: 'ALCALA',
        BARANGAY: 'TUPANG',
    },
    {
        CITY: 'CLAVERIA',
        BARANGAY: 'ALIMOAN',
    },
    {
        CITY: 'CLAVERIA',
        BARANGAY: 'BACSAY CATARAOAN NORTE',
    },
    {
        CITY: 'CLAVERIA',
        BARANGAY: 'BACSAY CATARAOAN SUR',
    },
    {
        CITY: 'CLAVERIA',
        BARANGAY: 'BACSAY MAPULAPULA',
    },
    {
        CITY: 'CLAVERIA',
        BARANGAY: 'BILIBIGAO',
    },
    {
        CITY: 'CLAVERIA',
        BARANGAY: 'BUENAVISTA',
    },
    {
        CITY: 'CLAVERIA',
        BARANGAY: 'CADCADIR EAST',
    },
    {
        CITY: 'CLAVERIA',
        BARANGAY: 'CADCADIR WEST',
    },
    {
        CITY: 'CLAVERIA',
        BARANGAY: 'CAMALAGGOAN/D LEANO',
    },
    {
        CITY: 'CLAVERIA',
        BARANGAY: 'CAPANIKIAN',
    },
    {
        CITY: 'CLAVERIA',
        BARANGAY: 'CENTRO I (POB.)',
    },
    {
        CITY: 'CLAVERIA',
        BARANGAY: 'CENTRO II (POB.)',
    },
    {
        CITY: 'CLAVERIA',
        BARANGAY: 'CENTRO III',
    },
    {
        CITY: 'CLAVERIA',
        BARANGAY: 'CENTRO IV (NANGASANGAN)',
    },
    {
        CITY: 'CLAVERIA',
        BARANGAY: 'CENTRO V (MINA)',
    },
    {
        CITY: 'CLAVERIA',
        BARANGAY: 'CENTRO VI (MINANGA)',
    },
    {
        CITY: 'CLAVERIA',
        BARANGAY: 'CENTRO VII (MALASIN EAST)',
    },
    {
        CITY: 'CLAVERIA',
        BARANGAY: 'CENTRO VIII (MALASIN WEST)',
    },
    {
        CITY: 'CLAVERIA',
        BARANGAY: 'CULAO',
    },
    {
        CITY: 'CLAVERIA',
        BARANGAY: 'DIBALIO',
    },
    {
        CITY: 'CLAVERIA',
        BARANGAY: 'KILKILING',
    },
    {
        CITY: 'CLAVERIA',
        BARANGAY: 'LABLABIG',
    },
    {
        CITY: 'CLAVERIA',
        BARANGAY: 'LUZON',
    },
    {
        CITY: 'CLAVERIA',
        BARANGAY: 'MABNANG',
    },
    {
        CITY: 'CLAVERIA',
        BARANGAY: 'MAGDALENA',
    },
    {
        CITY: 'CLAVERIA',
        BARANGAY: 'MALILITAO',
    },
    {
        CITY: 'CLAVERIA',
        BARANGAY: 'NAGSABARAN',
    },
    {
        CITY: 'CLAVERIA',
        BARANGAY: 'PATA EAST',
    },
    {
        CITY: 'CLAVERIA',
        BARANGAY: 'PATA WEST',
    },
    {
        CITY: 'CLAVERIA',
        BARANGAY: 'PINAS',
    },
    {
        CITY: 'CLAVERIA',
        BARANGAY: 'SAN ANTONIO (SAYAD*/BIMEKEL*)',
    },
    {
        CITY: 'CLAVERIA',
        BARANGAY: 'SAN ANTONIO (SAYAD/BIMEKEL)',
    },
    {
        CITY: 'CLAVERIA',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'CLAVERIA',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'CLAVERIA',
        BARANGAY: 'SANTA MARIA (SURNGOT)',
    },
    {
        CITY: 'CLAVERIA',
        BARANGAY: 'SANTIAGO',
    },
    {
        CITY: 'CLAVERIA',
        BARANGAY: 'SANTO NINO (BARBARNIS)',
    },
    {
        CITY: 'CLAVERIA',
        BARANGAY: 'SANTO TOMAS',
    },
    {
        CITY: 'CLAVERIA',
        BARANGAY: 'TABBUGAN',
    },
    {
        CITY: 'CLAVERIA',
        BARANGAY: 'TAGGAT NORTE',
    },
    {
        CITY: 'CLAVERIA',
        BARANGAY: 'TAGGAT SUR',
    },
    {
        CITY: 'CLAVERIA',
        BARANGAY: 'UNION',
    },
    {
        CITY: 'PAMPLONA',
        BARANGAY: 'ABANQUERUAN',
    },
    {
        CITY: 'PAMPLONA',
        BARANGAY: 'ALLASITAN',
    },
    {
        CITY: 'PAMPLONA',
        BARANGAY: 'BAGU',
    },
    {
        CITY: 'PAMPLONA',
        BARANGAY: 'BALINGIT',
    },
    {
        CITY: 'PAMPLONA',
        BARANGAY: 'BIDDUANG',
    },
    {
        CITY: 'PAMPLONA',
        BARANGAY: 'CABAGGAN',
    },
    {
        CITY: 'PAMPLONA',
        BARANGAY: 'CAPALALIAN',
    },
    {
        CITY: 'PAMPLONA',
        BARANGAY: 'CASITAN',
    },
    {
        CITY: 'PAMPLONA',
        BARANGAY: 'CENTRO (POB.)',
    },
    {
        CITY: 'PAMPLONA',
        BARANGAY: 'CURVA',
    },
    {
        CITY: 'PAMPLONA',
        BARANGAY: 'GATTU',
    },
    {
        CITY: 'PAMPLONA',
        BARANGAY: 'MASI',
    },
    {
        CITY: 'PAMPLONA',
        BARANGAY: 'NAGATTATAN',
    },
    {
        CITY: 'PAMPLONA',
        BARANGAY: 'NAGTUPACAN',
    },
    {
        CITY: 'PAMPLONA',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'PAMPLONA',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'PAMPLONA',
        BARANGAY: 'TABBA',
    },
    {
        CITY: 'PAMPLONA',
        BARANGAY: 'TUPANNA',
    },
    {
        CITY: 'CAGAYAN-RIZAL',
        BARANGAY: 'ANAGGUAN',
    },
    {
        CITY: 'CAGAYAN-RIZAL',
        BARANGAY: 'ANUNGU',
    },
    {
        CITY: 'CAGAYAN-RIZAL',
        BARANGAY: 'ANURTURU',
    },
    {
        CITY: 'CAGAYAN-RIZAL',
        BARANGAY: 'BALUNGCANAG',
    },
    {
        CITY: 'CAGAYAN-RIZAL',
        BARANGAY: 'BATTUT',
    },
    {
        CITY: 'CAGAYAN-RIZAL',
        BARANGAY: 'BATU',
    },
    {
        CITY: 'CAGAYAN-RIZAL',
        BARANGAY: 'BURAL (ZINUNDUNGAN)',
    },
    {
        CITY: 'CAGAYAN-RIZAL',
        BARANGAY: 'CAMBABANGAN',
    },
    {
        CITY: 'CAGAYAN-RIZAL',
        BARANGAY: 'CAPACUAN',
    },
    {
        CITY: 'CAGAYAN-RIZAL',
        BARANGAY: 'DUNGGAN',
    },
    {
        CITY: 'CAGAYAN-RIZAL',
        BARANGAY: 'DUYUN',
    },
    {
        CITY: 'CAGAYAN-RIZAL',
        BARANGAY: 'GADDANGAO',
    },
    {
        CITY: 'CAGAYAN-RIZAL',
        BARANGAY: 'GAGGABUTAN EAST',
    },
    {
        CITY: 'CAGAYAN-RIZAL',
        BARANGAY: 'GAGGABUTAN WEST',
    },
    {
        CITY: 'CAGAYAN-RIZAL',
        BARANGAY: 'ILLURU NORTE',
    },
    {
        CITY: 'CAGAYAN-RIZAL',
        BARANGAY: 'ILLURU SUR',
    },
    {
        CITY: 'CAGAYAN-RIZAL',
        BARANGAY: 'LATTUT',
    },
    {
        CITY: 'CAGAYAN-RIZAL',
        BARANGAY: 'LINNO (VILLA CRUZ)',
    },
    {
        CITY: 'CAGAYAN-RIZAL',
        BARANGAY: 'LINNO (VILLA CRUZ*)',
    },
    {
        CITY: 'CAGAYAN-RIZAL',
        BARANGAY: 'LIWAN',
    },
    {
        CITY: 'CAGAYAN-RIZAL',
        BARANGAY: 'MABBANG',
    },
    {
        CITY: 'CAGAYAN-RIZAL',
        BARANGAY: 'MASI (ZINUNDUNGAN)',
    },
    {
        CITY: 'CAGAYAN-RIZAL',
        BARANGAY: 'MAUANAN',
    },
    {
        CITY: 'CAGAYAN-RIZAL',
        BARANGAY: 'MINANGA',
    },
    {
        CITY: 'CAGAYAN-RIZAL',
        BARANGAY: 'NANAUATAN',
    },
    {
        CITY: 'CAGAYAN-RIZAL',
        BARANGAY: 'NANUNGARAN',
    },
    {
        CITY: 'CAGAYAN-RIZAL',
        BARANGAY: 'PASINGAN',
    },
    {
        CITY: 'CAGAYAN-RIZAL',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'CAGAYAN-RIZAL',
        BARANGAY: 'SAN JUAN (ZINUNDUNGAN)',
    },
    {
        CITY: 'CAGAYAN-RIZAL',
        BARANGAY: 'SINICKING',
    },
    {
        CITY: 'SANTA-ANA',
        BARANGAY: 'BATU-PARADA',
    },
    {
        CITY: 'SANTA-ANA',
        BARANGAY: 'CASAGAN',
    },
    {
        CITY: 'SANTA-ANA',
        BARANGAY: 'CASAMBALANGAN (PORT IRENE)',
    },
    {
        CITY: 'SANTA-ANA',
        BARANGAY: 'CENTRO (POB.)',
    },
    {
        CITY: 'SANTA-ANA',
        BARANGAY: 'DIORA-ZINUNGAN',
    },
    {
        CITY: 'SANTA-ANA',
        BARANGAY: 'DUNGEG',
    },
    {
        CITY: 'SANTA-ANA',
        BARANGAY: 'KAPANIKIAN',
    },
    {
        CITY: 'SANTA-ANA',
        BARANGAY: 'MAREDE',
    },
    {
        CITY: 'SANTA-ANA',
        BARANGAY: 'PALAWIG',
    },
    {
        CITY: 'SANTA-ANA',
        BARANGAY: 'PATUNUNGAN',
    },
    {
        CITY: 'SANTA-ANA',
        BARANGAY: 'RAPULI (PUNTI)',
    },
    {
        CITY: 'SANTA-ANA',
        BARANGAY: 'SAN VICENTE (FORT)',
    },
    {
        CITY: 'SANTA-ANA',
        BARANGAY: 'SANTA CLARA',
    },
    {
        CITY: 'SANTA-ANA',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'SANTA-ANA',
        BARANGAY: 'TANGATAN',
    },
    {
        CITY: 'SANTA-ANA',
        BARANGAY: 'VISITACION (POB.)',
    },
    {
        CITY: 'SANTA-TERESITA',
        BARANGAY: 'ALUCAO',
    },
    {
        CITY: 'SANTA-TERESITA',
        BARANGAY: 'ARIDAWEN',
    },
    {
        CITY: 'SANTA-TERESITA',
        BARANGAY: 'BUYUN',
    },
    {
        CITY: 'SANTA-TERESITA',
        BARANGAY: 'CANIUGAN',
    },
    {
        CITY: 'SANTA-TERESITA',
        BARANGAY: 'CENTRO EAST (POB.)',
    },
    {
        CITY: 'SANTA-TERESITA',
        BARANGAY: 'CENTRO WEST',
    },
    {
        CITY: 'SANTA-TERESITA',
        BARANGAY: 'DUNGEG',
    },
    {
        CITY: 'SANTA-TERESITA',
        BARANGAY: 'LUGA',
    },
    {
        CITY: 'SANTA-TERESITA',
        BARANGAY: 'MASI',
    },
    {
        CITY: 'SANTA-TERESITA',
        BARANGAY: 'MISSION',
    },
    {
        CITY: 'SANTA-TERESITA',
        BARANGAY: 'SIMBALUCA',
    },
    {
        CITY: 'SANTA-TERESITA',
        BARANGAY: 'SIMPATUYO',
    },
    {
        CITY: 'SANTA-TERESITA',
        BARANGAY: 'VILLA',
    },
    {
        CITY: 'SANTO-NINO',
        BARANGAY: 'ABARIONGAN RUAR',
    },
    {
        CITY: 'SANTO-NINO',
        BARANGAY: 'ABARIONGAN UNEG',
    },
    {
        CITY: 'SANTO-NINO',
        BARANGAY: 'BALAGAN',
    },
    {
        CITY: 'SANTO-NINO',
        BARANGAY: 'BALANNI',
    },
    {
        CITY: 'SANTO-NINO',
        BARANGAY: 'CABAYO',
    },
    {
        CITY: 'SANTO-NINO',
        BARANGAY: 'CALAPANGAN',
    },
    {
        CITY: 'SANTO-NINO',
        BARANGAY: 'CALASSITAN',
    },
    {
        CITY: 'SANTO-NINO',
        BARANGAY: 'CAMPO',
    },
    {
        CITY: 'SANTO-NINO',
        BARANGAY: 'CENTRO NORTE (POB.)',
    },
    {
        CITY: 'SANTO-NINO',
        BARANGAY: 'CENTRO SUR (POB.)',
    },
    {
        CITY: 'SANTO-NINO',
        BARANGAY: 'DUNGAO',
    },
    {
        CITY: 'SANTO-NINO',
        BARANGAY: 'LATTAC',
    },
    {
        CITY: 'SANTO-NINO',
        BARANGAY: 'LIPATAN',
    },
    {
        CITY: 'SANTO-NINO',
        BARANGAY: 'LUBO',
    },
    {
        CITY: 'SANTO-NINO',
        BARANGAY: 'MABITBITNONG',
    },
    {
        CITY: 'SANTO-NINO',
        BARANGAY: 'MAPITAC',
    },
    {
        CITY: 'SANTO-NINO',
        BARANGAY: 'MASICAL',
    },
    {
        CITY: 'SANTO-NINO',
        BARANGAY: 'MATALAO',
    },
    {
        CITY: 'SANTO-NINO',
        BARANGAY: 'NAG-UMA',
    },
    {
        CITY: 'SANTO-NINO',
        BARANGAY: 'NAMUCCAYAN',
    },
    {
        CITY: 'SANTO-NINO',
        BARANGAY: 'NIUG NORTE',
    },
    {
        CITY: 'SANTO-NINO',
        BARANGAY: 'NIUG SUR',
    },
    {
        CITY: 'SANTO-NINO',
        BARANGAY: 'PALUSAO',
    },
    {
        CITY: 'SANTO-NINO',
        BARANGAY: 'SAN MANUEL',
    },
    {
        CITY: 'SANTO-NINO',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'SANTO-NINO',
        BARANGAY: 'SANTA FELICITAS',
    },
    {
        CITY: 'SANTO-NINO',
        BARANGAY: 'SANTA MARIA',
    },
    {
        CITY: 'SANTO-NINO',
        BARANGAY: 'SIDIRAN',
    },
    {
        CITY: 'SANTO-NINO',
        BARANGAY: 'TABANG',
    },
    {
        CITY: 'SANTO-NINO',
        BARANGAY: 'TAMUCCO',
    },
    {
        CITY: 'SANTO-NINO',
        BARANGAY: 'VIRGINIA',
    },
    {
        CITY: 'CAMALANIUGAN',
        BARANGAY: 'ABAGAO',
    },
    {
        CITY: 'CAMALANIUGAN',
        BARANGAY: 'AFUNAN CABAYU',
    },
    {
        CITY: 'CAMALANIUGAN',
        BARANGAY: 'AGUSI',
    },
    {
        CITY: 'CAMALANIUGAN',
        BARANGAY: 'ALILINU',
    },
    {
        CITY: 'CAMALANIUGAN',
        BARANGAY: 'BAGGAO',
    },
    {
        CITY: 'CAMALANIUGAN',
        BARANGAY: 'BANTAY',
    },
    {
        CITY: 'CAMALANIUGAN',
        BARANGAY: 'BULALA',
    },
    {
        CITY: 'CAMALANIUGAN',
        BARANGAY: 'CASILI NORTE',
    },
    {
        CITY: 'CAMALANIUGAN',
        BARANGAY: 'CASILI SUR',
    },
    {
        CITY: 'CAMALANIUGAN',
        BARANGAY: 'CATOTORAN NORTE',
    },
    {
        CITY: 'CAMALANIUGAN',
        BARANGAY: 'CATOTORAN SUR',
    },
    {
        CITY: 'CAMALANIUGAN',
        BARANGAY: 'CENTRO NORTE (POB.)',
    },
    {
        CITY: 'CAMALANIUGAN',
        BARANGAY: 'CENTRO SUR (POB.)',
    },
    {
        CITY: 'CAMALANIUGAN',
        BARANGAY: 'CULLIT',
    },
    {
        CITY: 'CAMALANIUGAN',
        BARANGAY: 'DACAL-LAFUGU',
    },
    {
        CITY: 'CAMALANIUGAN',
        BARANGAY: 'DAMMANG NORTE (JOAQUIN DE LA CRUZ)',
    },
    {
        CITY: 'CAMALANIUGAN',
        BARANGAY: 'DAMMANG NORTE (JOAQUIN DE LA CRUZ*)',
    },
    {
        CITY: 'CAMALANIUGAN',
        BARANGAY: 'DAMMANG SUR (FELIPE TUZON)',
    },
    {
        CITY: 'CAMALANIUGAN',
        BARANGAY: 'DAMMANG SUR (FELIPE TUZON*)',
    },
    {
        CITY: 'CAMALANIUGAN',
        BARANGAY: 'DUGO',
    },
    {
        CITY: 'CAMALANIUGAN',
        BARANGAY: 'FUSINA',
    },
    {
        CITY: 'CAMALANIUGAN',
        BARANGAY: 'GANG-NGO',
    },
    {
        CITY: 'CAMALANIUGAN',
        BARANGAY: 'JURISDICTION',
    },
    {
        CITY: 'CAMALANIUGAN',
        BARANGAY: 'LUEC',
    },
    {
        CITY: 'CAMALANIUGAN',
        BARANGAY: 'MINANGA',
    },
    {
        CITY: 'CAMALANIUGAN',
        BARANGAY: 'PARAGAT',
    },
    {
        CITY: 'CAMALANIUGAN',
        BARANGAY: 'SAPPING',
    },
    {
        CITY: 'CAMALANIUGAN',
        BARANGAY: 'TAGUM',
    },
    {
        CITY: 'CAMALANIUGAN',
        BARANGAY: 'TULUTTUGING',
    },
    {
        CITY: 'CAMALANIUGAN',
        BARANGAY: 'ZIMINILA',
    },
    {
        CITY: 'ENRILE',
        BARANGAY: 'ALIBAGO (VILLA MARIA)',
    },
    {
        CITY: 'ENRILE',
        BARANGAY: 'BARANGAY I (POB.)',
    },
    {
        CITY: 'ENRILE',
        BARANGAY: 'BARANGAY II (POB.)',
    },
    {
        CITY: 'ENRILE',
        BARANGAY: 'BARANGAY III (SAN ROQUE)',
    },
    {
        CITY: 'ENRILE',
        BARANGAY: 'BARANGAY III (SAN ROQUE*)',
    },
    {
        CITY: 'ENRILE',
        BARANGAY: 'BARANGAY III-A',
    },
    {
        CITY: 'ENRILE',
        BARANGAY: 'BARANGAY IV (POB.)',
    },
    {
        CITY: 'ENRILE',
        BARANGAY: 'BATU',
    },
    {
        CITY: 'ENRILE',
        BARANGAY: 'DIVISORIA',
    },
    {
        CITY: 'ENRILE',
        BARANGAY: 'INGA',
    },
    {
        CITY: 'ENRILE',
        BARANGAY: 'LANNA',
    },
    {
        CITY: 'ENRILE',
        BARANGAY: 'LEMU NORTE',
    },
    {
        CITY: 'ENRILE',
        BARANGAY: 'LEMU SUR',
    },
    {
        CITY: 'ENRILE',
        BARANGAY: 'LIWAN NORTE',
    },
    {
        CITY: 'ENRILE',
        BARANGAY: 'LIWAN SUR',
    },
    {
        CITY: 'ENRILE',
        BARANGAY: 'MADDARULUG NORTE',
    },
    {
        CITY: 'ENRILE',
        BARANGAY: 'MADDARULUG SUR',
    },
    {
        CITY: 'ENRILE',
        BARANGAY: 'MAGALALAG EAST',
    },
    {
        CITY: 'ENRILE',
        BARANGAY: 'MAGALALAG WEST (SAN NICOLAS)',
    },
    {
        CITY: 'ENRILE',
        BARANGAY: 'MAGALALAG WEST (SAN NICOLAS*)',
    },
    {
        CITY: 'ENRILE',
        BARANGAY: 'MARACURU',
    },
    {
        CITY: 'ENRILE',
        BARANGAY: 'ROMA NORTE',
    },
    {
        CITY: 'ENRILE',
        BARANGAY: 'ROMA SUR',
    },
    {
        CITY: 'ENRILE',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'GATTARAN',
        BARANGAY: 'ABRA',
    },
    {
        CITY: 'GATTARAN',
        BARANGAY: 'AGUIGUICAN',
    },
    {
        CITY: 'GATTARAN',
        BARANGAY: 'BANGATAN NGAGAN',
    },
    {
        CITY: 'GATTARAN',
        BARANGAY: 'BARACAOIT',
    },
    {
        CITY: 'GATTARAN',
        BARANGAY: 'BARAOIDAN',
    },
    {
        CITY: 'GATTARAN',
        BARANGAY: 'BARBARIT',
    },
    {
        CITY: 'GATTARAN',
        BARANGAY: 'BASAO',
    },
    {
        CITY: 'GATTARAN',
        BARANGAY: 'BOLOS POINT',
    },
    {
        CITY: 'GATTARAN',
        BARANGAY: 'CABAYU',
    },
    {
        CITY: 'GATTARAN',
        BARANGAY: 'CALAOAGAN BASSIT',
    },
    {
        CITY: 'GATTARAN',
        BARANGAY: 'CALAOAGAN DACKEL',
    },
    {
        CITY: 'GATTARAN',
        BARANGAY: 'CAPIDDIGAN',
    },
    {
        CITY: 'GATTARAN',
        BARANGAY: 'CAPISSAYAN NORTE',
    },
    {
        CITY: 'GATTARAN',
        BARANGAY: 'CAPISSAYAN SUR',
    },
    {
        CITY: 'GATTARAN',
        BARANGAY: 'CASICALLAN NORTE',
    },
    {
        CITY: 'GATTARAN',
        BARANGAY: 'CASICALLAN SUR',
    },
    {
        CITY: 'GATTARAN',
        BARANGAY: 'CENTRO NORTE (POB.)',
    },
    {
        CITY: 'GATTARAN',
        BARANGAY: 'CENTRO SUR (POB.)',
    },
    {
        CITY: 'GATTARAN',
        BARANGAY: 'CULLIT',
    },
    {
        CITY: 'GATTARAN',
        BARANGAY: 'CUMAO',
    },
    {
        CITY: 'GATTARAN',
        BARANGAY: 'CUNIG',
    },
    {
        CITY: 'GATTARAN',
        BARANGAY: 'DUMMUN',
    },
    {
        CITY: 'GATTARAN',
        BARANGAY: 'FUGU',
    },
    {
        CITY: 'GATTARAN',
        BARANGAY: 'GANZANO',
    },
    {
        CITY: 'GATTARAN',
        BARANGAY: 'GUISING',
    },
    {
        CITY: 'GATTARAN',
        BARANGAY: 'L. ADVIENTO',
    },
    {
        CITY: 'GATTARAN',
        BARANGAY: 'LANGGAN',
    },
    {
        CITY: 'GATTARAN',
        BARANGAY: 'LAPOGAN',
    },
    {
        CITY: 'GATTARAN',
        BARANGAY: 'MABUNO',
    },
    {
        CITY: 'GATTARAN',
        BARANGAY: 'NABACCAYAN',
    },
    {
        CITY: 'GATTARAN',
        BARANGAY: 'NADDUNGAN',
    },
    {
        CITY: 'GATTARAN',
        BARANGAY: 'NAGATUTUAN',
    },
    {
        CITY: 'GATTARAN',
        BARANGAY: 'NASSIPING',
    },
    {
        CITY: 'GATTARAN',
        BARANGAY: 'NEWAGAC',
    },
    {
        CITY: 'GATTARAN',
        BARANGAY: 'PALAGAO NORTE',
    },
    {
        CITY: 'GATTARAN',
        BARANGAY: 'PALAGAO SUR',
    },
    {
        CITY: 'GATTARAN',
        BARANGAY: 'PINA ESTE',
    },
    {
        CITY: 'GATTARAN',
        BARANGAY: 'PINA WESTE',
    },
    {
        CITY: 'GATTARAN',
        BARANGAY: 'SAN CARLOS',
    },
    {
        CITY: 'GATTARAN',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'GATTARAN',
        BARANGAY: 'SANTA ANA',
    },
    {
        CITY: 'GATTARAN',
        BARANGAY: 'SANTA MARIA',
    },
    {
        CITY: 'GATTARAN',
        BARANGAY: 'SIDEM',
    },
    {
        CITY: 'GATTARAN',
        BARANGAY: 'T. ELIZAGA (MABIRBIRA)',
    },
    {
        CITY: 'GATTARAN',
        BARANGAY: 'TAGUMAY',
    },
    {
        CITY: 'GATTARAN',
        BARANGAY: 'TAKIKI',
    },
    {
        CITY: 'GATTARAN',
        BARANGAY: 'TALIGAN',
    },
    {
        CITY: 'GATTARAN',
        BARANGAY: 'TANGLAGAN',
    },
    {
        CITY: 'GATTARAN',
        BARANGAY: 'TUBUNGAN ESTE',
    },
    {
        CITY: 'GATTARAN',
        BARANGAY: 'TUBUNGAN WESTE',
    },
    {
        CITY: 'GONZAGA',
        BARANGAY: 'AMUNITAN',
    },
    {
        CITY: 'GONZAGA',
        BARANGAY: 'BATANGAN',
    },
    {
        CITY: 'GONZAGA',
        BARANGAY: 'BAUA',
    },
    {
        CITY: 'GONZAGA',
        BARANGAY: 'CABANBANAN NORTE',
    },
    {
        CITY: 'GONZAGA',
        BARANGAY: 'CABANBANAN SUR',
    },
    {
        CITY: 'GONZAGA',
        BARANGAY: 'CABIRAOAN',
    },
    {
        CITY: 'GONZAGA',
        BARANGAY: 'CALAYAN',
    },
    {
        CITY: 'GONZAGA',
        BARANGAY: 'CALLAO',
    },
    {
        CITY: 'GONZAGA',
        BARANGAY: 'CAROAN',
    },
    {
        CITY: 'GONZAGA',
        BARANGAY: 'CASITAN',
    },
    {
        CITY: 'GONZAGA',
        BARANGAY: 'FLOURISHING (POB.)',
    },
    {
        CITY: 'GONZAGA',
        BARANGAY: 'IPIL',
    },
    {
        CITY: 'GONZAGA',
        BARANGAY: 'ISCA',
    },
    {
        CITY: 'GONZAGA',
        BARANGAY: 'MAGRAFIL',
    },
    {
        CITY: 'GONZAGA',
        BARANGAY: 'MINANGA',
    },
    {
        CITY: 'GONZAGA',
        BARANGAY: 'PARADISE (POB.)',
    },
    {
        CITY: 'GONZAGA',
        BARANGAY: 'PATENG',
    },
    {
        CITY: 'GONZAGA',
        BARANGAY: 'PROGRESSIVE (POB.)',
    },
    {
        CITY: 'GONZAGA',
        BARANGAY: 'REBECCA (NAGBABALACAN)',
    },
    {
        CITY: 'GONZAGA',
        BARANGAY: 'REBECCA (NAGBABALACAN*)',
    },
    {
        CITY: 'GONZAGA',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'GONZAGA',
        BARANGAY: 'SANTA CLARA',
    },
    {
        CITY: 'GONZAGA',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'GONZAGA',
        BARANGAY: 'SANTA MARIA',
    },
    {
        CITY: 'GONZAGA',
        BARANGAY: 'SMART (POB.)',
    },
    {
        CITY: 'GONZAGA',
        BARANGAY: 'TAPEL',
    },
    {
        CITY: 'IGUIG',
        BARANGAY: 'AJAT (POB.)',
    },
    {
        CITY: 'IGUIG',
        BARANGAY: 'ATULU',
    },
    {
        CITY: 'IGUIG',
        BARANGAY: 'BACULUD',
    },
    {
        CITY: 'IGUIG',
        BARANGAY: 'BAYO',
    },
    {
        CITY: 'IGUIG',
        BARANGAY: 'CAMPO',
    },
    {
        CITY: 'IGUIG',
        BARANGAY: 'DUMPAO',
    },
    {
        CITY: 'IGUIG',
        BARANGAY: 'GAMMAD',
    },
    {
        CITY: 'IGUIG',
        BARANGAY: 'GARAB',
    },
    {
        CITY: 'IGUIG',
        BARANGAY: 'MALABBAC',
    },
    {
        CITY: 'IGUIG',
        BARANGAY: 'MANAOAG (AQUILIQUILAO)',
    },
    {
        CITY: 'IGUIG',
        BARANGAY: 'MINANGA NORTE',
    },
    {
        CITY: 'IGUIG',
        BARANGAY: 'MINANGA SUR',
    },
    {
        CITY: 'IGUIG',
        BARANGAY: 'NATTANZAN (POB.)',
    },
    {
        CITY: 'IGUIG',
        BARANGAY: 'REDONDO',
    },
    {
        CITY: 'IGUIG',
        BARANGAY: 'SALAMAGUE',
    },
    {
        CITY: 'IGUIG',
        BARANGAY: 'SAN ESTEBAN (CAPITAN)',
    },
    {
        CITY: 'IGUIG',
        BARANGAY: 'SAN ISIDRO (UGAC WEST)',
    },
    {
        CITY: 'IGUIG',
        BARANGAY: 'SAN LORENZO',
    },
    {
        CITY: 'IGUIG',
        BARANGAY: 'SAN VICENTE (UGAC EAST)',
    },
    {
        CITY: 'IGUIG',
        BARANGAY: 'SANTA BARBARA',
    },
    {
        CITY: 'IGUIG',
        BARANGAY: 'SANTA ROSA',
    },
    {
        CITY: 'IGUIG',
        BARANGAY: 'SANTA TERESA (GAMMAD SUR)',
    },
    {
        CITY: 'IGUIG',
        BARANGAY: 'SANTIAGO',
    },
    {
        CITY: 'LAL-LO',
        BARANGAY: 'ABAGAO',
    },
    {
        CITY: 'LAL-LO',
        BARANGAY: 'ALAGUIA',
    },
    {
        CITY: 'LAL-LO',
        BARANGAY: 'BAGUMBAYAN',
    },
    {
        CITY: 'LAL-LO',
        BARANGAY: 'BANGAG',
    },
    {
        CITY: 'LAL-LO',
        BARANGAY: 'BICAL',
    },
    {
        CITY: 'LAL-LO',
        BARANGAY: 'BICUD',
    },
    {
        CITY: 'LAL-LO',
        BARANGAY: 'BINAG',
    },
    {
        CITY: 'LAL-LO',
        BARANGAY: 'CABAYABASAN (CAPACUAN)',
    },
    {
        CITY: 'LAL-LO',
        BARANGAY: 'CAGORAN',
    },
    {
        CITY: 'LAL-LO',
        BARANGAY: 'CAMBONG',
    },
    {
        CITY: 'LAL-LO',
        BARANGAY: 'CATAYAUAN',
    },
    {
        CITY: 'LAL-LO',
        BARANGAY: 'CATUGAN',
    },
    {
        CITY: 'LAL-LO',
        BARANGAY: 'CENTRO (POB.)',
    },
    {
        CITY: 'LAL-LO',
        BARANGAY: 'CULLIT',
    },
    {
        CITY: 'LAL-LO',
        BARANGAY: 'DAGUPAN',
    },
    {
        CITY: 'LAL-LO',
        BARANGAY: 'DALAYA',
    },
    {
        CITY: 'LAL-LO',
        BARANGAY: 'FABRICA',
    },
    {
        CITY: 'LAL-LO',
        BARANGAY: 'FUSINA',
    },
    {
        CITY: 'LAL-LO',
        BARANGAY: 'JURISDICTION',
    },
    {
        CITY: 'LAL-LO',
        BARANGAY: 'LALAFUGAN',
    },
    {
        CITY: 'LAL-LO',
        BARANGAY: 'LOGAC',
    },
    {
        CITY: 'LAL-LO',
        BARANGAY: 'MAGALLUNGON (STA. TERESA)',
    },
    {
        CITY: 'LAL-LO',
        BARANGAY: 'MAGALLUNGON (STA. TERESA*)',
    },
    {
        CITY: 'LAL-LO',
        BARANGAY: 'MAGAPIT',
    },
    {
        CITY: 'LAL-LO',
        BARANGAY: 'MALANAO',
    },
    {
        CITY: 'LAL-LO',
        BARANGAY: 'MAXINGAL',
    },
    {
        CITY: 'LAL-LO',
        BARANGAY: 'NAGUILIAN',
    },
    {
        CITY: 'LAL-LO',
        BARANGAY: 'PARANUM',
    },
    {
        CITY: 'LAL-LO',
        BARANGAY: 'ROSARIO',
    },
    {
        CITY: 'LAL-LO',
        BARANGAY: 'SAN ANTONIO (LAFU)',
    },
    {
        CITY: 'LAL-LO',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'LAL-LO',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'LAL-LO',
        BARANGAY: 'SAN LORENZO',
    },
    {
        CITY: 'LAL-LO',
        BARANGAY: 'SAN MARIANO',
    },
    {
        CITY: 'LAL-LO',
        BARANGAY: 'SANTA MARIA',
    },
    {
        CITY: 'LAL-LO',
        BARANGAY: 'TUCALANA',
    },
    {
        CITY: 'LASAM',
        BARANGAY: 'AGGUNETAN',
    },
    {
        CITY: 'LASAM',
        BARANGAY: 'ALANNAY',
    },
    {
        CITY: 'LASAM',
        BARANGAY: 'BATTALAN',
    },
    {
        CITY: 'LASAM',
        BARANGAY: 'CABATACAN EAST (DULDUGAN)',
    },
    {
        CITY: 'LASAM',
        BARANGAY: 'CABATACAN EAST (DULDUGAN*)',
    },
    {
        CITY: 'LASAM',
        BARANGAY: 'CABATACAN WEST',
    },
    {
        CITY: 'LASAM',
        BARANGAY: 'CALAPANGAN NORTE',
    },
    {
        CITY: 'LASAM',
        BARANGAY: 'CALAPANGAN SUR',
    },
    {
        CITY: 'LASAM',
        BARANGAY: 'CALLAO NORTE',
    },
    {
        CITY: 'LASAM',
        BARANGAY: 'CALLAO SUR',
    },
    {
        CITY: 'LASAM',
        BARANGAY: 'CATALIGANAN',
    },
    {
        CITY: 'LASAM',
        BARANGAY: 'CENTRO I (POB.)',
    },
    {
        CITY: 'LASAM',
        BARANGAY: 'CENTRO II (POB.)',
    },
    {
        CITY: 'LASAM',
        BARANGAY: 'CENTRO III (POB.)',
    },
    {
        CITY: 'LASAM',
        BARANGAY: 'FINUGO NORTE',
    },
    {
        CITY: 'LASAM',
        BARANGAY: 'GABUN',
    },
    {
        CITY: 'LASAM',
        BARANGAY: 'IGNACIO JURADO (FINUGU SUR)',
    },
    {
        CITY: 'LASAM',
        BARANGAY: 'MAGSAYSAY',
    },
    {
        CITY: 'LASAM',
        BARANGAY: 'MALINTA',
    },
    {
        CITY: 'LASAM',
        BARANGAY: 'MINANGA NORTE',
    },
    {
        CITY: 'LASAM',
        BARANGAY: 'MINANGA SUR',
    },
    {
        CITY: 'LASAM',
        BARANGAY: 'NABANNAGAN EAST',
    },
    {
        CITY: 'LASAM',
        BARANGAY: 'NABANNAGAN WEST',
    },
    {
        CITY: 'LASAM',
        BARANGAY: 'NEW ORLINS',
    },
    {
        CITY: 'LASAM',
        BARANGAY: 'NICOLAS AGATEP',
    },
    {
        CITY: 'LASAM',
        BARANGAY: 'PERU',
    },
    {
        CITY: 'LASAM',
        BARANGAY: 'SAN PEDRO',
    },
    {
        CITY: 'LASAM',
        BARANGAY: 'SICALAO',
    },
    {
        CITY: 'LASAM',
        BARANGAY: 'TAGAO',
    },
    {
        CITY: 'LASAM',
        BARANGAY: 'TUCALAN PASSING',
    },
    {
        CITY: 'LASAM',
        BARANGAY: 'VIGA',
    },
    {
        CITY: 'PENABLANCA',
        BARANGAY: 'AGGUGADDAN',
    },
    {
        CITY: 'PENABLANCA',
        BARANGAY: 'ALIMANAO',
    },
    {
        CITY: 'PENABLANCA',
        BARANGAY: 'BALIUAG',
    },
    {
        CITY: 'PENABLANCA',
        BARANGAY: 'BICAL',
    },
    {
        CITY: 'PENABLANCA',
        BARANGAY: 'BUGATAY',
    },
    {
        CITY: 'PENABLANCA',
        BARANGAY: 'BUYUN',
    },
    {
        CITY: 'PENABLANCA',
        BARANGAY: 'CABASAN',
    },
    {
        CITY: 'PENABLANCA',
        BARANGAY: 'CABBO',
    },
    {
        CITY: 'PENABLANCA',
        BARANGAY: 'CALLAO',
    },
    {
        CITY: 'PENABLANCA',
        BARANGAY: 'CAMASI',
    },
    {
        CITY: 'PENABLANCA',
        BARANGAY: 'CENTRO (POB.)',
    },
    {
        CITY: 'PENABLANCA',
        BARANGAY: 'DODAN',
    },
    {
        CITY: 'PENABLANCA',
        BARANGAY: 'LAPI',
    },
    {
        CITY: 'PENABLANCA',
        BARANGAY: 'MALIBABAG',
    },
    {
        CITY: 'PENABLANCA',
        BARANGAY: 'MANGA',
    },
    {
        CITY: 'PENABLANCA',
        BARANGAY: 'MINANGA',
    },
    {
        CITY: 'PENABLANCA',
        BARANGAY: 'NABBABALAYAN',
    },
    {
        CITY: 'PENABLANCA',
        BARANGAY: 'NANGUILATTAN',
    },
    {
        CITY: 'PENABLANCA',
        BARANGAY: 'NANNARIAN',
    },
    {
        CITY: 'PENABLANCA',
        BARANGAY: 'PARABBA',
    },
    {
        CITY: 'PENABLANCA',
        BARANGAY: 'PATAGUELEG',
    },
    {
        CITY: 'PENABLANCA',
        BARANGAY: 'QUIBAL',
    },
    {
        CITY: 'PENABLANCA',
        BARANGAY: 'SAN ROQUE (LITTO)',
    },
    {
        CITY: 'PENABLANCA',
        BARANGAY: 'SISIM',
    },
    {
        CITY: 'PIAT',
        BARANGAY: 'APAYAO',
    },
    {
        CITY: 'PIAT',
        BARANGAY: 'AQUIB',
    },
    {
        CITY: 'PIAT',
        BARANGAY: 'BAUNG',
    },
    {
        CITY: 'PIAT',
        BARANGAY: 'CALAOAGAN',
    },
    {
        CITY: 'PIAT',
        BARANGAY: 'CATARAUAN',
    },
    {
        CITY: 'PIAT',
        BARANGAY: 'DUGAYUNG',
    },
    {
        CITY: 'PIAT',
        BARANGAY: 'GUMARUENG',
    },
    {
        CITY: 'PIAT',
        BARANGAY: 'MACAPIL',
    },
    {
        CITY: 'PIAT',
        BARANGAY: 'MAGUILLING',
    },
    {
        CITY: 'PIAT',
        BARANGAY: 'MINANGA',
    },
    {
        CITY: 'PIAT',
        BARANGAY: 'POBLACION I',
    },
    {
        CITY: 'PIAT',
        BARANGAY: 'POBLACION II',
    },
    {
        CITY: 'PIAT',
        BARANGAY: 'SANTA BARBARA',
    },
    {
        CITY: 'PIAT',
        BARANGAY: 'SANTO DOMINGO',
    },
    {
        CITY: 'PIAT',
        BARANGAY: 'SICATNA',
    },
    {
        CITY: 'PIAT',
        BARANGAY: 'VILLA REY (SAN GASPAR)',
    },
    {
        CITY: 'PIAT',
        BARANGAY: 'VILLA REY (SAN GASPAR*)',
    },
    {
        CITY: 'PIAT',
        BARANGAY: 'VILLA REYNO',
    },
    {
        CITY: 'PIAT',
        BARANGAY: 'WARAT',
    },
    {
        CITY: 'SANCHEZ-MIRA',
        BARANGAY: 'BANGAN',
    },
    {
        CITY: 'SANCHEZ-MIRA',
        BARANGAY: 'CALLUNGAN',
    },
    {
        CITY: 'SANCHEZ-MIRA',
        BARANGAY: 'CENTRO I (POB.)',
    },
    {
        CITY: 'SANCHEZ-MIRA',
        BARANGAY: 'CENTRO II (POB.)',
    },
    {
        CITY: 'SANCHEZ-MIRA',
        BARANGAY: 'DACAL',
    },
    {
        CITY: 'SANCHEZ-MIRA',
        BARANGAY: 'DAGUERAY',
    },
    {
        CITY: 'SANCHEZ-MIRA',
        BARANGAY: 'DAMMANG',
    },
    {
        CITY: 'SANCHEZ-MIRA',
        BARANGAY: 'KITTAG',
    },
    {
        CITY: 'SANCHEZ-MIRA',
        BARANGAY: 'LANGAGAN',
    },
    {
        CITY: 'SANCHEZ-MIRA',
        BARANGAY: 'MAGACAN',
    },
    {
        CITY: 'SANCHEZ-MIRA',
        BARANGAY: 'MARZAN',
    },
    {
        CITY: 'SANCHEZ-MIRA',
        BARANGAY: 'MASISIT',
    },
    {
        CITY: 'SANCHEZ-MIRA',
        BARANGAY: 'NAGRANGTAYAN',
    },
    {
        CITY: 'SANCHEZ-MIRA',
        BARANGAY: 'NAMUAC',
    },
    {
        CITY: 'SANCHEZ-MIRA',
        BARANGAY: 'SAN ANDRES',
    },
    {
        CITY: 'SANCHEZ-MIRA',
        BARANGAY: 'SANTIAGO',
    },
    {
        CITY: 'SANCHEZ-MIRA',
        BARANGAY: 'SANTOR',
    },
    {
        CITY: 'SANCHEZ-MIRA',
        BARANGAY: 'TOKITOK',
    },
    {
        CITY: 'SANTA-PRAXEDES',
        BARANGAY: 'CADONGDONGAN',
    },
    {
        CITY: 'SANTA-PRAXEDES',
        BARANGAY: 'CAPACUAN',
    },
    {
        CITY: 'SANTA-PRAXEDES',
        BARANGAY: 'CENTRO I (POB.)',
    },
    {
        CITY: 'SANTA-PRAXEDES',
        BARANGAY: 'CENTRO II (POB.)',
    },
    {
        CITY: 'SANTA-PRAXEDES',
        BARANGAY: 'MACATEL',
    },
    {
        CITY: 'SANTA-PRAXEDES',
        BARANGAY: 'PORTABAGA',
    },
    {
        CITY: 'SANTA-PRAXEDES',
        BARANGAY: 'SALUNGSONG',
    },
    {
        CITY: 'SANTA-PRAXEDES',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'SANTA-PRAXEDES',
        BARANGAY: 'SAN MIGUEL',
    },
    {
        CITY: 'SANTA-PRAXEDES',
        BARANGAY: 'SICUL',
    },
    {
        CITY: 'SOLANA',
        BARANGAY: 'ANDARAYAN NORTH',
    },
    {
        CITY: 'SOLANA',
        BARANGAY: 'ANDARAYAN SOUTH',
    },
    {
        CITY: 'SOLANA',
        BARANGAY: 'BANGAG',
    },
    {
        CITY: 'SOLANA',
        BARANGAY: 'BANTAY',
    },
    {
        CITY: 'SOLANA',
        BARANGAY: 'BASI EAST',
    },
    {
        CITY: 'SOLANA',
        BARANGAY: 'BASI WEST',
    },
    {
        CITY: 'SOLANA',
        BARANGAY: 'BAUAN EAST',
    },
    {
        CITY: 'SOLANA',
        BARANGAY: 'BAUAN WEST',
    },
    {
        CITY: 'SOLANA',
        BARANGAY: 'CADAANAN',
    },
    {
        CITY: 'SOLANA',
        BARANGAY: 'CALAMAGUI',
    },
    {
        CITY: 'SOLANA',
        BARANGAY: 'CALILLAUAN',
    },
    {
        CITY: 'SOLANA',
        BARANGAY: 'CARILUCUD',
    },
    {
        CITY: 'SOLANA',
        BARANGAY: 'CATTARAN',
    },
    {
        CITY: 'SOLANA',
        BARANGAY: 'CENTRO NORTHEAST (POB.)',
    },
    {
        CITY: 'SOLANA',
        BARANGAY: 'CENTRO NORTHWEST (POB.)',
    },
    {
        CITY: 'SOLANA',
        BARANGAY: 'CENTRO SOUTHEAST (POB.)',
    },
    {
        CITY: 'SOLANA',
        BARANGAY: 'CENTRO SOUTHWEST (POB.)',
    },
    {
        CITY: 'SOLANA',
        BARANGAY: 'DASSUN',
    },
    {
        CITY: 'SOLANA',
        BARANGAY: 'FURAGUI',
    },
    {
        CITY: 'SOLANA',
        BARANGAY: 'GADU',
    },
    {
        CITY: 'SOLANA',
        BARANGAY: 'GEN. EULOGIO BALAO',
    },
    {
        CITY: 'SOLANA',
        BARANGAY: 'IRAGA',
    },
    {
        CITY: 'SOLANA',
        BARANGAY: 'LANNA',
    },
    {
        CITY: 'SOLANA',
        BARANGAY: 'LANNIG',
    },
    {
        CITY: 'SOLANA',
        BARANGAY: 'LINGU',
    },
    {
        CITY: 'SOLANA',
        BARANGAY: 'MADDARULUG (SANTO DOMINGO)',
    },
    {
        CITY: 'SOLANA',
        BARANGAY: 'MAGUIRIG',
    },
    {
        CITY: 'SOLANA',
        BARANGAY: 'MALALAM-MALACABIBI',
    },
    {
        CITY: 'SOLANA',
        BARANGAY: 'NABBOTUAN',
    },
    {
        CITY: 'SOLANA',
        BARANGAY: 'NANGALISAN',
    },
    {
        CITY: 'SOLANA',
        BARANGAY: 'NATAPPIAN EAST',
    },
    {
        CITY: 'SOLANA',
        BARANGAY: 'NATAPPIAN WEST',
    },
    {
        CITY: 'SOLANA',
        BARANGAY: 'PADUL',
    },
    {
        CITY: 'SOLANA',
        BARANGAY: 'PALAO',
    },
    {
        CITY: 'SOLANA',
        BARANGAY: 'PARUG-PARUG',
    },
    {
        CITY: 'SOLANA',
        BARANGAY: 'PATAYA',
    },
    {
        CITY: 'SOLANA',
        BARANGAY: 'SAMPAGUITA',
    },
    {
        CITY: 'SOLANA',
        BARANGAY: 'UBONG',
    },
    {
        CITY: 'TUAO',
        BARANGAY: 'ACCUSILIAN',
    },
    {
        CITY: 'TUAO',
        BARANGAY: 'ALABIAO',
    },
    {
        CITY: 'TUAO',
        BARANGAY: 'ALABUG',
    },
    {
        CITY: 'TUAO',
        BARANGAY: 'ANGANG',
    },
    {
        CITY: 'TUAO',
        BARANGAY: 'BAGUMBAYAN',
    },
    {
        CITY: 'TUAO',
        BARANGAY: 'BALAGAO',
    },
    {
        CITY: 'TUAO',
        BARANGAY: 'BARANCUAG',
    },
    {
        CITY: 'TUAO',
        BARANGAY: 'BATTUNG',
    },
    {
        CITY: 'TUAO',
        BARANGAY: 'BICOK',
    },
    {
        CITY: 'TUAO',
        BARANGAY: 'BUGNAY',
    },
    {
        CITY: 'TUAO',
        BARANGAY: 'CAGUMITAN',
    },
    {
        CITY: 'TUAO',
        BARANGAY: 'CATO',
    },
    {
        CITY: 'TUAO',
        BARANGAY: 'CULONG',
    },
    {
        CITY: 'TUAO',
        BARANGAY: 'DAGUPAN',
    },
    {
        CITY: 'TUAO',
        BARANGAY: 'FUGU',
    },
    {
        CITY: 'TUAO',
        BARANGAY: 'LAKAMBINI',
    },
    {
        CITY: 'TUAO',
        BARANGAY: 'LALLAYUG',
    },
    {
        CITY: 'TUAO',
        BARANGAY: 'MALALINTA',
    },
    {
        CITY: 'TUAO',
        BARANGAY: 'MALUMIN',
    },
    {
        CITY: 'TUAO',
        BARANGAY: 'MAMBACAG',
    },
    {
        CITY: 'TUAO',
        BARANGAY: 'MUNGO',
    },
    {
        CITY: 'TUAO',
        BARANGAY: 'NARUANGAN',
    },
    {
        CITY: 'TUAO',
        BARANGAY: 'PALCA',
    },
    {
        CITY: 'TUAO',
        BARANGAY: 'PATA',
    },
    {
        CITY: 'TUAO',
        BARANGAY: 'POBLACION I (WARD I CENTRO)',
    },
    {
        CITY: 'TUAO',
        BARANGAY: 'POBLACION II (WARD II CENTRO)',
    },
    {
        CITY: 'TUAO',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'TUAO',
        BARANGAY: 'SAN LUIS (GURENGAD)',
    },
    {
        CITY: 'TUAO',
        BARANGAY: 'SAN VICENTE (MALEG)',
    },
    {
        CITY: 'TUAO',
        BARANGAY: 'SANTO TOMAS',
    },
    {
        CITY: 'TUAO',
        BARANGAY: 'TARIBUBU',
    },
    {
        CITY: 'TUAO',
        BARANGAY: 'VILLA LAIDA',
    },
    {
        CITY: 'TUGUEGARAO',
        BARANGAY: 'ANNAFUNAN EAST',
    },
    {
        CITY: 'TUGUEGARAO',
        BARANGAY: 'ANNAFUNAN WEST',
    },
    {
        CITY: 'TUGUEGARAO',
        BARANGAY: 'ATULAYAN NORTE',
    },
    {
        CITY: 'TUGUEGARAO',
        BARANGAY: 'ATULAYAN SUR',
    },
    {
        CITY: 'TUGUEGARAO',
        BARANGAY: 'BAGAY',
    },
    {
        CITY: 'TUGUEGARAO',
        BARANGAY: 'BUNTUN',
    },
    {
        CITY: 'TUGUEGARAO',
        BARANGAY: 'CAGGAY',
    },
    {
        CITY: 'TUGUEGARAO',
        BARANGAY: 'CAPATAN',
    },
    {
        CITY: 'TUGUEGARAO',
        BARANGAY: 'CARIG',
    },
    {
        CITY: 'TUGUEGARAO',
        BARANGAY: 'CARITAN CENTRO',
    },
    {
        CITY: 'TUGUEGARAO',
        BARANGAY: 'CARITAN NORTE',
    },
    {
        CITY: 'TUGUEGARAO',
        BARANGAY: 'CARITAN SUR',
    },
    {
        CITY: 'TUGUEGARAO',
        BARANGAY: 'CATAGGAMAN NUEVO',
    },
    {
        CITY: 'TUGUEGARAO',
        BARANGAY: 'CATAGGAMAN PARDO',
    },
    {
        CITY: 'TUGUEGARAO',
        BARANGAY: 'CATAGGAMAN VIEJO',
    },
    {
        CITY: 'TUGUEGARAO',
        BARANGAY: 'CENTRO 1 (POB.)',
    },
    {
        CITY: 'TUGUEGARAO',
        BARANGAY: 'CENTRO 10 (POB.)',
    },
    {
        CITY: 'TUGUEGARAO',
        BARANGAY: 'CENTRO 11 (POB.)',
    },
    {
        CITY: 'TUGUEGARAO',
        BARANGAY: 'CENTRO 12 (POB.)',
    },
    {
        CITY: 'TUGUEGARAO',
        BARANGAY: 'CENTRO 2 (POB.)',
    },
    {
        CITY: 'TUGUEGARAO',
        BARANGAY: 'CENTRO 3 (POB.)',
    },
    {
        CITY: 'TUGUEGARAO',
        BARANGAY: 'CENTRO 4 (POB.)',
    },
    {
        CITY: 'TUGUEGARAO',
        BARANGAY: 'CENTRO 5 (POB.)',
    },
    {
        CITY: 'TUGUEGARAO',
        BARANGAY: 'CENTRO 6 (POB.)',
    },
    {
        CITY: 'TUGUEGARAO',
        BARANGAY: 'CENTRO 7 (POB.)',
    },
    {
        CITY: 'TUGUEGARAO',
        BARANGAY: 'CENTRO 8 (POB.)',
    },
    {
        CITY: 'TUGUEGARAO',
        BARANGAY: 'CENTRO 9 (POB.)',
    },
    {
        CITY: 'TUGUEGARAO',
        BARANGAY: 'DADDA',
    },
    {
        CITY: 'TUGUEGARAO',
        BARANGAY: 'GOSI NORTE',
    },
    {
        CITY: 'TUGUEGARAO',
        BARANGAY: 'GOSI SUR',
    },
    {
        CITY: 'TUGUEGARAO',
        BARANGAY: 'LARION ALTO',
    },
    {
        CITY: 'TUGUEGARAO',
        BARANGAY: 'LARION BAJO',
    },
    {
        CITY: 'TUGUEGARAO',
        BARANGAY: 'LEONARDA',
    },
    {
        CITY: 'TUGUEGARAO',
        BARANGAY: 'LIBAG NORTE',
    },
    {
        CITY: 'TUGUEGARAO',
        BARANGAY: 'LIBAG SUR',
    },
    {
        CITY: 'TUGUEGARAO',
        BARANGAY: 'LINAO EAST',
    },
    {
        CITY: 'TUGUEGARAO',
        BARANGAY: 'LINAO NORTE',
    },
    {
        CITY: 'TUGUEGARAO',
        BARANGAY: 'LINAO WEST',
    },
    {
        CITY: 'TUGUEGARAO',
        BARANGAY: 'NAMBBALAN NORTE',
    },
    {
        CITY: 'TUGUEGARAO',
        BARANGAY: 'NAMBBALAN SUR',
    },
    {
        CITY: 'TUGUEGARAO',
        BARANGAY: 'PALLUA NORTE',
    },
    {
        CITY: 'TUGUEGARAO',
        BARANGAY: 'PALLUA SUR',
    },
    {
        CITY: 'TUGUEGARAO',
        BARANGAY: 'PENGUE (PENGUE-RUYU)',
    },
    {
        CITY: 'TUGUEGARAO',
        BARANGAY: 'REYES',
    },
    {
        CITY: 'TUGUEGARAO',
        BARANGAY: 'SAN GABRIEL',
    },
    {
        CITY: 'TUGUEGARAO',
        BARANGAY: 'TAGGA',
    },
    {
        CITY: 'TUGUEGARAO',
        BARANGAY: 'TANZA',
    },
    {
        CITY: 'TUGUEGARAO',
        BARANGAY: 'UGAC NORTE',
    },
    {
        CITY: 'TUGUEGARAO',
        BARANGAY: 'UGAC SUR',
    },
    {
        CITY: 'AGLIPAY',
        BARANGAY: 'ALICIA',
    },
    {
        CITY: 'AGLIPAY',
        BARANGAY: 'CABUGAO',
    },
    {
        CITY: 'AGLIPAY',
        BARANGAY: 'DAGUPAN',
    },
    {
        CITY: 'AGLIPAY',
        BARANGAY: 'DIODOL',
    },
    {
        CITY: 'AGLIPAY',
        BARANGAY: 'DUMABEL',
    },
    {
        CITY: 'AGLIPAY',
        BARANGAY: 'DUNGO (OSMENA)',
    },
    {
        CITY: 'AGLIPAY',
        BARANGAY: 'GUINALBIN',
    },
    {
        CITY: 'AGLIPAY',
        BARANGAY: 'LIGAYA',
    },
    {
        CITY: 'AGLIPAY',
        BARANGAY: 'NAGABGABAN',
    },
    {
        CITY: 'AGLIPAY',
        BARANGAY: 'PALACIAN',
    },
    {
        CITY: 'AGLIPAY',
        BARANGAY: 'PINARIPAD NORTE',
    },
    {
        CITY: 'AGLIPAY',
        BARANGAY: 'PINARIPAD SUR',
    },
    {
        CITY: 'AGLIPAY',
        BARANGAY: 'PROGRESO (POB.)',
    },
    {
        CITY: 'AGLIPAY',
        BARANGAY: 'RAMOS',
    },
    {
        CITY: 'AGLIPAY',
        BARANGAY: 'RANG-AYAN',
    },
    {
        CITY: 'AGLIPAY',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'AGLIPAY',
        BARANGAY: 'SAN BENIGNO',
    },
    {
        CITY: 'AGLIPAY',
        BARANGAY: 'SAN FRANCISCO',
    },
    {
        CITY: 'AGLIPAY',
        BARANGAY: 'SAN LEONARDO (CABARROGUIS)',
    },
    {
        CITY: 'AGLIPAY',
        BARANGAY: 'SAN MANUEL',
    },
    {
        CITY: 'AGLIPAY',
        BARANGAY: 'SAN RAMON',
    },
    {
        CITY: 'AGLIPAY',
        BARANGAY: 'VICTORIA',
    },
    {
        CITY: 'AGLIPAY',
        BARANGAY: 'VILLA PAGADUAN',
    },
    {
        CITY: 'AGLIPAY',
        BARANGAY: 'VILLA SANTIAGO',
    },
    {
        CITY: 'AGLIPAY',
        BARANGAY: 'VILLA VENTURA',
    },
    {
        CITY: 'CABARROGUIS',
        BARANGAY: 'BANUAR',
    },
    {
        CITY: 'CABARROGUIS',
        BARANGAY: 'BURGOS',
    },
    {
        CITY: 'CABARROGUIS',
        BARANGAY: 'CALAOCAN',
    },
    {
        CITY: 'CABARROGUIS',
        BARANGAY: 'DEL PILAR',
    },
    {
        CITY: 'CABARROGUIS',
        BARANGAY: 'DIBIBI',
    },
    {
        CITY: 'CABARROGUIS',
        BARANGAY: 'DINGASAN',
    },
    {
        CITY: 'CABARROGUIS',
        BARANGAY: 'EDEN',
    },
    {
        CITY: 'CABARROGUIS',
        BARANGAY: 'GOMEZ',
    },
    {
        CITY: 'CABARROGUIS',
        BARANGAY: 'GUNDAWAY (POB.)',
    },
    {
        CITY: 'CABARROGUIS',
        BARANGAY: 'MANGANDINGAY (POB.)',
    },
    {
        CITY: 'CABARROGUIS',
        BARANGAY: 'SAN MARCOS',
    },
    {
        CITY: 'CABARROGUIS',
        BARANGAY: 'SANTO DOMINGO',
    },
    {
        CITY: 'CABARROGUIS',
        BARANGAY: 'TUCOD',
    },
    {
        CITY: 'CABARROGUIS',
        BARANGAY: 'VILLA PENA (CAPELLANGAN)',
    },
    {
        CITY: 'CABARROGUIS',
        BARANGAY: 'VILLAMOR',
    },
    {
        CITY: 'CABARROGUIS',
        BARANGAY: 'VILLAROSE',
    },
    {
        CITY: 'CABARROGUIS',
        BARANGAY: 'ZAMORA',
    },
    {
        CITY: 'DIFFUN',
        BARANGAY: 'AKLAN VILLAGE',
    },
    {
        CITY: 'DIFFUN',
        BARANGAY: 'ANDRES BONIFACIO (POB.)',
    },
    {
        CITY: 'DIFFUN',
        BARANGAY: 'AURORA EAST (POB.)',
    },
    {
        CITY: 'DIFFUN',
        BARANGAY: 'AURORA WEST (POB.)',
    },
    {
        CITY: 'DIFFUN',
        BARANGAY: 'BAGUIO VILLAGE',
    },
    {
        CITY: 'DIFFUN',
        BARANGAY: 'BALAGBAG',
    },
    {
        CITY: 'DIFFUN',
        BARANGAY: 'BANNAWAG',
    },
    {
        CITY: 'DIFFUN',
        BARANGAY: 'CAJEL',
    },
    {
        CITY: 'DIFFUN',
        BARANGAY: 'CAMPAMENTO',
    },
    {
        CITY: 'DIFFUN',
        BARANGAY: 'DIEGO SILANG',
    },
    {
        CITY: 'DIFFUN',
        BARANGAY: 'DON FAUSTINO PAGADUAN',
    },
    {
        CITY: 'DIFFUN',
        BARANGAY: 'DON MARIANO PEREZ',
    },
    {
        CITY: 'DIFFUN',
        BARANGAY: 'DON MARIANO PEREZ SR.',
    },
    {
        CITY: 'DIFFUN',
        BARANGAY: 'DONA IMELDA',
    },
    {
        CITY: 'DIFFUN',
        BARANGAY: 'DUMANISI',
    },
    {
        CITY: 'DIFFUN',
        BARANGAY: 'GABRIELA SILANG',
    },
    {
        CITY: 'DIFFUN',
        BARANGAY: 'GREGORIO PIMENTEL',
    },
    {
        CITY: 'DIFFUN',
        BARANGAY: 'GULAC',
    },
    {
        CITY: 'DIFFUN',
        BARANGAY: 'GURIBANG',
    },
    {
        CITY: 'DIFFUN',
        BARANGAY: 'IFUGAO VILLAGE',
    },
    {
        CITY: 'DIFFUN',
        BARANGAY: 'ISIDRO PAREDES',
    },
    {
        CITY: 'DIFFUN',
        BARANGAY: 'LIWAYWAY',
    },
    {
        CITY: 'DIFFUN',
        BARANGAY: 'LUTTUAD',
    },
    {
        CITY: 'DIFFUN',
        BARANGAY: 'MAGSAYSAY',
    },
    {
        CITY: 'DIFFUN',
        BARANGAY: 'MAKATE',
    },
    {
        CITY: 'DIFFUN',
        BARANGAY: 'MARIA CLARA',
    },
    {
        CITY: 'DIFFUN',
        BARANGAY: 'RAFAEL PALMA (DON SERGIO OSMENA)',
    },
    {
        CITY: 'DIFFUN',
        BARANGAY: 'RICARTE NORTE',
    },
    {
        CITY: 'DIFFUN',
        BARANGAY: 'RICARTE SUR',
    },
    {
        CITY: 'DIFFUN',
        BARANGAY: 'RIZAL (POB.)',
    },
    {
        CITY: 'DIFFUN',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'DIFFUN',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'DIFFUN',
        BARANGAY: 'SAN PASCUAL',
    },
    {
        CITY: 'DIFFUN',
        BARANGAY: 'VILLA PASCUA',
    },
    {
        CITY: 'MADDELA',
        BARANGAY: 'ABBAG',
    },
    {
        CITY: 'MADDELA',
        BARANGAY: 'BALLIGUI',
    },
    {
        CITY: 'MADDELA',
        BARANGAY: 'BUENAVISTA',
    },
    {
        CITY: 'MADDELA',
        BARANGAY: 'CABARUAN',
    },
    {
        CITY: 'MADDELA',
        BARANGAY: 'CABUA-AN',
    },
    {
        CITY: 'MADDELA',
        BARANGAY: 'COFCAVILLE',
    },
    {
        CITY: 'MADDELA',
        BARANGAY: 'DIDUYON',
    },
    {
        CITY: 'MADDELA',
        BARANGAY: 'DIPINTIN',
    },
    {
        CITY: 'MADDELA',
        BARANGAY: 'DIVISORIA NORTE',
    },
    {
        CITY: 'MADDELA',
        BARANGAY: 'DIVISORIA SUR (BISANGAL)',
    },
    {
        CITY: 'MADDELA',
        BARANGAY: 'DUMABATO NORTE',
    },
    {
        CITY: 'MADDELA',
        BARANGAY: 'DUMABATO SUR',
    },
    {
        CITY: 'MADDELA',
        BARANGAY: 'JOSE ANCHETA',
    },
    {
        CITY: 'MADDELA',
        BARANGAY: 'LUSOD',
    },
    {
        CITY: 'MADDELA',
        BARANGAY: 'MANGLAD',
    },
    {
        CITY: 'MADDELA',
        BARANGAY: 'PEDLISAN',
    },
    {
        CITY: 'MADDELA',
        BARANGAY: 'POBLACION NORTE',
    },
    {
        CITY: 'MADDELA',
        BARANGAY: 'POBLACION SUR',
    },
    {
        CITY: 'MADDELA',
        BARANGAY: 'SAN BERNABE',
    },
    {
        CITY: 'MADDELA',
        BARANGAY: 'SAN DIONISIO I',
    },
    {
        CITY: 'MADDELA',
        BARANGAY: 'SAN MARTIN',
    },
    {
        CITY: 'MADDELA',
        BARANGAY: 'SAN PEDRO',
    },
    {
        CITY: 'MADDELA',
        BARANGAY: 'SAN SALVADOR',
    },
    {
        CITY: 'MADDELA',
        BARANGAY: 'SANTA MARIA',
    },
    {
        CITY: 'MADDELA',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'MADDELA',
        BARANGAY: 'SANTO TOMAS',
    },
    {
        CITY: 'MADDELA',
        BARANGAY: 'VILLA AGULLANA',
    },
    {
        CITY: 'MADDELA',
        BARANGAY: 'VILLA GRACIA',
    },
    {
        CITY: 'MADDELA',
        BARANGAY: 'VILLA HERMOSA NORTE',
    },
    {
        CITY: 'MADDELA',
        BARANGAY: 'VILLA HERMOSA SUR',
    },
    {
        CITY: 'MADDELA',
        BARANGAY: 'VILLA JOSE V YLANAN',
    },
    {
        CITY: 'MADDELA',
        BARANGAY: 'YSMAEL',
    },
    {
        CITY: 'NAGTIPUNAN',
        BARANGAY: 'ANAK',
    },
    {
        CITY: 'NAGTIPUNAN',
        BARANGAY: 'ASAKLAT',
    },
    {
        CITY: 'NAGTIPUNAN',
        BARANGAY: 'DIPANTAN',
    },
    {
        CITY: 'NAGTIPUNAN',
        BARANGAY: 'DISSIMUNGAL',
    },
    {
        CITY: 'NAGTIPUNAN',
        BARANGAY: 'GUINO (GIAYAN)',
    },
    {
        CITY: 'NAGTIPUNAN',
        BARANGAY: 'LA CONWAP (GUINGIN)',
    },
    {
        CITY: 'NAGTIPUNAN',
        BARANGAY: 'LANDINGAN',
    },
    {
        CITY: 'NAGTIPUNAN',
        BARANGAY: 'MATADDI',
    },
    {
        CITY: 'NAGTIPUNAN',
        BARANGAY: 'MATMAD',
    },
    {
        CITY: 'NAGTIPUNAN',
        BARANGAY: 'OLD GUMIAD',
    },
    {
        CITY: 'NAGTIPUNAN',
        BARANGAY: 'PONGGO',
    },
    {
        CITY: 'NAGTIPUNAN',
        BARANGAY: 'SAN DIONISIO II',
    },
    {
        CITY: 'NAGTIPUNAN',
        BARANGAY: 'SAN PUGO',
    },
    {
        CITY: 'NAGTIPUNAN',
        BARANGAY: 'SAN RAMOS',
    },
    {
        CITY: 'NAGTIPUNAN',
        BARANGAY: 'SANGBAY',
    },
    {
        CITY: 'NAGTIPUNAN',
        BARANGAY: 'WASID',
    },
    {
        CITY: 'SAGUDAY',
        BARANGAY: 'CARDENAS',
    },
    {
        CITY: 'SAGUDAY',
        BARANGAY: 'DIBUL',
    },
    {
        CITY: 'SAGUDAY',
        BARANGAY: 'GAMIS',
    },
    {
        CITY: 'SAGUDAY',
        BARANGAY: 'LA PAZ',
    },
    {
        CITY: 'SAGUDAY',
        BARANGAY: 'MAGSAYSAY (POB.)',
    },
    {
        CITY: 'SAGUDAY',
        BARANGAY: 'RIZAL (POB.)',
    },
    {
        CITY: 'SAGUDAY',
        BARANGAY: 'SALVACION',
    },
    {
        CITY: 'SAGUDAY',
        BARANGAY: 'SANTO TOMAS',
    },
    {
        CITY: 'SAGUDAY',
        BARANGAY: 'TRES REYES',
    },
    {
        CITY: 'ABULUG',
        BARANGAY: 'ALINUNU',
    },
    {
        CITY: 'ABULUG',
        BARANGAY: 'BAGU',
    },
    {
        CITY: 'ABULUG',
        BARANGAY: 'BANGUIAN',
    },
    {
        CITY: 'ABULUG',
        BARANGAY: 'CALOG NORTE',
    },
    {
        CITY: 'ABULUG',
        BARANGAY: 'CALOG SUR',
    },
    {
        CITY: 'ABULUG',
        BARANGAY: 'CANAYUN',
    },
    {
        CITY: 'ABULUG',
        BARANGAY: 'CENTRO (POB.)',
    },
    {
        CITY: 'ABULUG',
        BARANGAY: 'DANA-ILI',
    },
    {
        CITY: 'ABULUG',
        BARANGAY: 'GUIDDAM',
    },
    {
        CITY: 'ABULUG',
        BARANGAY: 'LIBERTAD',
    },
    {
        CITY: 'ABULUG',
        BARANGAY: 'LUCBAN',
    },
    {
        CITY: 'ABULUG',
        BARANGAY: 'PINILI',
    },
    {
        CITY: 'ABULUG',
        BARANGAY: 'SAN AGUSTIN',
    },
    {
        CITY: 'ABULUG',
        BARANGAY: 'SAN JULIAN',
    },
    {
        CITY: 'ABULUG',
        BARANGAY: 'SANTA FILOMENA',
    },
    {
        CITY: 'ABULUG',
        BARANGAY: 'SANTA ROSA',
    },
    {
        CITY: 'ABULUG',
        BARANGAY: 'SANTO TOMAS',
    },
    {
        CITY: 'ABULUG',
        BARANGAY: 'SIGUIRAN',
    },
    {
        CITY: 'ABULUG',
        BARANGAY: 'SIMAYUNG',
    },
    {
        CITY: 'ABULUG',
        BARANGAY: 'SIRIT',
    },
    {
        CITY: 'ALLACAPAN',
        BARANGAY: 'BESSANG',
    },
    {
        CITY: 'ALLACAPAN',
        BARANGAY: 'BINOBONGAN',
    },
    {
        CITY: 'ALLACAPAN',
        BARANGAY: 'BULO',
    },
    {
        CITY: 'ALLACAPAN',
        BARANGAY: 'BUROT',
    },
    {
        CITY: 'ALLACAPAN',
        BARANGAY: 'CAPAGARAN (BRIGIDA)',
    },
    {
        CITY: 'ALLACAPAN',
        BARANGAY: 'CAPALUTAN',
    },
    {
        CITY: 'ALLACAPAN',
        BARANGAY: 'CAPANICKIAN NORTE',
    },
    {
        CITY: 'ALLACAPAN',
        BARANGAY: 'CAPANICKIAN SUR',
    },
    {
        CITY: 'ALLACAPAN',
        BARANGAY: 'CATARATAN',
    },
    {
        CITY: 'ALLACAPAN',
        BARANGAY: 'CENTRO EAST (POB.)',
    },
    {
        CITY: 'ALLACAPAN',
        BARANGAY: 'CENTRO WEST (POB.)',
    },
    {
        CITY: 'ALLACAPAN',
        BARANGAY: 'DAAN-ILI',
    },
    {
        CITY: 'ALLACAPAN',
        BARANGAY: 'DAGUPAN',
    },
    {
        CITY: 'ALLACAPAN',
        BARANGAY: 'DALAYAP',
    },
    {
        CITY: 'ALLACAPAN',
        BARANGAY: 'GAGADDANGAN',
    },
    {
        CITY: 'ALLACAPAN',
        BARANGAY: 'IRINGAN',
    },
    {
        CITY: 'ALLACAPAN',
        BARANGAY: 'LABBEN',
    },
    {
        CITY: 'ALLACAPAN',
        BARANGAY: 'MALUYO',
    },
    {
        CITY: 'ALLACAPAN',
        BARANGAY: 'MAPURAO',
    },
    {
        CITY: 'ALLACAPAN',
        BARANGAY: 'MATUCAY',
    },
    {
        CITY: 'ALLACAPAN',
        BARANGAY: 'NAGATTATAN',
    },
    {
        CITY: 'ALLACAPAN',
        BARANGAY: 'PACAC',
    },
    {
        CITY: 'ALLACAPAN',
        BARANGAY: 'SAN JUAN (MAGUININANGO)',
    },
    {
        CITY: 'ALLACAPAN',
        BARANGAY: 'SILANGAN',
    },
    {
        CITY: 'ALLACAPAN',
        BARANGAY: 'TAMBOLI',
    },
    {
        CITY: 'ALLACAPAN',
        BARANGAY: 'TUBEL',
    },
    {
        CITY: 'ALLACAPAN',
        BARANGAY: 'UTAN',
    },
    {
        CITY: 'AMULUNG',
        BARANGAY: 'ABOLO',
    },
    {
        CITY: 'AMULUNG',
        BARANGAY: 'AGGUIRIT',
    },
    {
        CITY: 'AMULUNG',
        BARANGAY: 'ALITUNGTUNG',
    },
    {
        CITY: 'AMULUNG',
        BARANGAY: 'ANNABUCULAN',
    },
    {
        CITY: 'AMULUNG',
        BARANGAY: 'ANNAFATAN',
    },
    {
        CITY: 'AMULUNG',
        BARANGAY: 'ANQUIRAY',
    },
    {
        CITY: 'AMULUNG',
        BARANGAY: 'BABAYUAN',
    },
    {
        CITY: 'AMULUNG',
        BARANGAY: 'BACCUIT',
    },
    {
        CITY: 'AMULUNG',
        BARANGAY: 'BACRING',
    },
    {
        CITY: 'AMULUNG',
        BARANGAY: 'BACULUD',
    },
    {
        CITY: 'AMULUNG',
        BARANGAY: 'BALAUINI',
    },
    {
        CITY: 'AMULUNG',
        BARANGAY: 'BAUAN',
    },
    {
        CITY: 'AMULUNG',
        BARANGAY: 'BAYABAT',
    },
    {
        CITY: 'AMULUNG',
        BARANGAY: 'CALAMAGUI',
    },
    {
        CITY: 'AMULUNG',
        BARANGAY: 'CALINTAAN',
    },
    {
        CITY: 'AMULUNG',
        BARANGAY: 'CARATACAT',
    },
    {
        CITY: 'AMULUNG',
        BARANGAY: 'CASINGSINGAN NORTE',
    },
    {
        CITY: 'AMULUNG',
        BARANGAY: 'CASINGSINGAN SUR',
    },
    {
        CITY: 'AMULUNG',
        BARANGAY: 'CATARAUAN',
    },
    {
        CITY: 'AMULUNG',
        BARANGAY: 'CENTRO',
    },
    {
        CITY: 'AMULUNG',
        BARANGAY: 'CONCEPCION',
    },
    {
        CITY: 'AMULUNG',
        BARANGAY: 'CORDOVA',
    },
    {
        CITY: 'AMULUNG',
        BARANGAY: 'DADDA',
    },
    {
        CITY: 'AMULUNG',
        BARANGAY: 'DAFUNGANAY',
    },
    {
        CITY: 'AMULUNG',
        BARANGAY: 'DUGAYUNG',
    },
    {
        CITY: 'AMULUNG',
        BARANGAY: 'ESTEFANIA',
    },
    {
        CITY: 'AMULUNG',
        BARANGAY: 'GABUT',
    },
    {
        CITY: 'AMULUNG',
        BARANGAY: 'GANGAUAN',
    },
    {
        CITY: 'AMULUNG',
        BARANGAY: 'GORAN',
    },
    {
        CITY: 'AMULUNG',
        BARANGAY: 'JURISDICCION',
    },
    {
        CITY: 'AMULUNG',
        BARANGAY: 'LA SUERTE',
    },
    {
        CITY: 'AMULUNG',
        BARANGAY: 'LOGUNG',
    },
    {
        CITY: 'AMULUNG',
        BARANGAY: 'MAGOGOD',
    },
    {
        CITY: 'AMULUNG',
        BARANGAY: 'MANALO',
    },
    {
        CITY: 'AMULUNG',
        BARANGAY: 'MAROBBOB',
    },
    {
        CITY: 'AMULUNG',
        BARANGAY: 'MASICAL',
    },
    {
        CITY: 'AMULUNG',
        BARANGAY: 'MONTE ALEGRE',
    },
    {
        CITY: 'AMULUNG',
        BARANGAY: 'NABBIALAN',
    },
    {
        CITY: 'AMULUNG',
        BARANGAY: 'NAGSABARAN',
    },
    {
        CITY: 'AMULUNG',
        BARANGAY: 'NANGALASAUAN',
    },
    {
        CITY: 'AMULUNG',
        BARANGAY: 'NANUCCAUAN',
    },
    {
        CITY: 'AMULUNG',
        BARANGAY: 'PACAC-GRANDE',
    },
    {
        CITY: 'AMULUNG',
        BARANGAY: 'PACAC-PEQUENO',
    },
    {
        CITY: 'AMULUNG',
        BARANGAY: 'PALACU',
    },
    {
        CITY: 'AMULUNG',
        BARANGAY: 'PALAYAG',
    },
    {
        CITY: 'AMULUNG',
        BARANGAY: 'TANA',
    },
    {
        CITY: 'AMULUNG',
        BARANGAY: 'UNAG',
    },
    {
        CITY: 'APARRI',
        BARANGAY: 'BACKILING',
    },
    {
        CITY: 'APARRI',
        BARANGAY: 'BANGAG',
    },
    {
        CITY: 'APARRI',
        BARANGAY: 'BINALAN',
    },
    {
        CITY: 'APARRI',
        BARANGAY: 'BISAGU',
    },
    {
        CITY: 'APARRI',
        BARANGAY: 'BUKIG',
    },
    {
        CITY: 'APARRI',
        BARANGAY: 'BULALA NORTE',
    },
    {
        CITY: 'APARRI',
        BARANGAY: 'BULALA SUR',
    },
    {
        CITY: 'APARRI',
        BARANGAY: 'CAAGAMAN',
    },
    {
        CITY: 'APARRI',
        BARANGAY: 'CENTRO 1 (POB.)',
    },
    {
        CITY: 'APARRI',
        BARANGAY: 'CENTRO 10 (POB.)',
    },
    {
        CITY: 'APARRI',
        BARANGAY: 'CENTRO 11 (POB.)',
    },
    {
        CITY: 'APARRI',
        BARANGAY: 'CENTRO 12 (POB.)',
    },
    {
        CITY: 'APARRI',
        BARANGAY: 'CENTRO 13 (POB.)',
    },
    {
        CITY: 'APARRI',
        BARANGAY: 'CENTRO 14 (POB.)',
    },
    {
        CITY: 'APARRI',
        BARANGAY: 'CENTRO 15 (POB.)',
    },
    {
        CITY: 'APARRI',
        BARANGAY: 'CENTRO 2 (POB.)',
    },
    {
        CITY: 'APARRI',
        BARANGAY: 'CENTRO 3 (POB.)',
    },
    {
        CITY: 'APARRI',
        BARANGAY: 'CENTRO 4 (POB.)',
    },
    {
        CITY: 'APARRI',
        BARANGAY: 'CENTRO 5 (POB.)',
    },
    {
        CITY: 'APARRI',
        BARANGAY: 'CENTRO 6 (POB.)',
    },
    {
        CITY: 'APARRI',
        BARANGAY: 'CENTRO 7 (POB.)',
    },
    {
        CITY: 'APARRI',
        BARANGAY: 'CENTRO 8 (POB.)',
    },
    {
        CITY: 'APARRI',
        BARANGAY: 'CENTRO 9 (POB.)',
    },
    {
        CITY: 'APARRI',
        BARANGAY: 'DODAN',
    },
    {
        CITY: 'APARRI',
        BARANGAY: 'FUGA ISLAND',
    },
    {
        CITY: 'APARRI',
        BARANGAY: 'GADDANG',
    },
    {
        CITY: 'APARRI',
        BARANGAY: 'LINAO',
    },
    {
        CITY: 'APARRI',
        BARANGAY: 'MABANGUC',
    },
    {
        CITY: 'APARRI',
        BARANGAY: 'MACANAYA (PESCARIA)',
    },
    {
        CITY: 'APARRI',
        BARANGAY: 'MAURA',
    },
    {
        CITY: 'APARRI',
        BARANGAY: 'MINANGA',
    },
    {
        CITY: 'APARRI',
        BARANGAY: 'NAVAGAN',
    },
    {
        CITY: 'APARRI',
        BARANGAY: 'PADDAYA',
    },
    {
        CITY: 'APARRI',
        BARANGAY: 'PARUDDUN NORTE',
    },
    {
        CITY: 'APARRI',
        BARANGAY: 'PARUDDUN SUR',
    },
    {
        CITY: 'APARRI',
        BARANGAY: 'PLAZA',
    },
    {
        CITY: 'APARRI',
        BARANGAY: 'PUNTA',
    },
    {
        CITY: 'APARRI',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'APARRI',
        BARANGAY: 'SANJA',
    },
    {
        CITY: 'APARRI',
        BARANGAY: 'TALLUNGAN',
    },
    {
        CITY: 'APARRI',
        BARANGAY: 'TORAN',
    },
    {
        CITY: 'APARRI',
        BARANGAY: 'ZINARAG',
    },
    {
        CITY: 'BAGGAO',
        BARANGAY: 'ADAOAG',
    },
    {
        CITY: 'BAGGAO',
        BARANGAY: 'AGAMAN (PROPER)',
    },
    {
        CITY: 'BAGGAO',
        BARANGAY: 'AGAMAN NORTE',
    },
    {
        CITY: 'BAGGAO',
        BARANGAY: 'AGAMAN SUR',
    },
    {
        CITY: 'BAGGAO',
        BARANGAY: 'ALBA',
    },
    {
        CITY: 'BAGGAO',
        BARANGAY: 'ANNAYATAN',
    },
    {
        CITY: 'BAGGAO',
        BARANGAY: 'ASASSI',
    },
    {
        CITY: 'BAGGAO',
        BARANGAY: 'ASINGA-VIA',
    },
    {
        CITY: 'BAGGAO',
        BARANGAY: 'AWALLAN',
    },
    {
        CITY: 'BAGGAO',
        BARANGAY: 'BACAGAN',
    },
    {
        CITY: 'BAGGAO',
        BARANGAY: 'BAGUNOT',
    },
    {
        CITY: 'BAGGAO',
        BARANGAY: 'BARSAT EAST',
    },
    {
        CITY: 'BAGGAO',
        BARANGAY: 'BARSAT WEST',
    },
    {
        CITY: 'BAGGAO',
        BARANGAY: 'BITAG GRANDE',
    },
    {
        CITY: 'BAGGAO',
        BARANGAY: 'BITAG PEQUENO',
    },
    {
        CITY: 'BAGGAO',
        BARANGAY: 'BUNUGAN',
    },
    {
        CITY: 'BAGGAO',
        BARANGAY: 'C. VERZOSA (VALLEY COVE)',
    },
    {
        CITY: 'BAGGAO',
        BARANGAY: 'C. VERZOSA (VALLEY COVE*)',
    },
    {
        CITY: 'BAGGAO',
        BARANGAY: 'CANAGATAN',
    },
    {
        CITY: 'BAGGAO',
        BARANGAY: 'CARUPIAN',
    },
    {
        CITY: 'BAGGAO',
        BARANGAY: 'CATUGAY',
    },
    {
        CITY: 'BAGGAO',
        BARANGAY: 'DABBAC GRANDE',
    },
    {
        CITY: 'BAGGAO',
        BARANGAY: 'DALIN',
    },
    {
        CITY: 'BAGGAO',
        BARANGAY: 'DALLA',
    },
    {
        CITY: 'BAGGAO',
        BARANGAY: 'HACIENDA INTAL',
    },
    {
        CITY: 'BAGGAO',
        BARANGAY: 'IBULO',
    },
    {
        CITY: 'BAGGAO',
        BARANGAY: 'IMURONG',
    },
    {
        CITY: 'BAGGAO',
        BARANGAY: 'J. PALLAGAO',
    },
    {
        CITY: 'BAGGAO',
        BARANGAY: 'LASILAT',
    },
    {
        CITY: 'BAGGAO',
        BARANGAY: 'MABINI',
    },
    {
        CITY: 'BAGGAO',
        BARANGAY: 'MASICAL',
    },
    {
        CITY: 'BAGGAO',
        BARANGAY: 'MOCAG',
    },
    {
        CITY: 'BAGGAO',
        BARANGAY: 'NANGALINAN',
    },
    {
        CITY: 'BAGGAO',
        BARANGAY: 'POBLACION (CENTRO)',
    },
    {
        CITY: 'BAGGAO',
        BARANGAY: 'REMUS',
    },
    {
        CITY: 'BAGGAO',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'BAGGAO',
        BARANGAY: 'SAN FRANCISCO',
    },
    {
        CITY: 'BAGGAO',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'BAGGAO',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'BAGGAO',
        BARANGAY: 'SAN MIGUEL',
    },
    {
        CITY: 'BAGGAO',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'BAGGAO',
        BARANGAY: 'SANTA MARGARITA',
    },
    {
        CITY: 'BAGGAO',
        BARANGAY: 'SANTOR',
    },
    {
        CITY: 'BAGGAO',
        BARANGAY: 'TAGUING',
    },
    {
        CITY: 'BAGGAO',
        BARANGAY: 'TAGUNTUNGAN',
    },
    {
        CITY: 'BAGGAO',
        BARANGAY: 'TALLANG',
    },
    {
        CITY: 'BAGGAO',
        BARANGAY: 'TAYTAY',
    },
    {
        CITY: 'BAGGAO',
        BARANGAY: 'TEMBLIQUE',
    },
    {
        CITY: 'BAGGAO',
        BARANGAY: 'TUNGEL',
    },
    {
        CITY: 'BALLESTEROS',
        BARANGAY: 'AMMUBUAN',
    },
    {
        CITY: 'BALLESTEROS',
        BARANGAY: 'BARAN',
    },
    {
        CITY: 'BALLESTEROS',
        BARANGAY: 'CABARITAN EAST',
    },
    {
        CITY: 'BALLESTEROS',
        BARANGAY: 'CABARITAN WEST',
    },
    {
        CITY: 'BALLESTEROS',
        BARANGAY: 'CABAYU',
    },
    {
        CITY: 'BALLESTEROS',
        BARANGAY: 'CABULUAN EAST',
    },
    {
        CITY: 'BALLESTEROS',
        BARANGAY: 'CABULUAN WEST',
    },
    {
        CITY: 'BALLESTEROS',
        BARANGAY: 'CENTRO EAST (POB.)',
    },
    {
        CITY: 'BALLESTEROS',
        BARANGAY: 'CENTRO WEST (POB.)',
    },
    {
        CITY: 'BALLESTEROS',
        BARANGAY: 'FUGU',
    },
    {
        CITY: 'BALLESTEROS',
        BARANGAY: 'MABUTTAL EAST',
    },
    {
        CITY: 'BALLESTEROS',
        BARANGAY: 'MABUTTAL WEST',
    },
    {
        CITY: 'BALLESTEROS',
        BARANGAY: 'NARARAGAN',
    },
    {
        CITY: 'BALLESTEROS',
        BARANGAY: 'PALLOC',
    },
    {
        CITY: 'BALLESTEROS',
        BARANGAY: 'PAYAGAN EAST',
    },
    {
        CITY: 'BALLESTEROS',
        BARANGAY: 'PAYAGAN WEST',
    },
    {
        CITY: 'BALLESTEROS',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'BALLESTEROS',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'BALLESTEROS',
        BARANGAY: 'ZITANGA',
    },
    {
        CITY: 'BUGUEY',
        BARANGAY: 'ALUCAO WESTE (SAN LORENZO)',
    },
    {
        CITY: 'BUGUEY',
        BARANGAY: 'ALUCAO WESTE (SAN LORENZO*)',
    },
    {
        CITY: 'BUGUEY',
        BARANGAY: 'ANTIPORDA',
    },
    {
        CITY: 'BUGUEY',
        BARANGAY: 'BALLANG',
    },
    {
        CITY: 'BUGUEY',
        BARANGAY: 'BALZA',
    },
    {
        CITY: 'BUGUEY',
        BARANGAY: 'CABARITAN',
    },
    {
        CITY: 'BUGUEY',
        BARANGAY: 'CALAMEGATAN',
    },
    {
        CITY: 'BUGUEY',
        BARANGAY: 'CENTRO (POB.)',
    },
    {
        CITY: 'BUGUEY',
        BARANGAY: 'CENTRO WEST',
    },
    {
        CITY: 'BUGUEY',
        BARANGAY: 'DALAYA',
    },
    {
        CITY: 'BUGUEY',
        BARANGAY: 'FULA',
    },
    {
        CITY: 'BUGUEY',
        BARANGAY: 'LERON',
    },
    {
        CITY: 'BUGUEY',
        BARANGAY: 'MADDALERO',
    },
    {
        CITY: 'BUGUEY',
        BARANGAY: 'MALA ESTE',
    },
    {
        CITY: 'BUGUEY',
        BARANGAY: 'MALA WESTE',
    },
    {
        CITY: 'BUGUEY',
        BARANGAY: 'MINANGA ESTE',
    },
    {
        CITY: 'BUGUEY',
        BARANGAY: 'MINANGA WESTE',
    },
    {
        CITY: 'BUGUEY',
        BARANGAY: 'PADDAYA ESTE',
    },
    {
        CITY: 'BUGUEY',
        BARANGAY: 'PADDAYA WESTE',
    },
    {
        CITY: 'BUGUEY',
        BARANGAY: 'PATTAO',
    },
    {
        CITY: 'BUGUEY',
        BARANGAY: 'QUINAWEGAN',
    },
    {
        CITY: 'BUGUEY',
        BARANGAY: 'REMEBELLA',
    },
    {
        CITY: 'BUGUEY',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'BUGUEY',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'BUGUEY',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'BUGUEY',
        BARANGAY: 'SANTA ISABEL',
    },
    {
        CITY: 'BUGUEY',
        BARANGAY: 'SANTA MARIA',
    },
    {
        CITY: 'BUGUEY',
        BARANGAY: 'TABBAC',
    },
    {
        CITY: 'BUGUEY',
        BARANGAY: 'VILLA CIELO',
    },
    {
        CITY: 'BUGUEY',
        BARANGAY: 'VILLA GRACIA',
    },
    {
        CITY: 'BUGUEY',
        BARANGAY: 'VILLA LEONORA',
    },
    {
        CITY: 'ALCALA',
        BARANGAY: 'ABBEG',
    },
    {
        CITY: 'ALCALA',
        BARANGAY: 'AFUSING BATO',
    },
    {
        CITY: 'ALCALA',
        BARANGAY: 'AFUSING DAGA',
    },
    {
        CITY: 'ALCALA',
        BARANGAY: 'AGANI',
    },
    {
        CITY: 'ALCALA',
        BARANGAY: 'BACULOD',
    },
    {
        CITY: 'ALCALA',
        BARANGAY: 'BAYBAYOG',
    },
    {
        CITY: 'ALCALA',
        BARANGAY: 'CABULUAN',
    },
    {
        CITY: 'ALCALA',
        BARANGAY: 'CALANTAC',
    },
    {
        CITY: 'ALCALA',
        BARANGAY: 'CARALLANGAN',
    },
    {
        CITY: 'ALCALA',
        BARANGAY: 'CENTRO NORTE (POB.)',
    },
    {
        CITY: 'ALCALA',
        BARANGAY: 'CENTRO SUR (POB.)',
    },
    {
        CITY: 'ALCALA',
        BARANGAY: 'DALAOIG',
    },
    {
        CITY: 'ALCALA',
        BARANGAY: 'DAMUROG',
    },
    {
        CITY: 'ALCALA',
        BARANGAY: 'JURISDICTION',
    },
    {
        CITY: 'ALCALA',
        BARANGAY: 'MALALATAN',
    },
    {
        CITY: 'ALCALA',
        BARANGAY: 'MARABURAB',
    },
    {
        CITY: 'ALCALA',
        BARANGAY: 'MASIN',
    },
    {
        CITY: 'ALCALA',
        BARANGAY: 'PAGBANGKERUAN',
    },
    {
        CITY: 'ALCALA',
        BARANGAY: 'PARED',
    },
    {
        CITY: 'ALCALA',
        BARANGAY: 'PIGGATAN',
    },
    {
        CITY: 'ALCALA',
        BARANGAY: 'PINOPOC',
    },
    {
        CITY: 'ALCALA',
        BARANGAY: 'PUSSIAN',
    },
    {
        CITY: 'ALCALA',
        BARANGAY: 'SAN ESTEBAN',
    },
    {
        CITY: 'ALCALA',
        BARANGAY: 'TAMBAN',
    },
    {
        CITY: 'ALCALA',
        BARANGAY: 'TUPANG',
    },
    {
        CITY: 'CLAVERIA',
        BARANGAY: 'ALIMOAN',
    },
    {
        CITY: 'CLAVERIA',
        BARANGAY: 'BACSAY CATARAOAN NORTE',
    },
    {
        CITY: 'CLAVERIA',
        BARANGAY: 'BACSAY CATARAOAN SUR',
    },
    {
        CITY: 'CLAVERIA',
        BARANGAY: 'BACSAY MAPULAPULA',
    },
    {
        CITY: 'CLAVERIA',
        BARANGAY: 'BILIBIGAO',
    },
    {
        CITY: 'CLAVERIA',
        BARANGAY: 'BUENAVISTA',
    },
    {
        CITY: 'CLAVERIA',
        BARANGAY: 'CADCADIR EAST',
    },
    {
        CITY: 'CLAVERIA',
        BARANGAY: 'CADCADIR WEST',
    },
    {
        CITY: 'CLAVERIA',
        BARANGAY: 'CAMALAGGOAN/D LEANO',
    },
    {
        CITY: 'CLAVERIA',
        BARANGAY: 'CAPANIKIAN',
    },
    {
        CITY: 'CLAVERIA',
        BARANGAY: 'CENTRO I (POB.)',
    },
    {
        CITY: 'CLAVERIA',
        BARANGAY: 'CENTRO II (POB.)',
    },
    {
        CITY: 'CLAVERIA',
        BARANGAY: 'CENTRO III',
    },
    {
        CITY: 'CLAVERIA',
        BARANGAY: 'CENTRO IV (NANGASANGAN)',
    },
    {
        CITY: 'CLAVERIA',
        BARANGAY: 'CENTRO V (MINA)',
    },
    {
        CITY: 'CLAVERIA',
        BARANGAY: 'CENTRO VI (MINANGA)',
    },
    {
        CITY: 'CLAVERIA',
        BARANGAY: 'CENTRO VII (MALASIN EAST)',
    },
    {
        CITY: 'CLAVERIA',
        BARANGAY: 'CENTRO VIII (MALASIN WEST)',
    },
    {
        CITY: 'CLAVERIA',
        BARANGAY: 'CULAO',
    },
    {
        CITY: 'CLAVERIA',
        BARANGAY: 'DIBALIO',
    },
    {
        CITY: 'CLAVERIA',
        BARANGAY: 'KILKILING',
    },
    {
        CITY: 'CLAVERIA',
        BARANGAY: 'LABLABIG',
    },
    {
        CITY: 'CLAVERIA',
        BARANGAY: 'LUZON',
    },
    {
        CITY: 'CLAVERIA',
        BARANGAY: 'MABNANG',
    },
    {
        CITY: 'CLAVERIA',
        BARANGAY: 'MAGDALENA',
    },
    {
        CITY: 'CLAVERIA',
        BARANGAY: 'MALILITAO',
    },
    {
        CITY: 'CLAVERIA',
        BARANGAY: 'NAGSABARAN',
    },
    {
        CITY: 'CLAVERIA',
        BARANGAY: 'PATA EAST',
    },
    {
        CITY: 'CLAVERIA',
        BARANGAY: 'PATA WEST',
    },
    {
        CITY: 'CLAVERIA',
        BARANGAY: 'PINAS',
    },
    {
        CITY: 'CLAVERIA',
        BARANGAY: 'SAN ANTONIO (SAYAD*/BIMEKEL*)',
    },
    {
        CITY: 'CLAVERIA',
        BARANGAY: 'SAN ANTONIO (SAYAD/BIMEKEL)',
    },
    {
        CITY: 'CLAVERIA',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'CLAVERIA',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'CLAVERIA',
        BARANGAY: 'SANTA MARIA (SURNGOT)',
    },
    {
        CITY: 'CLAVERIA',
        BARANGAY: 'SANTIAGO',
    },
    {
        CITY: 'CLAVERIA',
        BARANGAY: 'SANTO NINO (BARBARNIS)',
    },
    {
        CITY: 'CLAVERIA',
        BARANGAY: 'SANTO TOMAS',
    },
    {
        CITY: 'CLAVERIA',
        BARANGAY: 'TABBUGAN',
    },
    {
        CITY: 'CLAVERIA',
        BARANGAY: 'TAGGAT NORTE',
    },
    {
        CITY: 'CLAVERIA',
        BARANGAY: 'TAGGAT SUR',
    },
    {
        CITY: 'CLAVERIA',
        BARANGAY: 'UNION',
    },
    {
        CITY: 'PAMPLONA',
        BARANGAY: 'ABANQUERUAN',
    },
    {
        CITY: 'PAMPLONA',
        BARANGAY: 'ALLASITAN',
    },
    {
        CITY: 'PAMPLONA',
        BARANGAY: 'BAGU',
    },
    {
        CITY: 'PAMPLONA',
        BARANGAY: 'BALINGIT',
    },
    {
        CITY: 'PAMPLONA',
        BARANGAY: 'BIDDUANG',
    },
    {
        CITY: 'PAMPLONA',
        BARANGAY: 'CABAGGAN',
    },
    {
        CITY: 'PAMPLONA',
        BARANGAY: 'CAPALALIAN',
    },
    {
        CITY: 'PAMPLONA',
        BARANGAY: 'CASITAN',
    },
    {
        CITY: 'PAMPLONA',
        BARANGAY: 'CENTRO (POB.)',
    },
    {
        CITY: 'PAMPLONA',
        BARANGAY: 'CURVA',
    },
    {
        CITY: 'PAMPLONA',
        BARANGAY: 'GATTU',
    },
    {
        CITY: 'PAMPLONA',
        BARANGAY: 'MASI',
    },
    {
        CITY: 'PAMPLONA',
        BARANGAY: 'NAGATTATAN',
    },
    {
        CITY: 'PAMPLONA',
        BARANGAY: 'NAGTUPACAN',
    },
    {
        CITY: 'PAMPLONA',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'PAMPLONA',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'PAMPLONA',
        BARANGAY: 'TABBA',
    },
    {
        CITY: 'PAMPLONA',
        BARANGAY: 'TUPANNA',
    },
    {
        CITY: 'CAGAYAN-RIZAL',
        BARANGAY: 'ANAGGUAN',
    },
    {
        CITY: 'CAGAYAN-RIZAL',
        BARANGAY: 'ANUNGU',
    },
    {
        CITY: 'CAGAYAN-RIZAL',
        BARANGAY: 'ANURTURU',
    },
    {
        CITY: 'CAGAYAN-RIZAL',
        BARANGAY: 'BALUNGCANAG',
    },
    {
        CITY: 'CAGAYAN-RIZAL',
        BARANGAY: 'BATTUT',
    },
    {
        CITY: 'CAGAYAN-RIZAL',
        BARANGAY: 'BATU',
    },
    {
        CITY: 'CAGAYAN-RIZAL',
        BARANGAY: 'BURAL (ZINUNDUNGAN)',
    },
    {
        CITY: 'CAGAYAN-RIZAL',
        BARANGAY: 'CAMBABANGAN',
    },
    {
        CITY: 'CAGAYAN-RIZAL',
        BARANGAY: 'CAPACUAN',
    },
    {
        CITY: 'CAGAYAN-RIZAL',
        BARANGAY: 'DUNGGAN',
    },
    {
        CITY: 'CAGAYAN-RIZAL',
        BARANGAY: 'DUYUN',
    },
    {
        CITY: 'CAGAYAN-RIZAL',
        BARANGAY: 'GADDANGAO',
    },
    {
        CITY: 'CAGAYAN-RIZAL',
        BARANGAY: 'GAGGABUTAN EAST',
    },
    {
        CITY: 'CAGAYAN-RIZAL',
        BARANGAY: 'GAGGABUTAN WEST',
    },
    {
        CITY: 'CAGAYAN-RIZAL',
        BARANGAY: 'ILLURU NORTE',
    },
    {
        CITY: 'CAGAYAN-RIZAL',
        BARANGAY: 'ILLURU SUR',
    },
    {
        CITY: 'CAGAYAN-RIZAL',
        BARANGAY: 'LATTUT',
    },
    {
        CITY: 'CAGAYAN-RIZAL',
        BARANGAY: 'LINNO (VILLA CRUZ)',
    },
    {
        CITY: 'CAGAYAN-RIZAL',
        BARANGAY: 'LINNO (VILLA CRUZ*)',
    },
    {
        CITY: 'CAGAYAN-RIZAL',
        BARANGAY: 'LIWAN',
    },
    {
        CITY: 'CAGAYAN-RIZAL',
        BARANGAY: 'MABBANG',
    },
    {
        CITY: 'CAGAYAN-RIZAL',
        BARANGAY: 'MASI (ZINUNDUNGAN)',
    },
    {
        CITY: 'CAGAYAN-RIZAL',
        BARANGAY: 'MAUANAN',
    },
    {
        CITY: 'CAGAYAN-RIZAL',
        BARANGAY: 'MINANGA',
    },
    {
        CITY: 'CAGAYAN-RIZAL',
        BARANGAY: 'NANAUATAN',
    },
    {
        CITY: 'CAGAYAN-RIZAL',
        BARANGAY: 'NANUNGARAN',
    },
    {
        CITY: 'CAGAYAN-RIZAL',
        BARANGAY: 'PASINGAN',
    },
    {
        CITY: 'CAGAYAN-RIZAL',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'CAGAYAN-RIZAL',
        BARANGAY: 'SAN JUAN (ZINUNDUNGAN)',
    },
    {
        CITY: 'CAGAYAN-RIZAL',
        BARANGAY: 'SINICKING',
    },
    {
        CITY: 'SANTA-ANA',
        BARANGAY: 'BATU-PARADA',
    },
    {
        CITY: 'SANTA-ANA',
        BARANGAY: 'CASAGAN',
    },
    {
        CITY: 'SANTA-ANA',
        BARANGAY: 'CASAMBALANGAN (PORT IRENE)',
    },
    {
        CITY: 'SANTA-ANA',
        BARANGAY: 'CENTRO (POB.)',
    },
    {
        CITY: 'SANTA-ANA',
        BARANGAY: 'DIORA-ZINUNGAN',
    },
    {
        CITY: 'SANTA-ANA',
        BARANGAY: 'DUNGEG',
    },
    {
        CITY: 'SANTA-ANA',
        BARANGAY: 'KAPANIKIAN',
    },
    {
        CITY: 'SANTA-ANA',
        BARANGAY: 'MAREDE',
    },
    {
        CITY: 'SANTA-ANA',
        BARANGAY: 'PALAWIG',
    },
    {
        CITY: 'SANTA-ANA',
        BARANGAY: 'PATUNUNGAN',
    },
    {
        CITY: 'SANTA-ANA',
        BARANGAY: 'RAPULI (PUNTI)',
    },
    {
        CITY: 'SANTA-ANA',
        BARANGAY: 'SAN VICENTE (FORT)',
    },
    {
        CITY: 'SANTA-ANA',
        BARANGAY: 'SANTA CLARA',
    },
    {
        CITY: 'SANTA-ANA',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'SANTA-ANA',
        BARANGAY: 'TANGATAN',
    },
    {
        CITY: 'SANTA-ANA',
        BARANGAY: 'VISITACION (POB.)',
    },
    {
        CITY: 'SANTA-TERESITA',
        BARANGAY: 'ALUCAO',
    },
    {
        CITY: 'SANTA-TERESITA',
        BARANGAY: 'ARIDAWEN',
    },
    {
        CITY: 'SANTA-TERESITA',
        BARANGAY: 'BUYUN',
    },
    {
        CITY: 'SANTA-TERESITA',
        BARANGAY: 'CANIUGAN',
    },
    {
        CITY: 'SANTA-TERESITA',
        BARANGAY: 'CENTRO EAST (POB.)',
    },
    {
        CITY: 'SANTA-TERESITA',
        BARANGAY: 'CENTRO WEST',
    },
    {
        CITY: 'SANTA-TERESITA',
        BARANGAY: 'DUNGEG',
    },
    {
        CITY: 'SANTA-TERESITA',
        BARANGAY: 'LUGA',
    },
    {
        CITY: 'SANTA-TERESITA',
        BARANGAY: 'MASI',
    },
    {
        CITY: 'SANTA-TERESITA',
        BARANGAY: 'MISSION',
    },
    {
        CITY: 'SANTA-TERESITA',
        BARANGAY: 'SIMBALUCA',
    },
    {
        CITY: 'SANTA-TERESITA',
        BARANGAY: 'SIMPATUYO',
    },
    {
        CITY: 'SANTA-TERESITA',
        BARANGAY: 'VILLA',
    },
    {
        CITY: 'SANTO-NINO',
        BARANGAY: 'ABARIONGAN RUAR',
    },
    {
        CITY: 'SANTO-NINO',
        BARANGAY: 'ABARIONGAN UNEG',
    },
    {
        CITY: 'SANTO-NINO',
        BARANGAY: 'BALAGAN',
    },
    {
        CITY: 'SANTO-NINO',
        BARANGAY: 'BALANNI',
    },
    {
        CITY: 'SANTO-NINO',
        BARANGAY: 'CABAYO',
    },
    {
        CITY: 'SANTO-NINO',
        BARANGAY: 'CALAPANGAN',
    },
    {
        CITY: 'SANTO-NINO',
        BARANGAY: 'CALASSITAN',
    },
    {
        CITY: 'SANTO-NINO',
        BARANGAY: 'CAMPO',
    },
    {
        CITY: 'SANTO-NINO',
        BARANGAY: 'CENTRO NORTE (POB.)',
    },
    {
        CITY: 'SANTO-NINO',
        BARANGAY: 'CENTRO SUR (POB.)',
    },
    {
        CITY: 'SANTO-NINO',
        BARANGAY: 'DUNGAO',
    },
    {
        CITY: 'SANTO-NINO',
        BARANGAY: 'LATTAC',
    },
    {
        CITY: 'SANTO-NINO',
        BARANGAY: 'LIPATAN',
    },
    {
        CITY: 'SANTO-NINO',
        BARANGAY: 'LUBO',
    },
    {
        CITY: 'SANTO-NINO',
        BARANGAY: 'MABITBITNONG',
    },
    {
        CITY: 'SANTO-NINO',
        BARANGAY: 'MAPITAC',
    },
    {
        CITY: 'SANTO-NINO',
        BARANGAY: 'MASICAL',
    },
    {
        CITY: 'SANTO-NINO',
        BARANGAY: 'MATALAO',
    },
    {
        CITY: 'SANTO-NINO',
        BARANGAY: 'NAG-UMA',
    },
    {
        CITY: 'SANTO-NINO',
        BARANGAY: 'NAMUCCAYAN',
    },
    {
        CITY: 'SANTO-NINO',
        BARANGAY: 'NIUG NORTE',
    },
    {
        CITY: 'SANTO-NINO',
        BARANGAY: 'NIUG SUR',
    },
    {
        CITY: 'SANTO-NINO',
        BARANGAY: 'PALUSAO',
    },
    {
        CITY: 'SANTO-NINO',
        BARANGAY: 'SAN MANUEL',
    },
    {
        CITY: 'SANTO-NINO',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'SANTO-NINO',
        BARANGAY: 'SANTA FELICITAS',
    },
    {
        CITY: 'SANTO-NINO',
        BARANGAY: 'SANTA MARIA',
    },
    {
        CITY: 'SANTO-NINO',
        BARANGAY: 'SIDIRAN',
    },
    {
        CITY: 'SANTO-NINO',
        BARANGAY: 'TABANG',
    },
    {
        CITY: 'SANTO-NINO',
        BARANGAY: 'TAMUCCO',
    },
    {
        CITY: 'SANTO-NINO',
        BARANGAY: 'VIRGINIA',
    },
    {
        CITY: 'CAMALANIUGAN',
        BARANGAY: 'ABAGAO',
    },
    {
        CITY: 'CAMALANIUGAN',
        BARANGAY: 'AFUNAN CABAYU',
    },
    {
        CITY: 'CAMALANIUGAN',
        BARANGAY: 'AGUSI',
    },
    {
        CITY: 'CAMALANIUGAN',
        BARANGAY: 'ALILINU',
    },
    {
        CITY: 'CAMALANIUGAN',
        BARANGAY: 'BAGGAO',
    },
    {
        CITY: 'CAMALANIUGAN',
        BARANGAY: 'BANTAY',
    },
    {
        CITY: 'CAMALANIUGAN',
        BARANGAY: 'BULALA',
    },
    {
        CITY: 'CAMALANIUGAN',
        BARANGAY: 'CASILI NORTE',
    },
    {
        CITY: 'CAMALANIUGAN',
        BARANGAY: 'CASILI SUR',
    },
    {
        CITY: 'CAMALANIUGAN',
        BARANGAY: 'CATOTORAN NORTE',
    },
    {
        CITY: 'CAMALANIUGAN',
        BARANGAY: 'CATOTORAN SUR',
    },
    {
        CITY: 'CAMALANIUGAN',
        BARANGAY: 'CENTRO NORTE (POB.)',
    },
    {
        CITY: 'CAMALANIUGAN',
        BARANGAY: 'CENTRO SUR (POB.)',
    },
    {
        CITY: 'CAMALANIUGAN',
        BARANGAY: 'CULLIT',
    },
    {
        CITY: 'CAMALANIUGAN',
        BARANGAY: 'DACAL-LAFUGU',
    },
    {
        CITY: 'CAMALANIUGAN',
        BARANGAY: 'DAMMANG NORTE (JOAQUIN DE LA CRUZ)',
    },
    {
        CITY: 'CAMALANIUGAN',
        BARANGAY: 'DAMMANG NORTE (JOAQUIN DE LA CRUZ*)',
    },
    {
        CITY: 'CAMALANIUGAN',
        BARANGAY: 'DAMMANG SUR (FELIPE TUZON)',
    },
    {
        CITY: 'CAMALANIUGAN',
        BARANGAY: 'DAMMANG SUR (FELIPE TUZON*)',
    },
    {
        CITY: 'CAMALANIUGAN',
        BARANGAY: 'DUGO',
    },
    {
        CITY: 'CAMALANIUGAN',
        BARANGAY: 'FUSINA',
    },
    {
        CITY: 'CAMALANIUGAN',
        BARANGAY: 'GANG-NGO',
    },
    {
        CITY: 'CAMALANIUGAN',
        BARANGAY: 'JURISDICTION',
    },
    {
        CITY: 'CAMALANIUGAN',
        BARANGAY: 'LUEC',
    },
    {
        CITY: 'CAMALANIUGAN',
        BARANGAY: 'MINANGA',
    },
    {
        CITY: 'CAMALANIUGAN',
        BARANGAY: 'PARAGAT',
    },
    {
        CITY: 'CAMALANIUGAN',
        BARANGAY: 'SAPPING',
    },
    {
        CITY: 'CAMALANIUGAN',
        BARANGAY: 'TAGUM',
    },
    {
        CITY: 'CAMALANIUGAN',
        BARANGAY: 'TULUTTUGING',
    },
    {
        CITY: 'CAMALANIUGAN',
        BARANGAY: 'ZIMINILA',
    },
    {
        CITY: 'ENRILE',
        BARANGAY: 'ALIBAGO (VILLA MARIA)',
    },
    {
        CITY: 'ENRILE',
        BARANGAY: 'BARANGAY I (POB.)',
    },
    {
        CITY: 'ENRILE',
        BARANGAY: 'BARANGAY II (POB.)',
    },
    {
        CITY: 'ENRILE',
        BARANGAY: 'BARANGAY III (SAN ROQUE)',
    },
    {
        CITY: 'ENRILE',
        BARANGAY: 'BARANGAY III (SAN ROQUE*)',
    },
    {
        CITY: 'ENRILE',
        BARANGAY: 'BARANGAY III-A',
    },
    {
        CITY: 'ENRILE',
        BARANGAY: 'BARANGAY IV (POB.)',
    },
    {
        CITY: 'ENRILE',
        BARANGAY: 'BATU',
    },
    {
        CITY: 'ENRILE',
        BARANGAY: 'DIVISORIA',
    },
    {
        CITY: 'ENRILE',
        BARANGAY: 'INGA',
    },
    {
        CITY: 'ENRILE',
        BARANGAY: 'LANNA',
    },
    {
        CITY: 'ENRILE',
        BARANGAY: 'LEMU NORTE',
    },
    {
        CITY: 'ENRILE',
        BARANGAY: 'LEMU SUR',
    },
    {
        CITY: 'ENRILE',
        BARANGAY: 'LIWAN NORTE',
    },
    {
        CITY: 'ENRILE',
        BARANGAY: 'LIWAN SUR',
    },
    {
        CITY: 'ENRILE',
        BARANGAY: 'MADDARULUG NORTE',
    },
    {
        CITY: 'ENRILE',
        BARANGAY: 'MADDARULUG SUR',
    },
    {
        CITY: 'ENRILE',
        BARANGAY: 'MAGALALAG EAST',
    },
    {
        CITY: 'ENRILE',
        BARANGAY: 'MAGALALAG WEST (SAN NICOLAS)',
    },
    {
        CITY: 'ENRILE',
        BARANGAY: 'MAGALALAG WEST (SAN NICOLAS*)',
    },
    {
        CITY: 'ENRILE',
        BARANGAY: 'MARACURU',
    },
    {
        CITY: 'ENRILE',
        BARANGAY: 'ROMA NORTE',
    },
    {
        CITY: 'ENRILE',
        BARANGAY: 'ROMA SUR',
    },
    {
        CITY: 'ENRILE',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'GATTARAN',
        BARANGAY: 'ABRA',
    },
    {
        CITY: 'GATTARAN',
        BARANGAY: 'AGUIGUICAN',
    },
    {
        CITY: 'GATTARAN',
        BARANGAY: 'BANGATAN NGAGAN',
    },
    {
        CITY: 'GATTARAN',
        BARANGAY: 'BARACAOIT',
    },
    {
        CITY: 'GATTARAN',
        BARANGAY: 'BARAOIDAN',
    },
    {
        CITY: 'GATTARAN',
        BARANGAY: 'BARBARIT',
    },
    {
        CITY: 'GATTARAN',
        BARANGAY: 'BASAO',
    },
    {
        CITY: 'GATTARAN',
        BARANGAY: 'BOLOS POINT',
    },
    {
        CITY: 'GATTARAN',
        BARANGAY: 'CABAYU',
    },
    {
        CITY: 'GATTARAN',
        BARANGAY: 'CALAOAGAN BASSIT',
    },
    {
        CITY: 'GATTARAN',
        BARANGAY: 'CALAOAGAN DACKEL',
    },
    {
        CITY: 'GATTARAN',
        BARANGAY: 'CAPIDDIGAN',
    },
    {
        CITY: 'GATTARAN',
        BARANGAY: 'CAPISSAYAN NORTE',
    },
    {
        CITY: 'GATTARAN',
        BARANGAY: 'CAPISSAYAN SUR',
    },
    {
        CITY: 'GATTARAN',
        BARANGAY: 'CASICALLAN NORTE',
    },
    {
        CITY: 'GATTARAN',
        BARANGAY: 'CASICALLAN SUR',
    },
    {
        CITY: 'GATTARAN',
        BARANGAY: 'CENTRO NORTE (POB.)',
    },
    {
        CITY: 'GATTARAN',
        BARANGAY: 'CENTRO SUR (POB.)',
    },
    {
        CITY: 'GATTARAN',
        BARANGAY: 'CULLIT',
    },
    {
        CITY: 'GATTARAN',
        BARANGAY: 'CUMAO',
    },
    {
        CITY: 'GATTARAN',
        BARANGAY: 'CUNIG',
    },
    {
        CITY: 'GATTARAN',
        BARANGAY: 'DUMMUN',
    },
    {
        CITY: 'GATTARAN',
        BARANGAY: 'FUGU',
    },
    {
        CITY: 'GATTARAN',
        BARANGAY: 'GANZANO',
    },
    {
        CITY: 'GATTARAN',
        BARANGAY: 'GUISING',
    },
    {
        CITY: 'GATTARAN',
        BARANGAY: 'L. ADVIENTO',
    },
    {
        CITY: 'GATTARAN',
        BARANGAY: 'LANGGAN',
    },
    {
        CITY: 'GATTARAN',
        BARANGAY: 'LAPOGAN',
    },
    {
        CITY: 'GATTARAN',
        BARANGAY: 'MABUNO',
    },
    {
        CITY: 'GATTARAN',
        BARANGAY: 'NABACCAYAN',
    },
    {
        CITY: 'GATTARAN',
        BARANGAY: 'NADDUNGAN',
    },
    {
        CITY: 'GATTARAN',
        BARANGAY: 'NAGATUTUAN',
    },
    {
        CITY: 'GATTARAN',
        BARANGAY: 'NASSIPING',
    },
    {
        CITY: 'GATTARAN',
        BARANGAY: 'NEWAGAC',
    },
    {
        CITY: 'GATTARAN',
        BARANGAY: 'PALAGAO NORTE',
    },
    {
        CITY: 'GATTARAN',
        BARANGAY: 'PALAGAO SUR',
    },
    {
        CITY: 'GATTARAN',
        BARANGAY: 'PINA ESTE',
    },
    {
        CITY: 'GATTARAN',
        BARANGAY: 'PINA WESTE',
    },
    {
        CITY: 'GATTARAN',
        BARANGAY: 'SAN CARLOS',
    },
    {
        CITY: 'GATTARAN',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'GATTARAN',
        BARANGAY: 'SANTA ANA',
    },
    {
        CITY: 'GATTARAN',
        BARANGAY: 'SANTA MARIA',
    },
    {
        CITY: 'GATTARAN',
        BARANGAY: 'SIDEM',
    },
    {
        CITY: 'GATTARAN',
        BARANGAY: 'T. ELIZAGA (MABIRBIRA)',
    },
    {
        CITY: 'GATTARAN',
        BARANGAY: 'TAGUMAY',
    },
    {
        CITY: 'GATTARAN',
        BARANGAY: 'TAKIKI',
    },
    {
        CITY: 'GATTARAN',
        BARANGAY: 'TALIGAN',
    },
    {
        CITY: 'GATTARAN',
        BARANGAY: 'TANGLAGAN',
    },
    {
        CITY: 'GATTARAN',
        BARANGAY: 'TUBUNGAN ESTE',
    },
    {
        CITY: 'GATTARAN',
        BARANGAY: 'TUBUNGAN WESTE',
    },
    {
        CITY: 'GONZAGA',
        BARANGAY: 'AMUNITAN',
    },
    {
        CITY: 'GONZAGA',
        BARANGAY: 'BATANGAN',
    },
    {
        CITY: 'GONZAGA',
        BARANGAY: 'BAUA',
    },
    {
        CITY: 'GONZAGA',
        BARANGAY: 'CABANBANAN NORTE',
    },
    {
        CITY: 'GONZAGA',
        BARANGAY: 'CABANBANAN SUR',
    },
    {
        CITY: 'GONZAGA',
        BARANGAY: 'CABIRAOAN',
    },
    {
        CITY: 'GONZAGA',
        BARANGAY: 'CALAYAN',
    },
    {
        CITY: 'GONZAGA',
        BARANGAY: 'CALLAO',
    },
    {
        CITY: 'GONZAGA',
        BARANGAY: 'CAROAN',
    },
    {
        CITY: 'GONZAGA',
        BARANGAY: 'CASITAN',
    },
    {
        CITY: 'GONZAGA',
        BARANGAY: 'FLOURISHING (POB.)',
    },
    {
        CITY: 'GONZAGA',
        BARANGAY: 'IPIL',
    },
    {
        CITY: 'GONZAGA',
        BARANGAY: 'ISCA',
    },
    {
        CITY: 'GONZAGA',
        BARANGAY: 'MAGRAFIL',
    },
    {
        CITY: 'GONZAGA',
        BARANGAY: 'MINANGA',
    },
    {
        CITY: 'GONZAGA',
        BARANGAY: 'PARADISE (POB.)',
    },
    {
        CITY: 'GONZAGA',
        BARANGAY: 'PATENG',
    },
    {
        CITY: 'GONZAGA',
        BARANGAY: 'PROGRESSIVE (POB.)',
    },
    {
        CITY: 'GONZAGA',
        BARANGAY: 'REBECCA (NAGBABALACAN)',
    },
    {
        CITY: 'GONZAGA',
        BARANGAY: 'REBECCA (NAGBABALACAN*)',
    },
    {
        CITY: 'GONZAGA',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'GONZAGA',
        BARANGAY: 'SANTA CLARA',
    },
    {
        CITY: 'GONZAGA',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'GONZAGA',
        BARANGAY: 'SANTA MARIA',
    },
    {
        CITY: 'GONZAGA',
        BARANGAY: 'SMART (POB.)',
    },
    {
        CITY: 'GONZAGA',
        BARANGAY: 'TAPEL',
    },
    {
        CITY: 'IGUIG',
        BARANGAY: 'AJAT (POB.)',
    },
    {
        CITY: 'IGUIG',
        BARANGAY: 'ATULU',
    },
    {
        CITY: 'IGUIG',
        BARANGAY: 'BACULUD',
    },
    {
        CITY: 'IGUIG',
        BARANGAY: 'BAYO',
    },
    {
        CITY: 'IGUIG',
        BARANGAY: 'CAMPO',
    },
    {
        CITY: 'IGUIG',
        BARANGAY: 'DUMPAO',
    },
    {
        CITY: 'IGUIG',
        BARANGAY: 'GAMMAD',
    },
    {
        CITY: 'IGUIG',
        BARANGAY: 'GARAB',
    },
    {
        CITY: 'IGUIG',
        BARANGAY: 'MALABBAC',
    },
    {
        CITY: 'IGUIG',
        BARANGAY: 'MANAOAG (AQUILIQUILAO)',
    },
    {
        CITY: 'IGUIG',
        BARANGAY: 'MINANGA NORTE',
    },
    {
        CITY: 'IGUIG',
        BARANGAY: 'MINANGA SUR',
    },
    {
        CITY: 'IGUIG',
        BARANGAY: 'NATTANZAN (POB.)',
    },
    {
        CITY: 'IGUIG',
        BARANGAY: 'REDONDO',
    },
    {
        CITY: 'IGUIG',
        BARANGAY: 'SALAMAGUE',
    },
    {
        CITY: 'IGUIG',
        BARANGAY: 'SAN ESTEBAN (CAPITAN)',
    },
    {
        CITY: 'IGUIG',
        BARANGAY: 'SAN ISIDRO (UGAC WEST)',
    },
    {
        CITY: 'IGUIG',
        BARANGAY: 'SAN LORENZO',
    },
    {
        CITY: 'IGUIG',
        BARANGAY: 'SAN VICENTE (UGAC EAST)',
    },
    {
        CITY: 'IGUIG',
        BARANGAY: 'SANTA BARBARA',
    },
    {
        CITY: 'IGUIG',
        BARANGAY: 'SANTA ROSA',
    },
    {
        CITY: 'IGUIG',
        BARANGAY: 'SANTA TERESA (GAMMAD SUR)',
    },
    {
        CITY: 'IGUIG',
        BARANGAY: 'SANTIAGO',
    },
    {
        CITY: 'LAL-LO',
        BARANGAY: 'ABAGAO',
    },
    {
        CITY: 'LAL-LO',
        BARANGAY: 'ALAGUIA',
    },
    {
        CITY: 'LAL-LO',
        BARANGAY: 'BAGUMBAYAN',
    },
    {
        CITY: 'LAL-LO',
        BARANGAY: 'BANGAG',
    },
    {
        CITY: 'LAL-LO',
        BARANGAY: 'BICAL',
    },
    {
        CITY: 'LAL-LO',
        BARANGAY: 'BICUD',
    },
    {
        CITY: 'LAL-LO',
        BARANGAY: 'BINAG',
    },
    {
        CITY: 'LAL-LO',
        BARANGAY: 'CABAYABASAN (CAPACUAN)',
    },
    {
        CITY: 'LAL-LO',
        BARANGAY: 'CAGORAN',
    },
    {
        CITY: 'LAL-LO',
        BARANGAY: 'CAMBONG',
    },
    {
        CITY: 'LAL-LO',
        BARANGAY: 'CATAYAUAN',
    },
    {
        CITY: 'LAL-LO',
        BARANGAY: 'CATUGAN',
    },
    {
        CITY: 'LAL-LO',
        BARANGAY: 'CENTRO (POB.)',
    },
    {
        CITY: 'LAL-LO',
        BARANGAY: 'CULLIT',
    },
    {
        CITY: 'LAL-LO',
        BARANGAY: 'DAGUPAN',
    },
    {
        CITY: 'LAL-LO',
        BARANGAY: 'DALAYA',
    },
    {
        CITY: 'LAL-LO',
        BARANGAY: 'FABRICA',
    },
    {
        CITY: 'LAL-LO',
        BARANGAY: 'FUSINA',
    },
    {
        CITY: 'LAL-LO',
        BARANGAY: 'JURISDICTION',
    },
    {
        CITY: 'LAL-LO',
        BARANGAY: 'LALAFUGAN',
    },
    {
        CITY: 'LAL-LO',
        BARANGAY: 'LOGAC',
    },
    {
        CITY: 'LAL-LO',
        BARANGAY: 'MAGALLUNGON (STA. TERESA)',
    },
    {
        CITY: 'LAL-LO',
        BARANGAY: 'MAGALLUNGON (STA. TERESA*)',
    },
    {
        CITY: 'LAL-LO',
        BARANGAY: 'MAGAPIT',
    },
    {
        CITY: 'LAL-LO',
        BARANGAY: 'MALANAO',
    },
    {
        CITY: 'LAL-LO',
        BARANGAY: 'MAXINGAL',
    },
    {
        CITY: 'LAL-LO',
        BARANGAY: 'NAGUILIAN',
    },
    {
        CITY: 'LAL-LO',
        BARANGAY: 'PARANUM',
    },
    {
        CITY: 'LAL-LO',
        BARANGAY: 'ROSARIO',
    },
    {
        CITY: 'LAL-LO',
        BARANGAY: 'SAN ANTONIO (LAFU)',
    },
    {
        CITY: 'LAL-LO',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'LAL-LO',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'LAL-LO',
        BARANGAY: 'SAN LORENZO',
    },
    {
        CITY: 'LAL-LO',
        BARANGAY: 'SAN MARIANO',
    },
    {
        CITY: 'LAL-LO',
        BARANGAY: 'SANTA MARIA',
    },
    {
        CITY: 'LAL-LO',
        BARANGAY: 'TUCALANA',
    },
    {
        CITY: 'LASAM',
        BARANGAY: 'AGGUNETAN',
    },
    {
        CITY: 'LASAM',
        BARANGAY: 'ALANNAY',
    },
    {
        CITY: 'LASAM',
        BARANGAY: 'BATTALAN',
    },
    {
        CITY: 'LASAM',
        BARANGAY: 'CABATACAN EAST (DULDUGAN)',
    },
    {
        CITY: 'LASAM',
        BARANGAY: 'CABATACAN EAST (DULDUGAN*)',
    },
    {
        CITY: 'LASAM',
        BARANGAY: 'CABATACAN WEST',
    },
    {
        CITY: 'LASAM',
        BARANGAY: 'CALAPANGAN NORTE',
    },
    {
        CITY: 'LASAM',
        BARANGAY: 'CALAPANGAN SUR',
    },
    {
        CITY: 'LASAM',
        BARANGAY: 'CALLAO NORTE',
    },
    {
        CITY: 'LASAM',
        BARANGAY: 'CALLAO SUR',
    },
    {
        CITY: 'LASAM',
        BARANGAY: 'CATALIGANAN',
    },
    {
        CITY: 'LASAM',
        BARANGAY: 'CENTRO I (POB.)',
    },
    {
        CITY: 'LASAM',
        BARANGAY: 'CENTRO II (POB.)',
    },
    {
        CITY: 'LASAM',
        BARANGAY: 'CENTRO III (POB.)',
    },
    {
        CITY: 'LASAM',
        BARANGAY: 'FINUGO NORTE',
    },
    {
        CITY: 'LASAM',
        BARANGAY: 'GABUN',
    },
    {
        CITY: 'LASAM',
        BARANGAY: 'IGNACIO JURADO (FINUGU SUR)',
    },
    {
        CITY: 'LASAM',
        BARANGAY: 'MAGSAYSAY',
    },
    {
        CITY: 'LASAM',
        BARANGAY: 'MALINTA',
    },
    {
        CITY: 'LASAM',
        BARANGAY: 'MINANGA NORTE',
    },
    {
        CITY: 'LASAM',
        BARANGAY: 'MINANGA SUR',
    },
    {
        CITY: 'LASAM',
        BARANGAY: 'NABANNAGAN EAST',
    },
    {
        CITY: 'LASAM',
        BARANGAY: 'NABANNAGAN WEST',
    },
    {
        CITY: 'LASAM',
        BARANGAY: 'NEW ORLINS',
    },
    {
        CITY: 'LASAM',
        BARANGAY: 'NICOLAS AGATEP',
    },
    {
        CITY: 'LASAM',
        BARANGAY: 'PERU',
    },
    {
        CITY: 'LASAM',
        BARANGAY: 'SAN PEDRO',
    },
    {
        CITY: 'LASAM',
        BARANGAY: 'SICALAO',
    },
    {
        CITY: 'LASAM',
        BARANGAY: 'TAGAO',
    },
    {
        CITY: 'LASAM',
        BARANGAY: 'TUCALAN PASSING',
    },
    {
        CITY: 'LASAM',
        BARANGAY: 'VIGA',
    },
    {
        CITY: 'PENABLANCA',
        BARANGAY: 'AGGUGADDAN',
    },
    {
        CITY: 'PENABLANCA',
        BARANGAY: 'ALIMANAO',
    },
    {
        CITY: 'PENABLANCA',
        BARANGAY: 'BALIUAG',
    },
    {
        CITY: 'PENABLANCA',
        BARANGAY: 'BICAL',
    },
    {
        CITY: 'PENABLANCA',
        BARANGAY: 'BUGATAY',
    },
    {
        CITY: 'PENABLANCA',
        BARANGAY: 'BUYUN',
    },
    {
        CITY: 'PENABLANCA',
        BARANGAY: 'CABASAN',
    },
    {
        CITY: 'PENABLANCA',
        BARANGAY: 'CABBO',
    },
    {
        CITY: 'PENABLANCA',
        BARANGAY: 'CALLAO',
    },
    {
        CITY: 'PENABLANCA',
        BARANGAY: 'CAMASI',
    },
    {
        CITY: 'PENABLANCA',
        BARANGAY: 'CENTRO (POB.)',
    },
    {
        CITY: 'PENABLANCA',
        BARANGAY: 'DODAN',
    },
    {
        CITY: 'PENABLANCA',
        BARANGAY: 'LAPI',
    },
    {
        CITY: 'PENABLANCA',
        BARANGAY: 'MALIBABAG',
    },
    {
        CITY: 'PENABLANCA',
        BARANGAY: 'MANGA',
    },
    {
        CITY: 'PENABLANCA',
        BARANGAY: 'MINANGA',
    },
    {
        CITY: 'PENABLANCA',
        BARANGAY: 'NABBABALAYAN',
    },
    {
        CITY: 'PENABLANCA',
        BARANGAY: 'NANGUILATTAN',
    },
    {
        CITY: 'PENABLANCA',
        BARANGAY: 'NANNARIAN',
    },
    {
        CITY: 'PENABLANCA',
        BARANGAY: 'PARABBA',
    },
    {
        CITY: 'PENABLANCA',
        BARANGAY: 'PATAGUELEG',
    },
    {
        CITY: 'PENABLANCA',
        BARANGAY: 'QUIBAL',
    },
    {
        CITY: 'PENABLANCA',
        BARANGAY: 'SAN ROQUE (LITTO)',
    },
    {
        CITY: 'PENABLANCA',
        BARANGAY: 'SISIM',
    },
    {
        CITY: 'PIAT',
        BARANGAY: 'APAYAO',
    },
    {
        CITY: 'PIAT',
        BARANGAY: 'AQUIB',
    },
    {
        CITY: 'PIAT',
        BARANGAY: 'BAUNG',
    },
    {
        CITY: 'PIAT',
        BARANGAY: 'CALAOAGAN',
    },
    {
        CITY: 'PIAT',
        BARANGAY: 'CATARAUAN',
    },
    {
        CITY: 'PIAT',
        BARANGAY: 'DUGAYUNG',
    },
    {
        CITY: 'PIAT',
        BARANGAY: 'GUMARUENG',
    },
    {
        CITY: 'PIAT',
        BARANGAY: 'MACAPIL',
    },
    {
        CITY: 'PIAT',
        BARANGAY: 'MAGUILLING',
    },
    {
        CITY: 'PIAT',
        BARANGAY: 'MINANGA',
    },
    {
        CITY: 'PIAT',
        BARANGAY: 'POBLACION I',
    },
    {
        CITY: 'PIAT',
        BARANGAY: 'POBLACION II',
    },
    {
        CITY: 'PIAT',
        BARANGAY: 'SANTA BARBARA',
    },
    {
        CITY: 'PIAT',
        BARANGAY: 'SANTO DOMINGO',
    },
    {
        CITY: 'PIAT',
        BARANGAY: 'SICATNA',
    },
    {
        CITY: 'PIAT',
        BARANGAY: 'VILLA REY (SAN GASPAR)',
    },
    {
        CITY: 'PIAT',
        BARANGAY: 'VILLA REY (SAN GASPAR*)',
    },
    {
        CITY: 'PIAT',
        BARANGAY: 'VILLA REYNO',
    },
    {
        CITY: 'PIAT',
        BARANGAY: 'WARAT',
    },
    {
        CITY: 'SANCHEZ-MIRA',
        BARANGAY: 'BANGAN',
    },
    {
        CITY: 'SANCHEZ-MIRA',
        BARANGAY: 'CALLUNGAN',
    },
    {
        CITY: 'SANCHEZ-MIRA',
        BARANGAY: 'CENTRO I (POB.)',
    },
    {
        CITY: 'SANCHEZ-MIRA',
        BARANGAY: 'CENTRO II (POB.)',
    },
    {
        CITY: 'SANCHEZ-MIRA',
        BARANGAY: 'DACAL',
    },
    {
        CITY: 'SANCHEZ-MIRA',
        BARANGAY: 'DAGUERAY',
    },
    {
        CITY: 'SANCHEZ-MIRA',
        BARANGAY: 'DAMMANG',
    },
    {
        CITY: 'SANCHEZ-MIRA',
        BARANGAY: 'KITTAG',
    },
    {
        CITY: 'SANCHEZ-MIRA',
        BARANGAY: 'LANGAGAN',
    },
    {
        CITY: 'SANCHEZ-MIRA',
        BARANGAY: 'MAGACAN',
    },
    {
        CITY: 'SANCHEZ-MIRA',
        BARANGAY: 'MARZAN',
    },
    {
        CITY: 'SANCHEZ-MIRA',
        BARANGAY: 'MASISIT',
    },
    {
        CITY: 'SANCHEZ-MIRA',
        BARANGAY: 'NAGRANGTAYAN',
    },
    {
        CITY: 'SANCHEZ-MIRA',
        BARANGAY: 'NAMUAC',
    },
    {
        CITY: 'SANCHEZ-MIRA',
        BARANGAY: 'SAN ANDRES',
    },
    {
        CITY: 'SANCHEZ-MIRA',
        BARANGAY: 'SANTIAGO',
    },
    {
        CITY: 'SANCHEZ-MIRA',
        BARANGAY: 'SANTOR',
    },
    {
        CITY: 'SANCHEZ-MIRA',
        BARANGAY: 'TOKITOK',
    },
    {
        CITY: 'SANTA-PRAXEDES',
        BARANGAY: 'CADONGDONGAN',
    },
    {
        CITY: 'SANTA-PRAXEDES',
        BARANGAY: 'CAPACUAN',
    },
    {
        CITY: 'SANTA-PRAXEDES',
        BARANGAY: 'CENTRO I (POB.)',
    },
    {
        CITY: 'SANTA-PRAXEDES',
        BARANGAY: 'CENTRO II (POB.)',
    },
    {
        CITY: 'SANTA-PRAXEDES',
        BARANGAY: 'MACATEL',
    },
    {
        CITY: 'SANTA-PRAXEDES',
        BARANGAY: 'PORTABAGA',
    },
    {
        CITY: 'SANTA-PRAXEDES',
        BARANGAY: 'SALUNGSONG',
    },
    {
        CITY: 'SANTA-PRAXEDES',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'SANTA-PRAXEDES',
        BARANGAY: 'SAN MIGUEL',
    },
    {
        CITY: 'SANTA-PRAXEDES',
        BARANGAY: 'SICUL',
    },
    {
        CITY: 'SOLANA',
        BARANGAY: 'ANDARAYAN NORTH',
    },
    {
        CITY: 'SOLANA',
        BARANGAY: 'ANDARAYAN SOUTH',
    },
    {
        CITY: 'SOLANA',
        BARANGAY: 'BANGAG',
    },
    {
        CITY: 'SOLANA',
        BARANGAY: 'BANTAY',
    },
    {
        CITY: 'SOLANA',
        BARANGAY: 'BASI EAST',
    },
    {
        CITY: 'SOLANA',
        BARANGAY: 'BASI WEST',
    },
    {
        CITY: 'SOLANA',
        BARANGAY: 'BAUAN EAST',
    },
    {
        CITY: 'SOLANA',
        BARANGAY: 'BAUAN WEST',
    },
    {
        CITY: 'SOLANA',
        BARANGAY: 'CADAANAN',
    },
    {
        CITY: 'SOLANA',
        BARANGAY: 'CALAMAGUI',
    },
    {
        CITY: 'SOLANA',
        BARANGAY: 'CALILLAUAN',
    },
    {
        CITY: 'SOLANA',
        BARANGAY: 'CARILUCUD',
    },
    {
        CITY: 'SOLANA',
        BARANGAY: 'CATTARAN',
    },
    {
        CITY: 'SOLANA',
        BARANGAY: 'CENTRO NORTHEAST (POB.)',
    },
    {
        CITY: 'SOLANA',
        BARANGAY: 'CENTRO NORTHWEST (POB.)',
    },
    {
        CITY: 'SOLANA',
        BARANGAY: 'CENTRO SOUTHEAST (POB.)',
    },
    {
        CITY: 'SOLANA',
        BARANGAY: 'CENTRO SOUTHWEST (POB.)',
    },
    {
        CITY: 'SOLANA',
        BARANGAY: 'DASSUN',
    },
    {
        CITY: 'SOLANA',
        BARANGAY: 'FURAGUI',
    },
    {
        CITY: 'SOLANA',
        BARANGAY: 'GADU',
    },
    {
        CITY: 'SOLANA',
        BARANGAY: 'GEN. EULOGIO BALAO',
    },
    {
        CITY: 'SOLANA',
        BARANGAY: 'IRAGA',
    },
    {
        CITY: 'SOLANA',
        BARANGAY: 'LANNA',
    },
    {
        CITY: 'SOLANA',
        BARANGAY: 'LANNIG',
    },
    {
        CITY: 'SOLANA',
        BARANGAY: 'LINGU',
    },
    {
        CITY: 'SOLANA',
        BARANGAY: 'MADDARULUG (SANTO DOMINGO)',
    },
    {
        CITY: 'SOLANA',
        BARANGAY: 'MAGUIRIG',
    },
    {
        CITY: 'SOLANA',
        BARANGAY: 'MALALAM-MALACABIBI',
    },
    {
        CITY: 'SOLANA',
        BARANGAY: 'NABBOTUAN',
    },
    {
        CITY: 'SOLANA',
        BARANGAY: 'NANGALISAN',
    },
    {
        CITY: 'SOLANA',
        BARANGAY: 'NATAPPIAN EAST',
    },
    {
        CITY: 'SOLANA',
        BARANGAY: 'NATAPPIAN WEST',
    },
    {
        CITY: 'SOLANA',
        BARANGAY: 'PADUL',
    },
    {
        CITY: 'SOLANA',
        BARANGAY: 'PALAO',
    },
    {
        CITY: 'SOLANA',
        BARANGAY: 'PARUG-PARUG',
    },
    {
        CITY: 'SOLANA',
        BARANGAY: 'PATAYA',
    },
    {
        CITY: 'SOLANA',
        BARANGAY: 'SAMPAGUITA',
    },
    {
        CITY: 'SOLANA',
        BARANGAY: 'UBONG',
    },
    {
        CITY: 'TUAO',
        BARANGAY: 'ACCUSILIAN',
    },
    {
        CITY: 'TUAO',
        BARANGAY: 'ALABIAO',
    },
    {
        CITY: 'TUAO',
        BARANGAY: 'ALABUG',
    },
    {
        CITY: 'TUAO',
        BARANGAY: 'ANGANG',
    },
    {
        CITY: 'TUAO',
        BARANGAY: 'BAGUMBAYAN',
    },
    {
        CITY: 'TUAO',
        BARANGAY: 'BALAGAO',
    },
    {
        CITY: 'TUAO',
        BARANGAY: 'BARANCUAG',
    },
    {
        CITY: 'TUAO',
        BARANGAY: 'BATTUNG',
    },
    {
        CITY: 'TUAO',
        BARANGAY: 'BICOK',
    },
    {
        CITY: 'TUAO',
        BARANGAY: 'BUGNAY',
    },
    {
        CITY: 'TUAO',
        BARANGAY: 'CAGUMITAN',
    },
    {
        CITY: 'TUAO',
        BARANGAY: 'CATO',
    },
    {
        CITY: 'TUAO',
        BARANGAY: 'CULONG',
    },
    {
        CITY: 'TUAO',
        BARANGAY: 'DAGUPAN',
    },
    {
        CITY: 'TUAO',
        BARANGAY: 'FUGU',
    },
    {
        CITY: 'TUAO',
        BARANGAY: 'LAKAMBINI',
    },
    {
        CITY: 'TUAO',
        BARANGAY: 'LALLAYUG',
    },
    {
        CITY: 'TUAO',
        BARANGAY: 'MALALINTA',
    },
    {
        CITY: 'TUAO',
        BARANGAY: 'MALUMIN',
    },
    {
        CITY: 'TUAO',
        BARANGAY: 'MAMBACAG',
    },
    {
        CITY: 'TUAO',
        BARANGAY: 'MUNGO',
    },
    {
        CITY: 'TUAO',
        BARANGAY: 'NARUANGAN',
    },
    {
        CITY: 'TUAO',
        BARANGAY: 'PALCA',
    },
    {
        CITY: 'TUAO',
        BARANGAY: 'PATA',
    },
    {
        CITY: 'TUAO',
        BARANGAY: 'POBLACION I (WARD I CENTRO)',
    },
    {
        CITY: 'TUAO',
        BARANGAY: 'POBLACION II (WARD II CENTRO)',
    },
    {
        CITY: 'TUAO',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'TUAO',
        BARANGAY: 'SAN LUIS (GURENGAD)',
    },
    {
        CITY: 'TUAO',
        BARANGAY: 'SAN VICENTE (MALEG)',
    },
    {
        CITY: 'TUAO',
        BARANGAY: 'SANTO TOMAS',
    },
    {
        CITY: 'TUAO',
        BARANGAY: 'TARIBUBU',
    },
    {
        CITY: 'TUAO',
        BARANGAY: 'VILLA LAIDA',
    },
    {
        CITY: 'TUGUEGARAO',
        BARANGAY: 'ANNAFUNAN EAST',
    },
    {
        CITY: 'TUGUEGARAO',
        BARANGAY: 'ANNAFUNAN WEST',
    },
    {
        CITY: 'TUGUEGARAO',
        BARANGAY: 'ATULAYAN NORTE',
    },
    {
        CITY: 'TUGUEGARAO',
        BARANGAY: 'ATULAYAN SUR',
    },
    {
        CITY: 'TUGUEGARAO',
        BARANGAY: 'BAGAY',
    },
    {
        CITY: 'TUGUEGARAO',
        BARANGAY: 'BUNTUN',
    },
    {
        CITY: 'TUGUEGARAO',
        BARANGAY: 'CAGGAY',
    },
    {
        CITY: 'TUGUEGARAO',
        BARANGAY: 'CAPATAN',
    },
    {
        CITY: 'TUGUEGARAO',
        BARANGAY: 'CARIG',
    },
    {
        CITY: 'TUGUEGARAO',
        BARANGAY: 'CARITAN CENTRO',
    },
    {
        CITY: 'TUGUEGARAO',
        BARANGAY: 'CARITAN NORTE',
    },
    {
        CITY: 'TUGUEGARAO',
        BARANGAY: 'CARITAN SUR',
    },
    {
        CITY: 'TUGUEGARAO',
        BARANGAY: 'CATAGGAMAN NUEVO',
    },
    {
        CITY: 'TUGUEGARAO',
        BARANGAY: 'CATAGGAMAN PARDO',
    },
    {
        CITY: 'TUGUEGARAO',
        BARANGAY: 'CATAGGAMAN VIEJO',
    },
    {
        CITY: 'TUGUEGARAO',
        BARANGAY: 'CENTRO 1 (POB.)',
    },
    {
        CITY: 'TUGUEGARAO',
        BARANGAY: 'CENTRO 10 (POB.)',
    },
    {
        CITY: 'TUGUEGARAO',
        BARANGAY: 'CENTRO 11 (POB.)',
    },
    {
        CITY: 'TUGUEGARAO',
        BARANGAY: 'CENTRO 12 (POB.)',
    },
    {
        CITY: 'TUGUEGARAO',
        BARANGAY: 'CENTRO 2 (POB.)',
    },
    {
        CITY: 'TUGUEGARAO',
        BARANGAY: 'CENTRO 3 (POB.)',
    },
    {
        CITY: 'TUGUEGARAO',
        BARANGAY: 'CENTRO 4 (POB.)',
    },
    {
        CITY: 'TUGUEGARAO',
        BARANGAY: 'CENTRO 5 (POB.)',
    },
    {
        CITY: 'TUGUEGARAO',
        BARANGAY: 'CENTRO 6 (POB.)',
    },
    {
        CITY: 'TUGUEGARAO',
        BARANGAY: 'CENTRO 7 (POB.)',
    },
    {
        CITY: 'TUGUEGARAO',
        BARANGAY: 'CENTRO 8 (POB.)',
    },
    {
        CITY: 'TUGUEGARAO',
        BARANGAY: 'CENTRO 9 (POB.)',
    },
    {
        CITY: 'TUGUEGARAO',
        BARANGAY: 'DADDA',
    },
    {
        CITY: 'TUGUEGARAO',
        BARANGAY: 'GOSI NORTE',
    },
    {
        CITY: 'TUGUEGARAO',
        BARANGAY: 'GOSI SUR',
    },
    {
        CITY: 'TUGUEGARAO',
        BARANGAY: 'LARION ALTO',
    },
    {
        CITY: 'TUGUEGARAO',
        BARANGAY: 'LARION BAJO',
    },
    {
        CITY: 'TUGUEGARAO',
        BARANGAY: 'LEONARDA',
    },
    {
        CITY: 'TUGUEGARAO',
        BARANGAY: 'LIBAG NORTE',
    },
    {
        CITY: 'TUGUEGARAO',
        BARANGAY: 'LIBAG SUR',
    },
    {
        CITY: 'TUGUEGARAO',
        BARANGAY: 'LINAO EAST',
    },
    {
        CITY: 'TUGUEGARAO',
        BARANGAY: 'LINAO NORTE',
    },
    {
        CITY: 'TUGUEGARAO',
        BARANGAY: 'LINAO WEST',
    },
    {
        CITY: 'TUGUEGARAO',
        BARANGAY: 'NAMBBALAN NORTE',
    },
    {
        CITY: 'TUGUEGARAO',
        BARANGAY: 'NAMBBALAN SUR',
    },
    {
        CITY: 'TUGUEGARAO',
        BARANGAY: 'PALLUA NORTE',
    },
    {
        CITY: 'TUGUEGARAO',
        BARANGAY: 'PALLUA SUR',
    },
    {
        CITY: 'TUGUEGARAO',
        BARANGAY: 'PENGUE (PENGUE-RUYU)',
    },
    {
        CITY: 'TUGUEGARAO',
        BARANGAY: 'REYES',
    },
    {
        CITY: 'TUGUEGARAO',
        BARANGAY: 'SAN GABRIEL',
    },
    {
        CITY: 'TUGUEGARAO',
        BARANGAY: 'TAGGA',
    },
    {
        CITY: 'TUGUEGARAO',
        BARANGAY: 'TANZA',
    },
    {
        CITY: 'TUGUEGARAO',
        BARANGAY: 'UGAC NORTE',
    },
    {
        CITY: 'TUGUEGARAO',
        BARANGAY: 'UGAC SUR',
    },
    {
        CITY: 'ALFONSO-CASTANEDA',
        BARANGAY: 'ABUYO',
    },
    {
        CITY: 'ALFONSO-CASTANEDA',
        BARANGAY: 'GALINTUJA',
    },
    {
        CITY: 'ALFONSO-CASTANEDA',
        BARANGAY: 'LUBLUB (POB.)',
    },
    {
        CITY: 'ALFONSO-CASTANEDA',
        BARANGAY: 'PELAWAY',
    },
    {
        CITY: 'AMBAGUIO',
        BARANGAY: 'AMMUEG',
    },
    {
        CITY: 'AMBAGUIO',
        BARANGAY: 'CAMANDAG',
    },
    {
        CITY: 'AMBAGUIO',
        BARANGAY: 'DULLI',
    },
    {
        CITY: 'AMBAGUIO',
        BARANGAY: 'LABANG',
    },
    {
        CITY: 'AMBAGUIO',
        BARANGAY: 'NAPO',
    },
    {
        CITY: 'AMBAGUIO',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'AMBAGUIO',
        BARANGAY: 'SALINGSINGAN',
    },
    {
        CITY: 'AMBAGUIO',
        BARANGAY: 'TIBLAC',
    },
    {
        CITY: 'ARITAO',
        BARANGAY: 'ANAYO',
    },
    {
        CITY: 'ARITAO',
        BARANGAY: 'BAAN',
    },
    {
        CITY: 'ARITAO',
        BARANGAY: 'BALITE',
    },
    {
        CITY: 'ARITAO',
        BARANGAY: 'BANGANAN',
    },
    {
        CITY: 'ARITAO',
        BARANGAY: 'BETI',
    },
    {
        CITY: 'ARITAO',
        BARANGAY: 'BONE NORTH',
    },
    {
        CITY: 'ARITAO',
        BARANGAY: 'BONE SOUTH',
    },
    {
        CITY: 'ARITAO',
        BARANGAY: 'CALITLITAN',
    },
    {
        CITY: 'ARITAO',
        BARANGAY: 'CANABUAN',
    },
    {
        CITY: 'ARITAO',
        BARANGAY: 'CANAREM',
    },
    {
        CITY: 'ARITAO',
        BARANGAY: 'COMON',
    },
    {
        CITY: 'ARITAO',
        BARANGAY: 'CUTAR',
    },
    {
        CITY: 'ARITAO',
        BARANGAY: 'DARAPIDAP',
    },
    {
        CITY: 'ARITAO',
        BARANGAY: 'KIRANG',
    },
    {
        CITY: 'ARITAO',
        BARANGAY: 'LATAR-NOCNOC-SAN FRANCISCO',
    },
    {
        CITY: 'ARITAO',
        BARANGAY: 'NAGCUARTELAN',
    },
    {
        CITY: 'ARITAO',
        BARANGAY: 'OCAO-CAPINIAAN',
    },
    {
        CITY: 'ARITAO',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'ARITAO',
        BARANGAY: 'SANTA CLARA',
    },
    {
        CITY: 'ARITAO',
        BARANGAY: 'TABUENG',
    },
    {
        CITY: 'ARITAO',
        BARANGAY: 'TUCANON',
    },
    {
        CITY: 'ARITAO',
        BARANGAY: 'YAWAY',
    },
    {
        CITY: 'BAGABAG',
        BARANGAY: 'BAKIR',
    },
    {
        CITY: 'BAGABAG',
        BARANGAY: 'BARETBET',
    },
    {
        CITY: 'BAGABAG',
        BARANGAY: 'CAREB',
    },
    {
        CITY: 'BAGABAG',
        BARANGAY: 'LANTAP',
    },
    {
        CITY: 'BAGABAG',
        BARANGAY: 'MURONG',
    },
    {
        CITY: 'BAGABAG',
        BARANGAY: 'NANGALISAN',
    },
    {
        CITY: 'BAGABAG',
        BARANGAY: 'PANIKI',
    },
    {
        CITY: 'BAGABAG',
        BARANGAY: 'POGONSINO',
    },
    {
        CITY: 'BAGABAG',
        BARANGAY: 'QUIRINO (POB.)',
    },
    {
        CITY: 'BAGABAG',
        BARANGAY: 'SAN GERONIMO (POB.)',
    },
    {
        CITY: 'BAGABAG',
        BARANGAY: 'SAN PEDRO (POB.)',
    },
    {
        CITY: 'BAGABAG',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'BAGABAG',
        BARANGAY: 'SANTA LUCIA',
    },
    {
        CITY: 'BAGABAG',
        BARANGAY: 'TUAO NORTH',
    },
    {
        CITY: 'BAGABAG',
        BARANGAY: 'TUAO SOUTH',
    },
    {
        CITY: 'BAGABAG',
        BARANGAY: 'VILLA COLOMA (POB.)',
    },
    {
        CITY: 'BAGABAG',
        BARANGAY: 'VILLAROS',
    },
    {
        CITY: 'BAMBANG',
        BARANGAY: 'ABIAN',
    },
    {
        CITY: 'BAMBANG',
        BARANGAY: 'ABINGANAN',
    },
    {
        CITY: 'BAMBANG',
        BARANGAY: 'ALIAGA',
    },
    {
        CITY: 'BAMBANG',
        BARANGAY: 'ALMAGUER NORTH',
    },
    {
        CITY: 'BAMBANG',
        BARANGAY: 'ALMAGUER SOUTH',
    },
    {
        CITY: 'BAMBANG',
        BARANGAY: 'BANGGOT (POB.)',
    },
    {
        CITY: 'BAMBANG',
        BARANGAY: 'BARAT',
    },
    {
        CITY: 'BAMBANG',
        BARANGAY: 'BUAG (POB.)',
    },
    {
        CITY: 'BAMBANG',
        BARANGAY: 'CALAOCAN (POB.)',
    },
    {
        CITY: 'BAMBANG',
        BARANGAY: 'DULLAO',
    },
    {
        CITY: 'BAMBANG',
        BARANGAY: 'HOMESTEAD',
    },
    {
        CITY: 'BAMBANG',
        BARANGAY: 'INDIANA',
    },
    {
        CITY: 'BAMBANG',
        BARANGAY: 'MABUSLO',
    },
    {
        CITY: 'BAMBANG',
        BARANGAY: 'MACATE',
    },
    {
        CITY: 'BAMBANG',
        BARANGAY: 'MAGSAYSAY HILLS',
    },
    {
        CITY: 'BAMBANG',
        BARANGAY: 'MANAMTAM',
    },
    {
        CITY: 'BAMBANG',
        BARANGAY: 'MAUAN',
    },
    {
        CITY: 'BAMBANG',
        BARANGAY: 'PALLAS',
    },
    {
        CITY: 'BAMBANG',
        BARANGAY: 'SALINAS',
    },
    {
        CITY: 'BAMBANG',
        BARANGAY: 'SAN ANTONIO NORTH',
    },
    {
        CITY: 'BAMBANG',
        BARANGAY: 'SAN ANTONIO SOUTH',
    },
    {
        CITY: 'BAMBANG',
        BARANGAY: 'SAN FERNANDO',
    },
    {
        CITY: 'BAMBANG',
        BARANGAY: 'SAN LEONARDO',
    },
    {
        CITY: 'BAMBANG',
        BARANGAY: 'SANTO DOMINGO (TABANGAN)',
    },
    {
        CITY: 'BAMBANG',
        BARANGAY: 'SANTO DOMINGO WEST',
    },
    {
        CITY: 'BAYOMBONG',
        BARANGAY: 'BANSING',
    },
    {
        CITY: 'BAYOMBONG',
        BARANGAY: 'BONFAL EAST',
    },
    {
        CITY: 'BAYOMBONG',
        BARANGAY: 'BONFAL PROPER',
    },
    {
        CITY: 'BAYOMBONG',
        BARANGAY: 'BONFAL WEST',
    },
    {
        CITY: 'BAYOMBONG',
        BARANGAY: 'BUENAVISTA (VISTA HILLS)',
    },
    {
        CITY: 'BAYOMBONG',
        BARANGAY: 'BUSILAC',
    },
    {
        CITY: 'BAYOMBONG',
        BARANGAY: 'CABUAAN',
    },
    {
        CITY: 'BAYOMBONG',
        BARANGAY: 'CASAT',
    },
    {
        CITY: 'BAYOMBONG',
        BARANGAY: 'DISTRICT III POB. (DON M. PEREZ)',
    },
    {
        CITY: 'BAYOMBONG',
        BARANGAY: 'DISTRICT IV (POB.)',
    },
    {
        CITY: 'BAYOMBONG',
        BARANGAY: 'DON DOMINGO MADDELA POB. (DISTRICT I)',
    },
    {
        CITY: 'BAYOMBONG',
        BARANGAY: 'DON MARIANO MARCOS',
    },
    {
        CITY: 'BAYOMBONG',
        BARANGAY: 'DON TOMAS MADDELA POB. (DISTRICT II)',
    },
    {
        CITY: 'BAYOMBONG',
        BARANGAY: 'IPIL-CUNEG',
    },
    {
        CITY: 'BAYOMBONG',
        BARANGAY: 'LA TORRE NORTH',
    },
    {
        CITY: 'BAYOMBONG',
        BARANGAY: 'LA TORRE SOUTH',
    },
    {
        CITY: 'BAYOMBONG',
        BARANGAY: 'LUYANG',
    },
    {
        CITY: 'BAYOMBONG',
        BARANGAY: 'MAGAPUY',
    },
    {
        CITY: 'BAYOMBONG',
        BARANGAY: 'MAGSAYSAY',
    },
    {
        CITY: 'BAYOMBONG',
        BARANGAY: 'MASOC',
    },
    {
        CITY: 'BAYOMBONG',
        BARANGAY: 'PAITAN',
    },
    {
        CITY: 'BAYOMBONG',
        BARANGAY: 'SALVACION',
    },
    {
        CITY: 'BAYOMBONG',
        BARANGAY: 'SAN NICOLAS NORTH (LUYANG)',
    },
    {
        CITY: 'BAYOMBONG',
        BARANGAY: 'SANTA ROSA',
    },
    {
        CITY: 'BAYOMBONG',
        BARANGAY: 'VISTA ALEGRE (B. BARINGIN)',
    },
    {
        CITY: 'DIADI',
        BARANGAY: 'AMPAKLING',
    },
    {
        CITY: 'DIADI',
        BARANGAY: 'ARWAS',
    },
    {
        CITY: 'DIADI',
        BARANGAY: 'BALETE',
    },
    {
        CITY: 'DIADI',
        BARANGAY: 'BUGNAY',
    },
    {
        CITY: 'DIADI',
        BARANGAY: 'BUTAO',
    },
    {
        CITY: 'DIADI',
        BARANGAY: 'DECABACAN',
    },
    {
        CITY: 'DIADI',
        BARANGAY: 'DURUAROG',
    },
    {
        CITY: 'DIADI',
        BARANGAY: 'ESCOTING',
    },
    {
        CITY: 'DIADI',
        BARANGAY: 'LANGCA',
    },
    {
        CITY: 'DIADI',
        BARANGAY: 'LURAD',
    },
    {
        CITY: 'DIADI',
        BARANGAY: 'NAGSABARAN',
    },
    {
        CITY: 'DIADI',
        BARANGAY: 'NAMAMPARAN',
    },
    {
        CITY: 'DIADI',
        BARANGAY: 'PINYA',
    },
    {
        CITY: 'DIADI',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'DIADI',
        BARANGAY: 'ROSARIO',
    },
    {
        CITY: 'DIADI',
        BARANGAY: 'SAN LUIS',
    },
    {
        CITY: 'DIADI',
        BARANGAY: 'SAN PABLO',
    },
    {
        CITY: 'DIADI',
        BARANGAY: 'VILLA AURORA',
    },
    {
        CITY: 'DIADI',
        BARANGAY: 'VILLA FLORENTINO',
    },
    {
        CITY: 'DUPAX-DEL-NORTE',
        BARANGAY: 'BELANCE',
    },
    {
        CITY: 'DUPAX-DEL-NORTE',
        BARANGAY: 'BINNUANGAN',
    },
    {
        CITY: 'DUPAX-DEL-NORTE',
        BARANGAY: 'BITNONG',
    },
    {
        CITY: 'DUPAX-DEL-NORTE',
        BARANGAY: 'BULALA',
    },
    {
        CITY: 'DUPAX-DEL-NORTE',
        BARANGAY: 'INABAN',
    },
    {
        CITY: 'DUPAX-DEL-NORTE',
        BARANGAY: 'INEANGAN',
    },
    {
        CITY: 'DUPAX-DEL-NORTE',
        BARANGAY: 'LAMO',
    },
    {
        CITY: 'DUPAX-DEL-NORTE',
        BARANGAY: 'MABASA',
    },
    {
        CITY: 'DUPAX-DEL-NORTE',
        BARANGAY: 'MACABENGA',
    },
    {
        CITY: 'DUPAX-DEL-NORTE',
        BARANGAY: 'MALASIN (POB.)',
    },
    {
        CITY: 'DUPAX-DEL-NORTE',
        BARANGAY: 'MUNGUIA',
    },
    {
        CITY: 'DUPAX-DEL-NORTE',
        BARANGAY: 'NEW GUMIAD',
    },
    {
        CITY: 'DUPAX-DEL-NORTE',
        BARANGAY: 'OYAO',
    },
    {
        CITY: 'DUPAX-DEL-NORTE',
        BARANGAY: 'PARAI',
    },
    {
        CITY: 'DUPAX-DEL-NORTE',
        BARANGAY: 'YABBI',
    },
    {
        CITY: 'DUPAX-DEL-SUR',
        BARANGAY: 'ABACA',
    },
    {
        CITY: 'DUPAX-DEL-SUR',
        BARANGAY: 'BAGUMBAYAN',
    },
    {
        CITY: 'DUPAX-DEL-SUR',
        BARANGAY: 'BALSAIN',
    },
    {
        CITY: 'DUPAX-DEL-SUR',
        BARANGAY: 'BANILA',
    },
    {
        CITY: 'DUPAX-DEL-SUR',
        BARANGAY: 'BIRUK',
    },
    {
        CITY: 'DUPAX-DEL-SUR',
        BARANGAY: 'CANABAY',
    },
    {
        CITY: 'DUPAX-DEL-SUR',
        BARANGAY: 'CAROLOTAN',
    },
    {
        CITY: 'DUPAX-DEL-SUR',
        BARANGAY: 'DOMANG',
    },
    {
        CITY: 'DUPAX-DEL-SUR',
        BARANGAY: 'DOPAJ',
    },
    {
        CITY: 'DUPAX-DEL-SUR',
        BARANGAY: 'GABUT',
    },
    {
        CITY: 'DUPAX-DEL-SUR',
        BARANGAY: 'GANAO (LINGAD)',
    },
    {
        CITY: 'DUPAX-DEL-SUR',
        BARANGAY: 'KIMBUTAN',
    },
    {
        CITY: 'DUPAX-DEL-SUR',
        BARANGAY: 'KINABUAN',
    },
    {
        CITY: 'DUPAX-DEL-SUR',
        BARANGAY: 'LUKIDNON',
    },
    {
        CITY: 'DUPAX-DEL-SUR',
        BARANGAY: 'MANGAYANG',
    },
    {
        CITY: 'DUPAX-DEL-SUR',
        BARANGAY: 'PALABOTAN',
    },
    {
        CITY: 'DUPAX-DEL-SUR',
        BARANGAY: 'SANGUIT',
    },
    {
        CITY: 'DUPAX-DEL-SUR',
        BARANGAY: 'SANTA MARIA',
    },
    {
        CITY: 'DUPAX-DEL-SUR',
        BARANGAY: 'TALBEK',
    },
    {
        CITY: 'KASIBU',
        BARANGAY: 'ALIMIT',
    },
    {
        CITY: 'KASIBU',
        BARANGAY: 'ALLOY',
    },
    {
        CITY: 'KASIBU',
        BARANGAY: 'ANTUTOT',
    },
    {
        CITY: 'KASIBU',
        BARANGAY: 'BILET',
    },
    {
        CITY: 'KASIBU',
        BARANGAY: 'BINOGAWAN',
    },
    {
        CITY: 'KASIBU',
        BARANGAY: 'BIYOY',
    },
    {
        CITY: 'KASIBU',
        BARANGAY: 'BUA',
    },
    {
        CITY: 'KASIBU',
        BARANGAY: 'CAMAMASI',
    },
    {
        CITY: 'KASIBU',
        BARANGAY: 'CAPISAAN',
    },
    {
        CITY: 'KASIBU',
        BARANGAY: 'CATARAWAN',
    },
    {
        CITY: 'KASIBU',
        BARANGAY: 'CORDON',
    },
    {
        CITY: 'KASIBU',
        BARANGAY: 'DIDIPIO',
    },
    {
        CITY: 'KASIBU',
        BARANGAY: 'DINE',
    },
    {
        CITY: 'KASIBU',
        BARANGAY: 'KAKIDUGUEN',
    },
    {
        CITY: 'KASIBU',
        BARANGAY: 'KONGKONG',
    },
    {
        CITY: 'KASIBU',
        BARANGAY: 'LUPA',
    },
    {
        CITY: 'KASIBU',
        BARANGAY: 'MACALONG',
    },
    {
        CITY: 'KASIBU',
        BARANGAY: 'MALABING',
    },
    {
        CITY: 'KASIBU',
        BARANGAY: 'MUTA',
    },
    {
        CITY: 'KASIBU',
        BARANGAY: 'NANTAWACAN',
    },
    {
        CITY: 'KASIBU',
        BARANGAY: 'PACQUET (ILONGOT RES.)',
    },
    {
        CITY: 'KASIBU',
        BARANGAY: 'PAO',
    },
    {
        CITY: 'KASIBU',
        BARANGAY: 'PAPAYA',
    },
    {
        CITY: 'KASIBU',
        BARANGAY: 'POBLACION (ALLOY)',
    },
    {
        CITY: 'KASIBU',
        BARANGAY: 'PUDI',
    },
    {
        CITY: 'KASIBU',
        BARANGAY: 'SEGUEM',
    },
    {
        CITY: 'KASIBU',
        BARANGAY: 'TADJI',
    },
    {
        CITY: 'KASIBU',
        BARANGAY: 'TOKOD',
    },
    {
        CITY: 'KASIBU',
        BARANGAY: 'WANGAL',
    },
    {
        CITY: 'KASIBU',
        BARANGAY: 'WATWAT',
    },
    {
        CITY: 'KAYAPA',
        BARANGAY: 'ACACIA',
    },
    {
        CITY: 'KAYAPA',
        BARANGAY: 'ALANG-SALACSAC',
    },
    {
        CITY: 'KAYAPA',
        BARANGAY: 'AMILONG LABENG',
    },
    {
        CITY: 'KAYAPA',
        BARANGAY: 'ANSIPSIP',
    },
    {
        CITY: 'KAYAPA',
        BARANGAY: 'BAAN',
    },
    {
        CITY: 'KAYAPA',
        BARANGAY: 'BABADI',
    },
    {
        CITY: 'KAYAPA',
        BARANGAY: 'BALANGABANG',
    },
    {
        CITY: 'KAYAPA',
        BARANGAY: 'BALETE',
    },
    {
        CITY: 'KAYAPA',
        BARANGAY: 'BANAO',
    },
    {
        CITY: 'KAYAPA',
        BARANGAY: 'BESONG',
    },
    {
        CITY: 'KAYAPA',
        BARANGAY: 'BINALIAN',
    },
    {
        CITY: 'KAYAPA',
        BARANGAY: 'BUYASYAS',
    },
    {
        CITY: 'KAYAPA',
        BARANGAY: 'CABALATAN-ALANG',
    },
    {
        CITY: 'KAYAPA',
        BARANGAY: 'CABANGLASAN',
    },
    {
        CITY: 'KAYAPA',
        BARANGAY: 'CABAYO',
    },
    {
        CITY: 'KAYAPA',
        BARANGAY: 'CASTILLO VILLAGE',
    },
    {
        CITY: 'KAYAPA',
        BARANGAY: 'KAYAPA PROPER EAST',
    },
    {
        CITY: 'KAYAPA',
        BARANGAY: 'KAYAPA PROPER WEST',
    },
    {
        CITY: 'KAYAPA',
        BARANGAY: 'LATBANG',
    },
    {
        CITY: 'KAYAPA',
        BARANGAY: 'LAWIGAN',
    },
    {
        CITY: 'KAYAPA',
        BARANGAY: 'MAPAYAO',
    },
    {
        CITY: 'KAYAPA',
        BARANGAY: 'NANSIAKAN',
    },
    {
        CITY: 'KAYAPA',
        BARANGAY: 'PAMPANG (POB.)',
    },
    {
        CITY: 'KAYAPA',
        BARANGAY: 'PANGAWAN',
    },
    {
        CITY: 'KAYAPA',
        BARANGAY: 'PINAYAG',
    },
    {
        CITY: 'KAYAPA',
        BARANGAY: 'PINGKIAN',
    },
    {
        CITY: 'KAYAPA',
        BARANGAY: 'SAN FABIAN',
    },
    {
        CITY: 'KAYAPA',
        BARANGAY: 'TALECABCAB',
    },
    {
        CITY: 'KAYAPA',
        BARANGAY: 'TIDANG VILLAGE',
    },
    {
        CITY: 'KAYAPA',
        BARANGAY: 'TUBONGAN',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'AURORA',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'BARESBES',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'BONIFACIO',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'BULIWAO',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'CALAOCAN',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'CALIAT (POB.)',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'DAGUPAN',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'DARUBBA',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'MAASIN',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'MADDIANGAT',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'NALUBBUNAN',
    },
    {
        CITY: 'QUEZON',
        BARANGAY: 'RUNRUNO',
    },
    {
        CITY: 'SANTA-FE',
        BARANGAY: 'ATBU',
    },
    {
        CITY: 'SANTA-FE',
        BARANGAY: 'BACNENG',
    },
    {
        CITY: 'SANTA-FE',
        BARANGAY: 'BALETE',
    },
    {
        CITY: 'SANTA-FE',
        BARANGAY: 'BALILING',
    },
    {
        CITY: 'SANTA-FE',
        BARANGAY: 'BANTINAN',
    },
    {
        CITY: 'SANTA-FE',
        BARANGAY: 'BARACBAC',
    },
    {
        CITY: 'SANTA-FE',
        BARANGAY: 'BUYASYAS',
    },
    {
        CITY: 'SANTA-FE',
        BARANGAY: 'CANABUAN',
    },
    {
        CITY: 'SANTA-FE',
        BARANGAY: 'IMUGAN',
    },
    {
        CITY: 'SANTA-FE',
        BARANGAY: 'MALICO',
    },
    {
        CITY: 'SANTA-FE',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'SANTA-FE',
        BARANGAY: 'SANTA ROSA',
    },
    {
        CITY: 'SANTA-FE',
        BARANGAY: 'SINAPAOAN',
    },
    {
        CITY: 'SANTA-FE',
        BARANGAY: 'TACTAC',
    },
    {
        CITY: 'SANTA-FE',
        BARANGAY: 'UNIB',
    },
    {
        CITY: 'SANTA-FE',
        BARANGAY: 'VILLA FLORES',
    },
    {
        CITY: 'SOLANO',
        BARANGAY: 'AGGUB',
    },
    {
        CITY: 'SOLANO',
        BARANGAY: 'BAGAHABAG',
    },
    {
        CITY: 'SOLANO',
        BARANGAY: 'BANGAAN',
    },
    {
        CITY: 'SOLANO',
        BARANGAY: 'BANGAR',
    },
    {
        CITY: 'SOLANO',
        BARANGAY: 'BASCARAN',
    },
    {
        CITY: 'SOLANO',
        BARANGAY: 'COMMUNAL',
    },
    {
        CITY: 'SOLANO',
        BARANGAY: 'CONCEPCION (CALALABANGAN)',
    },
    {
        CITY: 'SOLANO',
        BARANGAY: 'CURIFANG',
    },
    {
        CITY: 'SOLANO',
        BARANGAY: 'DADAP',
    },
    {
        CITY: 'SOLANO',
        BARANGAY: 'LACTAWAN',
    },
    {
        CITY: 'SOLANO',
        BARANGAY: 'OSMENA',
    },
    {
        CITY: 'SOLANO',
        BARANGAY: 'PILAR D. GALIMA',
    },
    {
        CITY: 'SOLANO',
        BARANGAY: 'POBLACION NORTH',
    },
    {
        CITY: 'SOLANO',
        BARANGAY: 'POBLACION SOUTH',
    },
    {
        CITY: 'SOLANO',
        BARANGAY: 'QUEZON',
    },
    {
        CITY: 'SOLANO',
        BARANGAY: 'QUIRINO',
    },
    {
        CITY: 'SOLANO',
        BARANGAY: 'ROXAS',
    },
    {
        CITY: 'SOLANO',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'SOLANO',
        BARANGAY: 'SAN LUIS',
    },
    {
        CITY: 'SOLANO',
        BARANGAY: 'TUCAL',
    },
    {
        CITY: 'SOLANO',
        BARANGAY: 'UDDIAWAN',
    },
    {
        CITY: 'SOLANO',
        BARANGAY: 'WACAL',
    },
    {
        CITY: 'VILLAVERDE',
        BARANGAY: 'BINTAWAN NORTE',
    },
    {
        CITY: 'VILLAVERDE',
        BARANGAY: 'BINTAWAN SUR',
    },
    {
        CITY: 'VILLAVERDE',
        BARANGAY: 'CABULUAN',
    },
    {
        CITY: 'VILLAVERDE',
        BARANGAY: 'IBUNG',
    },
    {
        CITY: 'VILLAVERDE',
        BARANGAY: 'NAGBITIN',
    },
    {
        CITY: 'VILLAVERDE',
        BARANGAY: 'OCAPON',
    },
    {
        CITY: 'VILLAVERDE',
        BARANGAY: 'PIEZA',
    },
    {
        CITY: 'VILLAVERDE',
        BARANGAY: 'POBLACION (TUROD)',
    },
    {
        CITY: 'VILLAVERDE',
        BARANGAY: 'SAWMILL',
    },
    {
        CITY: 'ANGADANAN',
        BARANGAY: 'ALLANGIGAN',
    },
    {
        CITY: 'ANGADANAN',
        BARANGAY: 'ANIOG',
    },
    {
        CITY: 'ANGADANAN',
        BARANGAY: 'BANIKET',
    },
    {
        CITY: 'ANGADANAN',
        BARANGAY: 'BANNAWAG',
    },
    {
        CITY: 'ANGADANAN',
        BARANGAY: 'BANTUG',
    },
    {
        CITY: 'ANGADANAN',
        BARANGAY: 'BARANGCUAG',
    },
    {
        CITY: 'ANGADANAN',
        BARANGAY: 'BAUI',
    },
    {
        CITY: 'ANGADANAN',
        BARANGAY: 'BONIFACIO',
    },
    {
        CITY: 'ANGADANAN',
        BARANGAY: 'BUENAVISTA',
    },
    {
        CITY: 'ANGADANAN',
        BARANGAY: 'CALABAYAN-MINANGA',
    },
    {
        CITY: 'ANGADANAN',
        BARANGAY: 'CALACCAB',
    },
    {
        CITY: 'ANGADANAN',
        BARANGAY: 'CALAOCAN',
    },
    {
        CITY: 'ANGADANAN',
        BARANGAY: 'CAMPANARIO',
    },
    {
        CITY: 'ANGADANAN',
        BARANGAY: 'CANANGAN',
    },
    {
        CITY: 'ANGADANAN',
        BARANGAY: 'CENTRO I (POB.)',
    },
    {
        CITY: 'ANGADANAN',
        BARANGAY: 'CENTRO II (POB.)',
    },
    {
        CITY: 'ANGADANAN',
        BARANGAY: 'CENTRO III (POB.)',
    },
    {
        CITY: 'ANGADANAN',
        BARANGAY: 'CONSULAR',
    },
    {
        CITY: 'ANGADANAN',
        BARANGAY: 'CUMU',
    },
    {
        CITY: 'ANGADANAN',
        BARANGAY: 'DALAKIP',
    },
    {
        CITY: 'ANGADANAN',
        BARANGAY: 'DALENAT',
    },
    {
        CITY: 'ANGADANAN',
        BARANGAY: 'DIPALUDA',
    },
    {
        CITY: 'ANGADANAN',
        BARANGAY: 'DUROC',
    },
    {
        CITY: 'ANGADANAN',
        BARANGAY: 'ESPERANZA',
    },
    {
        CITY: 'ANGADANAN',
        BARANGAY: 'FUGARU',
    },
    {
        CITY: 'ANGADANAN',
        BARANGAY: 'INGUD NORTE',
    },
    {
        CITY: 'ANGADANAN',
        BARANGAY: 'INGUD SUR',
    },
    {
        CITY: 'ANGADANAN',
        BARANGAY: 'KALUSUTAN',
    },
    {
        CITY: 'ANGADANAN',
        BARANGAY: 'LA SUERTE',
    },
    {
        CITY: 'ANGADANAN',
        BARANGAY: 'LIWLIWA',
    },
    {
        CITY: 'ANGADANAN',
        BARANGAY: 'LOMBOY',
    },
    {
        CITY: 'ANGADANAN',
        BARANGAY: 'LORIA',
    },
    {
        CITY: 'ANGADANAN',
        BARANGAY: 'LOURDES (EL ESCANO)',
    },
    {
        CITY: 'ANGADANAN',
        BARANGAY: 'MABUHAY',
    },
    {
        CITY: 'ANGADANAN',
        BARANGAY: 'MACALAUAT',
    },
    {
        CITY: 'ANGADANAN',
        BARANGAY: 'MACANIAO',
    },
    {
        CITY: 'ANGADANAN',
        BARANGAY: 'MALANNAO',
    },
    {
        CITY: 'ANGADANAN',
        BARANGAY: 'MALASIN',
    },
    {
        CITY: 'ANGADANAN',
        BARANGAY: 'MANGANDINGAY',
    },
    {
        CITY: 'ANGADANAN',
        BARANGAY: 'MINANGA PROPER',
    },
    {
        CITY: 'ANGADANAN',
        BARANGAY: 'PAPPAT',
    },
    {
        CITY: 'ANGADANAN',
        BARANGAY: 'PISSAY',
    },
    {
        CITY: 'ANGADANAN',
        BARANGAY: 'RAMONA',
    },
    {
        CITY: 'ANGADANAN',
        BARANGAY: 'RANCHO BASSIT',
    },
    {
        CITY: 'ANGADANAN',
        BARANGAY: 'RANG-AYAN',
    },
    {
        CITY: 'ANGADANAN',
        BARANGAY: 'SALAY',
    },
    {
        CITY: 'ANGADANAN',
        BARANGAY: 'SAN AMBROCIO',
    },
    {
        CITY: 'ANGADANAN',
        BARANGAY: 'SAN GUILLERMO',
    },
    {
        CITY: 'ANGADANAN',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'ANGADANAN',
        BARANGAY: 'SAN MARCELO',
    },
    {
        CITY: 'ANGADANAN',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'ANGADANAN',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'ANGADANAN',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'ANGADANAN',
        BARANGAY: 'SARANAY',
    },
    {
        CITY: 'ANGADANAN',
        BARANGAY: 'SINABBARAN',
    },
    {
        CITY: 'ANGADANAN',
        BARANGAY: 'VICTORY',
    },
    {
        CITY: 'ANGADANAN',
        BARANGAY: 'VIGA',
    },
    {
        CITY: 'ANGADANAN',
        BARANGAY: 'VILLA DOMINGO',
    },
    {
        CITY: 'BENITO-SOLIVEN',
        BARANGAY: 'ANDABUEN',
    },
    {
        CITY: 'BENITO-SOLIVEN',
        BARANGAY: 'ARA',
    },
    {
        CITY: 'BENITO-SOLIVEN',
        BARANGAY: 'BALLIAO',
    },
    {
        CITY: 'BENITO-SOLIVEN',
        BARANGAY: 'BINOGTUNGAN',
    },
    {
        CITY: 'BENITO-SOLIVEN',
        BARANGAY: 'CAPUSERAN (CAPUROCAN)',
    },
    {
        CITY: 'BENITO-SOLIVEN',
        BARANGAY: 'DAGUPAN',
    },
    {
        CITY: 'BENITO-SOLIVEN',
        BARANGAY: 'DANIPA',
    },
    {
        CITY: 'BENITO-SOLIVEN',
        BARANGAY: 'DISTRICT I (POB.)',
    },
    {
        CITY: 'BENITO-SOLIVEN',
        BARANGAY: 'DISTRICT II (POB.)',
    },
    {
        CITY: 'BENITO-SOLIVEN',
        BARANGAY: 'GOMEZ',
    },
    {
        CITY: 'BENITO-SOLIVEN',
        BARANGAY: 'GUILINGAN',
    },
    {
        CITY: 'BENITO-SOLIVEN',
        BARANGAY: 'LA SALETTE',
    },
    {
        CITY: 'BENITO-SOLIVEN',
        BARANGAY: 'LUCBAN',
    },
    {
        CITY: 'BENITO-SOLIVEN',
        BARANGAY: 'MAKINDOL',
    },
    {
        CITY: 'BENITO-SOLIVEN',
        BARANGAY: 'MALUNO NORTE',
    },
    {
        CITY: 'BENITO-SOLIVEN',
        BARANGAY: 'MALUNO SUR',
    },
    {
        CITY: 'BENITO-SOLIVEN',
        BARANGAY: 'NACALMA',
    },
    {
        CITY: 'BENITO-SOLIVEN',
        BARANGAY: 'NEW MAGSAYSAY',
    },
    {
        CITY: 'BENITO-SOLIVEN',
        BARANGAY: 'PLACER',
    },
    {
        CITY: 'BENITO-SOLIVEN',
        BARANGAY: 'PUNIT',
    },
    {
        CITY: 'BENITO-SOLIVEN',
        BARANGAY: 'SAN CARLOS',
    },
    {
        CITY: 'BENITO-SOLIVEN',
        BARANGAY: 'SAN FRANCISCO',
    },
    {
        CITY: 'BENITO-SOLIVEN',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'BENITO-SOLIVEN',
        BARANGAY: 'SANTIAGO',
    },
    {
        CITY: 'BENITO-SOLIVEN',
        BARANGAY: 'SEVILLANA',
    },
    {
        CITY: 'BENITO-SOLIVEN',
        BARANGAY: 'SINIPIT',
    },
    {
        CITY: 'BENITO-SOLIVEN',
        BARANGAY: 'VILLALUZ',
    },
    {
        CITY: 'BENITO-SOLIVEN',
        BARANGAY: 'YEBAN NORTE',
    },
    {
        CITY: 'BENITO-SOLIVEN',
        BARANGAY: 'YEBAN SUR',
    },
    {
        CITY: 'CABAGAN',
        BARANGAY: 'AGGUB',
    },
    {
        CITY: 'CABAGAN',
        BARANGAY: 'ANAO',
    },
    {
        CITY: 'CABAGAN',
        BARANGAY: 'ANGANCASILIAN',
    },
    {
        CITY: 'CABAGAN',
        BARANGAY: 'BALASIG',
    },
    {
        CITY: 'CABAGAN',
        BARANGAY: 'CANSAN',
    },
    {
        CITY: 'CABAGAN',
        BARANGAY: 'CASIBARAG NORTE',
    },
    {
        CITY: 'CABAGAN',
        BARANGAY: 'CASIBARAG SUR',
    },
    {
        CITY: 'CABAGAN',
        BARANGAY: 'CATABAYUNGAN',
    },
    {
        CITY: 'CABAGAN',
        BARANGAY: 'CENTRO (POB.)',
    },
    {
        CITY: 'CABAGAN',
        BARANGAY: 'CUBAG',
    },
    {
        CITY: 'CABAGAN',
        BARANGAY: 'GARITA',
    },
    {
        CITY: 'CABAGAN',
        BARANGAY: 'LUQUILU',
    },
    {
        CITY: 'CABAGAN',
        BARANGAY: 'MABANGUG',
    },
    {
        CITY: 'CABAGAN',
        BARANGAY: 'MAGASSI',
    },
    {
        CITY: 'CABAGAN',
        BARANGAY: 'MASIPI EAST',
    },
    {
        CITY: 'CABAGAN',
        BARANGAY: 'MASIPI WEST',
    },
    {
        CITY: 'CABAGAN',
        BARANGAY: 'NGARAG',
    },
    {
        CITY: 'CABAGAN',
        BARANGAY: 'PILIG ABAJO',
    },
    {
        CITY: 'CABAGAN',
        BARANGAY: 'PILIG ALTO',
    },
    {
        CITY: 'CABAGAN',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'CABAGAN',
        BARANGAY: 'SAN BERNARDO',
    },
    {
        CITY: 'CABAGAN',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'CABAGAN',
        BARANGAY: 'SAUI',
    },
    {
        CITY: 'CABAGAN',
        BARANGAY: 'TALLAG',
    },
    {
        CITY: 'CABAGAN',
        BARANGAY: 'UGAD',
    },
    {
        CITY: 'CABAGAN',
        BARANGAY: 'UNION',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'ALICAOCAO',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'ALINAM',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'AMOBOCAN',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'ANDARAYAN',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'BACULOD',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'BARINGIN NORTE',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'BARINGIN SUR',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'BUENA SUERTE',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'BUGALLON',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'BUYON',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'CABARUAN',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'CABUGAO',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'CARABATAN BACARENO',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'CARABATAN CHICA',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'CARABATAN GRANDE',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'CARABATAN PUNTA',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'CASALATAN',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'CASSAP FUERA',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'CATALINA',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'CULALABAT',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'DABBURAB',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'DE VERA',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'DIANAO',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'DISIMURAY',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'DISTRICT I (POB.)',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'DISTRICT II (POB.)',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'DISTRICT III (POB.)',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'DUMINIT',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'FAUSTINO (SIPAY)',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'GAGABUTAN',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'GAPPAL',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'GUAYABAL',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'LABINAB',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'LINGLINGAY',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'MABANTAD',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'MALIGAYA',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'MANAOAG',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'MARABULIG I',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'MARABULIG II',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'MINANTE I',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'MINANTE II',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'NAGANACAN',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'NAGCAMPEGAN',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'NAGRUMBUAN',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'NUNGNUNGAN I',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'NUNGNUNGAN II',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'PINOMA',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'RIZAL',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'ROGUS',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'SAN FERMIN',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'SAN FRANCISCO',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'SAN LUIS',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'SAN PABLO (CASAP HACIENDA)',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'SANTA LUCIANA (DABURAB 2)',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'SANTA MARIA',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'SILLAWIT',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'SINIPPIL',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'TAGARAN',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'TURAYONG',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'UNION',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'VILLA CONCEPCION',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'VILLA LUNA',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'VILLAFLOR',
    },
    {
        CITY: 'CORDON',
        BARANGAY: 'AGUINALDO (RIZALUNA ESTE)',
    },
    {
        CITY: 'CORDON',
        BARANGAY: 'ANONANG (BALITOC)',
    },
    {
        CITY: 'CORDON',
        BARANGAY: 'ANONANG (BALITOC*)',
    },
    {
        CITY: 'CORDON',
        BARANGAY: 'CALIMATUROD',
    },
    {
        CITY: 'CORDON',
        BARANGAY: 'CAMARAO',
    },
    {
        CITY: 'CORDON',
        BARANGAY: 'CAPIRPIRIWAN',
    },
    {
        CITY: 'CORDON',
        BARANGAY: 'CAQUILINGAN (SAN LUIS)',
    },
    {
        CITY: 'CORDON',
        BARANGAY: 'DALLAO',
    },
    {
        CITY: 'CORDON',
        BARANGAY: 'GAYONG',
    },
    {
        CITY: 'CORDON',
        BARANGAY: 'LAUREL (CENTRO NORTE)',
    },
    {
        CITY: 'CORDON',
        BARANGAY: 'MAGSAYSAY (CENTRO SUR OESTE)',
    },
    {
        CITY: 'CORDON',
        BARANGAY: 'MALAPAT',
    },
    {
        CITY: 'CORDON',
        BARANGAY: 'OSMENA (CENTRO SUR ESTE)',
    },
    {
        CITY: 'CORDON',
        BARANGAY: 'QUEZON (CENTRO NORTE ESTE)',
    },
    {
        CITY: 'CORDON',
        BARANGAY: 'QUIRINO (MANASIN)',
    },
    {
        CITY: 'CORDON',
        BARANGAY: 'RIZALUNA (RIZALUNA OESTE)',
    },
    {
        CITY: 'CORDON',
        BARANGAY: 'ROXAS POB. (CENTRO SUR)',
    },
    {
        CITY: 'CORDON',
        BARANGAY: 'SAGAT',
    },
    {
        CITY: 'CORDON',
        BARANGAY: 'SAN JUAN (SAN JUAN ESTE)',
    },
    {
        CITY: 'CORDON',
        BARANGAY: 'TALIKTIK',
    },
    {
        CITY: 'CORDON',
        BARANGAY: 'TANGGAL',
    },
    {
        CITY: 'CORDON',
        BARANGAY: 'TARINSING',
    },
    {
        CITY: 'CORDON',
        BARANGAY: 'TUROD NORTE',
    },
    {
        CITY: 'CORDON',
        BARANGAY: 'TUROD SUR',
    },
    {
        CITY: 'CORDON',
        BARANGAY: 'VILLAMARZO',
    },
    {
        CITY: 'CORDON',
        BARANGAY: 'VILLAMIEMBAN',
    },
    {
        CITY: 'CORDON',
        BARANGAY: 'WIGAN',
    },
    {
        CITY: 'DELFIN-ALBANO',
        BARANGAY: 'AGA',
    },
    {
        CITY: 'DELFIN-ALBANO',
        BARANGAY: 'ANDARAYAN',
    },
    {
        CITY: 'DELFIN-ALBANO',
        BARANGAY: 'ANEG',
    },
    {
        CITY: 'DELFIN-ALBANO',
        BARANGAY: 'BAYABO',
    },
    {
        CITY: 'DELFIN-ALBANO',
        BARANGAY: 'CALINAOAN SUR',
    },
    {
        CITY: 'DELFIN-ALBANO',
        BARANGAY: 'CALOOCAN',
    },
    {
        CITY: 'DELFIN-ALBANO',
        BARANGAY: 'CAPITOL',
    },
    {
        CITY: 'DELFIN-ALBANO',
        BARANGAY: 'CARMENCITA',
    },
    {
        CITY: 'DELFIN-ALBANO',
        BARANGAY: 'CONCEPCION',
    },
    {
        CITY: 'DELFIN-ALBANO',
        BARANGAY: 'MAUI',
    },
    {
        CITY: 'DELFIN-ALBANO',
        BARANGAY: 'QUIBAL',
    },
    {
        CITY: 'DELFIN-ALBANO',
        BARANGAY: 'RAGAN ALMACEN',
    },
    {
        CITY: 'DELFIN-ALBANO',
        BARANGAY: 'RAGAN NORTE',
    },
    {
        CITY: 'DELFIN-ALBANO',
        BARANGAY: 'RAGAN SUR (POB.)',
    },
    {
        CITY: 'DELFIN-ALBANO',
        BARANGAY: 'RIZAL (RAGAN ALMACEN ALTO)',
    },
    {
        CITY: 'DELFIN-ALBANO',
        BARANGAY: 'SAN ANDRES',
    },
    {
        CITY: 'DELFIN-ALBANO',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'DELFIN-ALBANO',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'DELFIN-ALBANO',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'DELFIN-ALBANO',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'DELFIN-ALBANO',
        BARANGAY: 'SAN MACARIO',
    },
    {
        CITY: 'DELFIN-ALBANO',
        BARANGAY: 'SAN NICOLAS (FUSI)',
    },
    {
        CITY: 'DELFIN-ALBANO',
        BARANGAY: 'SAN PATRICIO',
    },
    {
        CITY: 'DELFIN-ALBANO',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'DELFIN-ALBANO',
        BARANGAY: 'SANTO ROSARIO',
    },
    {
        CITY: 'DELFIN-ALBANO',
        BARANGAY: 'SANTOR',
    },
    {
        CITY: 'DELFIN-ALBANO',
        BARANGAY: 'VILLA LUZ',
    },
    {
        CITY: 'DELFIN-ALBANO',
        BARANGAY: 'VILLA PEREDA',
    },
    {
        CITY: 'DELFIN-ALBANO',
        BARANGAY: 'VISITACION',
    },
    {
        CITY: 'ECHAGUE',
        BARANGAY: 'ANGOLUAN',
    },
    {
        CITY: 'ECHAGUE',
        BARANGAY: 'ANNAFUNAN',
    },
    {
        CITY: 'ECHAGUE',
        BARANGAY: 'ARABIAT',
    },
    {
        CITY: 'ECHAGUE',
        BARANGAY: 'AROMIN',
    },
    {
        CITY: 'ECHAGUE',
        BARANGAY: 'BABARAN',
    },
    {
        CITY: 'ECHAGUE',
        BARANGAY: 'BACRADAL',
    },
    {
        CITY: 'ECHAGUE',
        BARANGAY: 'BENGUET',
    },
    {
        CITY: 'ECHAGUE',
        BARANGAY: 'BUNEG',
    },
    {
        CITY: 'ECHAGUE',
        BARANGAY: 'BUSILELAO',
    },
    {
        CITY: 'ECHAGUE',
        BARANGAY: 'CABUGAO (POB.)',
    },
    {
        CITY: 'ECHAGUE',
        BARANGAY: 'CANIGUING',
    },
    {
        CITY: 'ECHAGUE',
        BARANGAY: 'CARULAY',
    },
    {
        CITY: 'ECHAGUE',
        BARANGAY: 'CASTILLO',
    },
    {
        CITY: 'ECHAGUE',
        BARANGAY: 'DAMMANG EAST',
    },
    {
        CITY: 'ECHAGUE',
        BARANGAY: 'DAMMANG WEST',
    },
    {
        CITY: 'ECHAGUE',
        BARANGAY: 'DIASAN',
    },
    {
        CITY: 'ECHAGUE',
        BARANGAY: 'DICARAOYAN',
    },
    {
        CITY: 'ECHAGUE',
        BARANGAY: 'DUGAYONG',
    },
    {
        CITY: 'ECHAGUE',
        BARANGAY: 'FUGU',
    },
    {
        CITY: 'ECHAGUE',
        BARANGAY: 'GARIT NORTE',
    },
    {
        CITY: 'ECHAGUE',
        BARANGAY: 'GARIT SUR',
    },
    {
        CITY: 'ECHAGUE',
        BARANGAY: 'GUCAB',
    },
    {
        CITY: 'ECHAGUE',
        BARANGAY: 'GUMBAUAN',
    },
    {
        CITY: 'ECHAGUE',
        BARANGAY: 'IPIL',
    },
    {
        CITY: 'ECHAGUE',
        BARANGAY: 'LIBERTAD',
    },
    {
        CITY: 'ECHAGUE',
        BARANGAY: 'MABBAYAD',
    },
    {
        CITY: 'ECHAGUE',
        BARANGAY: 'MABUHAY',
    },
    {
        CITY: 'ECHAGUE',
        BARANGAY: 'MADADAMIAN',
    },
    {
        CITY: 'ECHAGUE',
        BARANGAY: 'MAGLETICIA',
    },
    {
        CITY: 'ECHAGUE',
        BARANGAY: 'MALIBAGO',
    },
    {
        CITY: 'ECHAGUE',
        BARANGAY: 'MALIGAYA',
    },
    {
        CITY: 'ECHAGUE',
        BARANGAY: 'MALITAO',
    },
    {
        CITY: 'ECHAGUE',
        BARANGAY: 'NARRA',
    },
    {
        CITY: 'ECHAGUE',
        BARANGAY: 'NILUMISU',
    },
    {
        CITY: 'ECHAGUE',
        BARANGAY: 'PAG-ASA',
    },
    {
        CITY: 'ECHAGUE',
        BARANGAY: 'PANGAL NORTE',
    },
    {
        CITY: 'ECHAGUE',
        BARANGAY: 'PANGAL SUR',
    },
    {
        CITY: 'ECHAGUE',
        BARANGAY: 'RUMANG-AY',
    },
    {
        CITY: 'ECHAGUE',
        BARANGAY: 'SALAY',
    },
    {
        CITY: 'ECHAGUE',
        BARANGAY: 'SALVACION',
    },
    {
        CITY: 'ECHAGUE',
        BARANGAY: 'SAN ANTONIO MINIT',
    },
    {
        CITY: 'ECHAGUE',
        BARANGAY: 'SAN ANTONIO UGAD',
    },
    {
        CITY: 'ECHAGUE',
        BARANGAY: 'SAN CARLOS',
    },
    {
        CITY: 'ECHAGUE',
        BARANGAY: 'SAN FABIAN',
    },
    {
        CITY: 'ECHAGUE',
        BARANGAY: 'SAN FELIPE',
    },
    {
        CITY: 'ECHAGUE',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'ECHAGUE',
        BARANGAY: 'SAN MANUEL',
    },
    {
        CITY: 'ECHAGUE',
        BARANGAY: 'SAN MIGUEL',
    },
    {
        CITY: 'ECHAGUE',
        BARANGAY: 'SAN SALVADOR',
    },
    {
        CITY: 'ECHAGUE',
        BARANGAY: 'SANTA ANA',
    },
    {
        CITY: 'ECHAGUE',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'ECHAGUE',
        BARANGAY: 'SANTA MARIA',
    },
    {
        CITY: 'ECHAGUE',
        BARANGAY: 'SANTA MONICA',
    },
    {
        CITY: 'ECHAGUE',
        BARANGAY: 'SANTO DOMINGO',
    },
    {
        CITY: 'ECHAGUE',
        BARANGAY: 'SILAUAN NORTE (POB.)',
    },
    {
        CITY: 'ECHAGUE',
        BARANGAY: 'SILAUAN SUR (POB.)',
    },
    {
        CITY: 'ECHAGUE',
        BARANGAY: 'SINABBARAN',
    },
    {
        CITY: 'ECHAGUE',
        BARANGAY: 'SOYUNG',
    },
    {
        CITY: 'ECHAGUE',
        BARANGAY: 'TAGGAPPAN',
    },
    {
        CITY: 'ECHAGUE',
        BARANGAY: 'TUGUEGARAO',
    },
    {
        CITY: 'ECHAGUE',
        BARANGAY: 'VILLA CAMPO',
    },
    {
        CITY: 'ECHAGUE',
        BARANGAY: 'VILLA FERMIN',
    },
    {
        CITY: 'ECHAGUE',
        BARANGAY: 'VILLA REY',
    },
    {
        CITY: 'ECHAGUE',
        BARANGAY: 'VILLA VICTORIA',
    },
    {
        CITY: 'GAMU',
        BARANGAY: 'BARCOLAN',
    },
    {
        CITY: 'GAMU',
        BARANGAY: 'BUENAVISTA',
    },
    {
        CITY: 'GAMU',
        BARANGAY: 'DAMMAO',
    },
    {
        CITY: 'GAMU',
        BARANGAY: 'DISTRICT I (POB.)',
    },
    {
        CITY: 'GAMU',
        BARANGAY: 'DISTRICT II (POB.)',
    },
    {
        CITY: 'GAMU',
        BARANGAY: 'DISTRICT III (POB.)',
    },
    {
        CITY: 'GAMU',
        BARANGAY: 'FURAO',
    },
    {
        CITY: 'GAMU',
        BARANGAY: 'GUIBANG',
    },
    {
        CITY: 'GAMU',
        BARANGAY: 'LENZON',
    },
    {
        CITY: 'GAMU',
        BARANGAY: 'LINGLINGAY',
    },
    {
        CITY: 'GAMU',
        BARANGAY: 'MABINI',
    },
    {
        CITY: 'GAMU',
        BARANGAY: 'PINTOR',
    },
    {
        CITY: 'GAMU',
        BARANGAY: 'RIZAL',
    },
    {
        CITY: 'GAMU',
        BARANGAY: 'SONGSONG',
    },
    {
        CITY: 'GAMU',
        BARANGAY: 'UNION',
    },
    {
        CITY: 'GAMU',
        BARANGAY: 'UPI',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'AGGASIAN',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'ALIBAGU',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'ALLINGUIGAN 1ST',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'ALLINGUIGAN 2ND',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'ALLINGUIGAN 3RD',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'ARUSIP',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'BACULOD (POB.)',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'BAGONG SILANG',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'BAGUMBAYAN (POB.)',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'BALIGATAN',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'BALLACONG',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'BANGAG',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'BATONG-LABANG',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'BIGAO',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'CABANNUNGAN 1ST',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'CABANNUNGAN 2ND',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'CABESERIA 10 (LAPIGUI)',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'CABESERIA 14 AND 16 (CASILAGAN)',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'CABESERIA 17 AND 21 (SAN RAFAEL)',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'CABESERIA 19 (VILLA SUERTE)',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'CABESERIA 19 (VILLA SUERTE*)',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'CABESERIA 2 (DAPPAT)',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'CABESERIA 22 (SABLANG)',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'CABESERIA 23 (SAN FRANCISCO)',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'CABESERIA 23 (SAN FRANCISCO*)',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'CABESERIA 25 (STA. LUCIA)',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'CABESERIA 25 (STA. LUCIA*)',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'CABESERIA 27 (ABUAN)',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'CABESERIA 3 (SAN FERNANDO)',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'CABESERIA 4 (SAN MANUEL)',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'CABESERIA 5 (BARIBAD)',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'CABESERIA 6 & 24 (VILLA MARCOS)',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'CABESERIA 6 & 24 (VILLA MARCOS*)',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'CABESERIA 7 (NANGALISAN)',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'CABESERIA 9 AND 11 (CAPOGOTAN)',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'CADU',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'CALAMAGUI 1ST',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'CALAMAGUI 2ND',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'CAMUNATAN',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'CAPELLAN',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'CAPO',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'CARIKKIKAN NORTE',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'CARIKKIKAN SUR',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'CENTRO - SAN ANTONIO',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'CENTRO POBLACION',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'FUGU',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'FUYO',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'GAYONG-GAYONG NORTE',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'GAYONG-GAYONG SUR',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'GUINATAN',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'IMELDA BLISS VILLAGE',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'LULLUTAN',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'MALALAM',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'MALASIN (ANGELES)',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'MANARING',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'MANGCURAM',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'MARANA I',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'MARANA II',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'MARANA III',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'MINABANG',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'MORADO',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'NAGUILIAN NORTE',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'NAGUILIAN SUR',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'NAMNAMA',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'NANAGUAN',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'OSMENA (SINIPPIL)',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'PALIUEG',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'PASA',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'PILAR',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'QUIMALABASA',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'RANG-AYAN (BINTACAN)',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'RUGAO',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'SALINDINGAN',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'SAN ANDRES (ANGARILLA)',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'SAN FELIPE',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'SAN IGNACIO (CANAPI)',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'SAN LORENZO',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'SAN PABLO',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'SAN RODRIGO',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'SAN VICENTE (POB.)',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'SANTA BARBARA (POB.)',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'SANTA CATALINA',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'SANTA ISABEL NORTE',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'SANTA ISABEL SUR',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'SANTA MARIA (CABESERIA 8)',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'SANTA VICTORIA',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'SANTO TOMAS',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'SIFFU',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'SINDON BAYABO',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'SINDON MARIDE',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'SIPAY',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'TANGCUL',
    },
    {
        CITY: 'ILAGAN',
        BARANGAY: 'VILLA IMELDA (MAPLAS)',
    },
    {
        CITY: 'ALICIA',
        BARANGAY: 'AMISTAD',
    },
    {
        CITY: 'ALICIA',
        BARANGAY: 'ANTONINO (POB.)',
    },
    {
        CITY: 'ALICIA',
        BARANGAY: 'APANAY',
    },
    {
        CITY: 'ALICIA',
        BARANGAY: 'AURORA',
    },
    {
        CITY: 'ALICIA',
        BARANGAY: 'BAGNOS',
    },
    {
        CITY: 'ALICIA',
        BARANGAY: 'BAGONG SIKAT',
    },
    {
        CITY: 'ALICIA',
        BARANGAY: 'BANTUG-PETINES',
    },
    {
        CITY: 'ALICIA',
        BARANGAY: 'BONIFACIO',
    },
    {
        CITY: 'ALICIA',
        BARANGAY: 'BURGOS',
    },
    {
        CITY: 'ALICIA',
        BARANGAY: 'CALAOCAN (POB.)',
    },
    {
        CITY: 'ALICIA',
        BARANGAY: 'CALLAO',
    },
    {
        CITY: 'ALICIA',
        BARANGAY: 'DAGUPAN',
    },
    {
        CITY: 'ALICIA',
        BARANGAY: 'INANAMA',
    },
    {
        CITY: 'ALICIA',
        BARANGAY: 'LINGLINGAY',
    },
    {
        CITY: 'ALICIA',
        BARANGAY: 'M.H. DEL PILAR',
    },
    {
        CITY: 'ALICIA',
        BARANGAY: 'MABINI',
    },
    {
        CITY: 'ALICIA',
        BARANGAY: 'MAGSAYSAY (POB.)',
    },
    {
        CITY: 'ALICIA',
        BARANGAY: 'MATAAS NA KAHOY',
    },
    {
        CITY: 'ALICIA',
        BARANGAY: 'PADDAD',
    },
    {
        CITY: 'ALICIA',
        BARANGAY: 'RIZAL',
    },
    {
        CITY: 'ALICIA',
        BARANGAY: 'RIZALUNA',
    },
    {
        CITY: 'ALICIA',
        BARANGAY: 'SALVACION',
    },
    {
        CITY: 'ALICIA',
        BARANGAY: 'SAN ANTONIO (POB.)',
    },
    {
        CITY: 'ALICIA',
        BARANGAY: 'SAN FERNANDO',
    },
    {
        CITY: 'ALICIA',
        BARANGAY: 'SAN FRANCISCO',
    },
    {
        CITY: 'ALICIA',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'ALICIA',
        BARANGAY: 'SAN PABLO',
    },
    {
        CITY: 'ALICIA',
        BARANGAY: 'SAN PEDRO',
    },
    {
        CITY: 'ALICIA',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'ALICIA',
        BARANGAY: 'SANTA MARIA',
    },
    {
        CITY: 'ALICIA',
        BARANGAY: 'SANTO DOMINGO',
    },
    {
        CITY: 'ALICIA',
        BARANGAY: 'SANTO TOMAS',
    },
    {
        CITY: 'ALICIA',
        BARANGAY: 'VICTORIA',
    },
    {
        CITY: 'ALICIA',
        BARANGAY: 'ZAMORA',
    },
    {
        CITY: 'AURORA',
        BARANGAY: 'APIAT',
    },
    {
        CITY: 'AURORA',
        BARANGAY: 'BAGNOS',
    },
    {
        CITY: 'AURORA',
        BARANGAY: 'BAGONG TANZA',
    },
    {
        CITY: 'AURORA',
        BARANGAY: 'BALLESTEROS',
    },
    {
        CITY: 'AURORA',
        BARANGAY: 'BANNAGAO',
    },
    {
        CITY: 'AURORA',
        BARANGAY: 'BANNAWAG',
    },
    {
        CITY: 'AURORA',
        BARANGAY: 'BOLINAO',
    },
    {
        CITY: 'AURORA',
        BARANGAY: 'CAIPILAN',
    },
    {
        CITY: 'AURORA',
        BARANGAY: 'CAMARUNGGAYAN',
    },
    {
        CITY: 'AURORA',
        BARANGAY: 'DALIG-KALINGA',
    },
    {
        CITY: 'AURORA',
        BARANGAY: 'DIAMANTINA',
    },
    {
        CITY: 'AURORA',
        BARANGAY: 'DIVISORIA',
    },
    {
        CITY: 'AURORA',
        BARANGAY: 'ESPERANZA EAST',
    },
    {
        CITY: 'AURORA',
        BARANGAY: 'ESPERANZA WEST',
    },
    {
        CITY: 'AURORA',
        BARANGAY: 'KALABAZA',
    },
    {
        CITY: 'AURORA',
        BARANGAY: 'MACATAL',
    },
    {
        CITY: 'AURORA',
        BARANGAY: 'MALASIN',
    },
    {
        CITY: 'AURORA',
        BARANGAY: 'NAMPICUAN',
    },
    {
        CITY: 'AURORA',
        BARANGAY: 'PANECIEN',
    },
    {
        CITY: 'AURORA',
        BARANGAY: 'RIZALUNA (LAPUZ)',
    },
    {
        CITY: 'AURORA',
        BARANGAY: 'SAN ANDRES',
    },
    {
        CITY: 'AURORA',
        BARANGAY: 'SAN JOSE (POB.)',
    },
    {
        CITY: 'AURORA',
        BARANGAY: 'SAN JUAN (POB.)',
    },
    {
        CITY: 'AURORA',
        BARANGAY: 'SAN PEDRO-SAN PABLO (POB.)',
    },
    {
        CITY: 'AURORA',
        BARANGAY: 'SAN RAFAEL',
    },
    {
        CITY: 'AURORA',
        BARANGAY: 'SAN RAMON',
    },
    {
        CITY: 'AURORA',
        BARANGAY: 'SANTA RITA',
    },
    {
        CITY: 'AURORA',
        BARANGAY: 'SANTA ROSA',
    },
    {
        CITY: 'AURORA',
        BARANGAY: 'SARANAY',
    },
    {
        CITY: 'AURORA',
        BARANGAY: 'SILI',
    },
    {
        CITY: 'AURORA',
        BARANGAY: 'VICTORIA',
    },
    {
        CITY: 'AURORA',
        BARANGAY: 'VILLA FUGU',
    },
    {
        CITY: 'AURORA',
        BARANGAY: 'VILLA NUESA',
    },
    {
        CITY: 'BURGOS',
        BARANGAY: 'BACNOR EAST',
    },
    {
        CITY: 'BURGOS',
        BARANGAY: 'BACNOR WEST',
    },
    {
        CITY: 'BURGOS',
        BARANGAY: 'CALIGUIAN (POB.)',
    },
    {
        CITY: 'BURGOS',
        BARANGAY: 'CATABBAN',
    },
    {
        CITY: 'BURGOS',
        BARANGAY: 'CULLALABO DEL NORTE',
    },
    {
        CITY: 'BURGOS',
        BARANGAY: 'CULLALABO DEL SUR',
    },
    {
        CITY: 'BURGOS',
        BARANGAY: 'CULLALABO SAN ANTONIO',
    },
    {
        CITY: 'BURGOS',
        BARANGAY: 'DALIG',
    },
    {
        CITY: 'BURGOS',
        BARANGAY: 'MALASIN',
    },
    {
        CITY: 'BURGOS',
        BARANGAY: 'MASIGUN',
    },
    {
        CITY: 'BURGOS',
        BARANGAY: 'RANIAG',
    },
    {
        CITY: 'BURGOS',
        BARANGAY: 'SAN BONIFACIO',
    },
    {
        CITY: 'BURGOS',
        BARANGAY: 'SAN MIGUEL',
    },
    {
        CITY: 'BURGOS',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'CABATUAN',
        BARANGAY: 'CALAOCAN',
    },
    {
        CITY: 'CABATUAN',
        BARANGAY: 'CANAN',
    },
    {
        CITY: 'CABATUAN',
        BARANGAY: 'CENTRO (POB.)',
    },
    {
        CITY: 'CABATUAN',
        BARANGAY: 'CULING CENTRO',
    },
    {
        CITY: 'CABATUAN',
        BARANGAY: 'CULING EAST',
    },
    {
        CITY: 'CABATUAN',
        BARANGAY: 'CULING WEST',
    },
    {
        CITY: 'CABATUAN',
        BARANGAY: 'DEL CORPUZ',
    },
    {
        CITY: 'CABATUAN',
        BARANGAY: 'DEL PILAR',
    },
    {
        CITY: 'CABATUAN',
        BARANGAY: 'DIAMANTINA',
    },
    {
        CITY: 'CABATUAN',
        BARANGAY: 'LA PAZ',
    },
    {
        CITY: 'CABATUAN',
        BARANGAY: 'LUZON',
    },
    {
        CITY: 'CABATUAN',
        BARANGAY: 'MACALAOAT',
    },
    {
        CITY: 'CABATUAN',
        BARANGAY: 'MAGDALENA',
    },
    {
        CITY: 'CABATUAN',
        BARANGAY: 'MAGSAYSAY',
    },
    {
        CITY: 'CABATUAN',
        BARANGAY: 'NAMNAMA',
    },
    {
        CITY: 'CABATUAN',
        BARANGAY: 'NUEVA ERA',
    },
    {
        CITY: 'CABATUAN',
        BARANGAY: 'PARAISO',
    },
    {
        CITY: 'CABATUAN',
        BARANGAY: 'RANG-AY (CAGGONG)',
    },
    {
        CITY: 'CABATUAN',
        BARANGAY: 'SAMPALOC',
    },
    {
        CITY: 'CABATUAN',
        BARANGAY: 'SAN ANDRES (TEODORO ABAD)',
    },
    {
        CITY: 'CABATUAN',
        BARANGAY: 'SARANAY',
    },
    {
        CITY: 'CABATUAN',
        BARANGAY: 'TANDUL',
    },
    {
        CITY: 'LUNA',
        BARANGAY: 'BUSTAMANTE',
    },
    {
        CITY: 'LUNA',
        BARANGAY: 'CENTRO 1 (POB.)',
    },
    {
        CITY: 'LUNA',
        BARANGAY: 'CENTRO 2 (POB.)',
    },
    {
        CITY: 'LUNA',
        BARANGAY: 'CENTRO 3 (POB.)',
    },
    {
        CITY: 'LUNA',
        BARANGAY: 'CONCEPCION',
    },
    {
        CITY: 'LUNA',
        BARANGAY: 'DADAP',
    },
    {
        CITY: 'LUNA',
        BARANGAY: 'HARANA',
    },
    {
        CITY: 'LUNA',
        BARANGAY: 'LALOG 1',
    },
    {
        CITY: 'LUNA',
        BARANGAY: 'LALOG 2',
    },
    {
        CITY: 'LUNA',
        BARANGAY: 'LUYAO',
    },
    {
        CITY: 'LUNA',
        BARANGAY: 'MACANAO',
    },
    {
        CITY: 'LUNA',
        BARANGAY: 'MACUGAY',
    },
    {
        CITY: 'LUNA',
        BARANGAY: 'MAMBABANGA',
    },
    {
        CITY: 'LUNA',
        BARANGAY: 'PULAY',
    },
    {
        CITY: 'LUNA',
        BARANGAY: 'PUROC',
    },
    {
        CITY: 'LUNA',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'LUNA',
        BARANGAY: 'SAN MIGUEL',
    },
    {
        CITY: 'LUNA',
        BARANGAY: 'SANTO DOMINGO',
    },
    {
        CITY: 'LUNA',
        BARANGAY: 'UNION KALINGA',
    },
    {
        CITY: 'NAGUILIAN',
        BARANGAY: 'AGUINALDO',
    },
    {
        CITY: 'NAGUILIAN',
        BARANGAY: 'BAGONG SIKAT',
    },
    {
        CITY: 'NAGUILIAN',
        BARANGAY: 'BURGOS',
    },
    {
        CITY: 'NAGUILIAN',
        BARANGAY: 'CABARUAN',
    },
    {
        CITY: 'NAGUILIAN',
        BARANGAY: 'FLORES',
    },
    {
        CITY: 'NAGUILIAN',
        BARANGAY: 'LA UNION',
    },
    {
        CITY: 'NAGUILIAN',
        BARANGAY: 'MAGSAYSAY (POB.)',
    },
    {
        CITY: 'NAGUILIAN',
        BARANGAY: 'MANARING',
    },
    {
        CITY: 'NAGUILIAN',
        BARANGAY: 'MANSIBANG',
    },
    {
        CITY: 'NAGUILIAN',
        BARANGAY: 'MINALLO',
    },
    {
        CITY: 'NAGUILIAN',
        BARANGAY: 'MINANGA',
    },
    {
        CITY: 'NAGUILIAN',
        BARANGAY: 'PALATTAO',
    },
    {
        CITY: 'NAGUILIAN',
        BARANGAY: 'QUEZON (POB.)',
    },
    {
        CITY: 'NAGUILIAN',
        BARANGAY: 'QUINALABASA',
    },
    {
        CITY: 'NAGUILIAN',
        BARANGAY: 'QUIRINO (POB.)',
    },
    {
        CITY: 'NAGUILIAN',
        BARANGAY: 'RANGAYAN',
    },
    {
        CITY: 'NAGUILIAN',
        BARANGAY: 'RIZAL',
    },
    {
        CITY: 'NAGUILIAN',
        BARANGAY: 'ROXAS (POB.)',
    },
    {
        CITY: 'NAGUILIAN',
        BARANGAY: 'SAN MANUEL',
    },
    {
        CITY: 'NAGUILIAN',
        BARANGAY: 'SANTA VICTORIA (VILLA CAPUCHINO)',
    },
    {
        CITY: 'NAGUILIAN',
        BARANGAY: 'SANTO TOMAS',
    },
    {
        CITY: 'NAGUILIAN',
        BARANGAY: 'SUNLIFE',
    },
    {
        CITY: 'NAGUILIAN',
        BARANGAY: 'SURCOC',
    },
    {
        CITY: 'NAGUILIAN',
        BARANGAY: 'TOMINES',
    },
    {
        CITY: 'NAGUILIAN',
        BARANGAY: 'VILLA PAZ',
    },
    {
        CITY: 'ISABELA-QUEZON',
        BARANGAY: 'ABUT',
    },
    {
        CITY: 'ISABELA-QUEZON',
        BARANGAY: 'ALUNAN (POB.)',
    },
    {
        CITY: 'ISABELA-QUEZON',
        BARANGAY: 'ARELLANO (POB.)',
    },
    {
        CITY: 'ISABELA-QUEZON',
        BARANGAY: 'AURORA',
    },
    {
        CITY: 'ISABELA-QUEZON',
        BARANGAY: 'BARUCBOC NORTE',
    },
    {
        CITY: 'ISABELA-QUEZON',
        BARANGAY: 'CALANGIGAN (CALAMAGUI)',
    },
    {
        CITY: 'ISABELA-QUEZON',
        BARANGAY: 'DUNMON',
    },
    {
        CITY: 'ISABELA-QUEZON',
        BARANGAY: 'ESTRADA',
    },
    {
        CITY: 'ISABELA-QUEZON',
        BARANGAY: 'LEPANTO',
    },
    {
        CITY: 'ISABELA-QUEZON',
        BARANGAY: 'MANGGA',
    },
    {
        CITY: 'ISABELA-QUEZON',
        BARANGAY: 'MINAGBAG',
    },
    {
        CITY: 'ISABELA-QUEZON',
        BARANGAY: 'SAMONTE (POB.)',
    },
    {
        CITY: 'ISABELA-QUEZON',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'ISABELA-QUEZON',
        BARANGAY: 'SANTOS (POB.)',
    },
    {
        CITY: 'ISABELA-QUEZON',
        BARANGAY: 'TUROD',
    },
    {
        CITY: 'QUIRINO',
        BARANGAY: 'BINARZANG',
    },
    {
        CITY: 'QUIRINO',
        BARANGAY: 'CABARUAN',
    },
    {
        CITY: 'QUIRINO',
        BARANGAY: 'CAMAAL',
    },
    {
        CITY: 'QUIRINO',
        BARANGAY: 'DOLORES',
    },
    {
        CITY: 'QUIRINO',
        BARANGAY: 'LUNA',
    },
    {
        CITY: 'QUIRINO',
        BARANGAY: 'MANAOAG',
    },
    {
        CITY: 'QUIRINO',
        BARANGAY: 'RIZAL',
    },
    {
        CITY: 'QUIRINO',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'QUIRINO',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'QUIRINO',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'QUIRINO',
        BARANGAY: 'SAN MATEO',
    },
    {
        CITY: 'QUIRINO',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'QUIRINO',
        BARANGAY: 'SANTA CATALINA',
    },
    {
        CITY: 'QUIRINO',
        BARANGAY: 'SANTA LUCIA (POB.)',
    },
    {
        CITY: 'QUIRINO',
        BARANGAY: 'SANTIAGO',
    },
    {
        CITY: 'QUIRINO',
        BARANGAY: 'SANTO DOMINGO',
    },
    {
        CITY: 'QUIRINO',
        BARANGAY: 'SINAIT',
    },
    {
        CITY: 'QUIRINO',
        BARANGAY: 'SUERTE',
    },
    {
        CITY: 'QUIRINO',
        BARANGAY: 'VILLA BULUSAN',
    },
    {
        CITY: 'QUIRINO',
        BARANGAY: 'VILLA MIGUEL (UGAK)',
    },
    {
        CITY: 'QUIRINO',
        BARANGAY: 'VINTAR',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'ANAO',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'BANTUG (POB.)',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'DONA CONCHA',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'IMBIAO',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'LANTING',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'LUCBAN',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'LUNA (POB.)',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'MARCOS',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'MASIGUN',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'MATUSALEM',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'MUNOZ EAST',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'MUNOZ WEST',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'QUILING',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'RANG-AYAN',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'RIZAL (POB.)',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'SAN LUIS',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'SAN PEDRO',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'SAN PLACIDO',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'SAN RAFAEL',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'SIMIMBAAN',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'SINAMAR',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'SOTERO NUESA',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'VILLA CONCEPCION',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'VIRA (POB.)',
    },
    {
        CITY: 'SAN-AGUSTIN',
        BARANGAY: 'BAUTISTA',
    },
    {
        CITY: 'SAN-AGUSTIN',
        BARANGAY: 'CALAOCAN',
    },
    {
        CITY: 'SAN-AGUSTIN',
        BARANGAY: 'DABUBU GRANDE',
    },
    {
        CITY: 'SAN-AGUSTIN',
        BARANGAY: 'DABUBU PEQUENO',
    },
    {
        CITY: 'SAN-AGUSTIN',
        BARANGAY: 'DAPPIG',
    },
    {
        CITY: 'SAN-AGUSTIN',
        BARANGAY: 'LAOAG',
    },
    {
        CITY: 'SAN-AGUSTIN',
        BARANGAY: 'MAPALAD',
    },
    {
        CITY: 'SAN-AGUSTIN',
        BARANGAY: 'MASAYA CENTRO (POB.)',
    },
    {
        CITY: 'SAN-AGUSTIN',
        BARANGAY: 'MASAYA NORTE',
    },
    {
        CITY: 'SAN-AGUSTIN',
        BARANGAY: 'MASAYA SUR',
    },
    {
        CITY: 'SAN-AGUSTIN',
        BARANGAY: 'NEMMATAN',
    },
    {
        CITY: 'SAN-AGUSTIN',
        BARANGAY: 'PALACIAN',
    },
    {
        CITY: 'SAN-AGUSTIN',
        BARANGAY: 'PANANG',
    },
    {
        CITY: 'SAN-AGUSTIN',
        BARANGAY: 'QUIMALABASA NORTE',
    },
    {
        CITY: 'SAN-AGUSTIN',
        BARANGAY: 'QUIMALABASA SUR',
    },
    {
        CITY: 'SAN-AGUSTIN',
        BARANGAY: 'RANG-AY',
    },
    {
        CITY: 'SAN-AGUSTIN',
        BARANGAY: 'SALAY',
    },
    {
        CITY: 'SAN-AGUSTIN',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'SAN-AGUSTIN',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'SAN-AGUSTIN',
        BARANGAY: 'SANTOS',
    },
    {
        CITY: 'SAN-AGUSTIN',
        BARANGAY: 'SINAOANGAN NORTE',
    },
    {
        CITY: 'SAN-AGUSTIN',
        BARANGAY: 'SINAOANGAN SUR',
    },
    {
        CITY: 'SAN-AGUSTIN',
        BARANGAY: 'VIRGONEZA',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'CAMARAG',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'CEBU',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'GOMEZ',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'GUD',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'NAGBUKEL',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'PATANAD',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'QUEZON',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'RAMOS EAST',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'RAMOS WEST',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'RIZAL EAST (POB.)',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'RIZAL WEST (POB.)',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'VICTORIA',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'VILLAFLOR',
    },
    {
        CITY: 'SAN-MANUEL',
        BARANGAY: 'AGLIAM',
    },
    {
        CITY: 'SAN-MANUEL',
        BARANGAY: 'BABANUANG',
    },
    {
        CITY: 'SAN-MANUEL',
        BARANGAY: 'CABARITAN',
    },
    {
        CITY: 'SAN-MANUEL',
        BARANGAY: 'CARANIOGAN',
    },
    {
        CITY: 'SAN-MANUEL',
        BARANGAY: 'DISTRICT 1 (POB.)',
    },
    {
        CITY: 'SAN-MANUEL',
        BARANGAY: 'DISTRICT 2 (POB.)',
    },
    {
        CITY: 'SAN-MANUEL',
        BARANGAY: 'DISTRICT 3 (POB.)',
    },
    {
        CITY: 'SAN-MANUEL',
        BARANGAY: 'DISTRICT 4 (POB.)',
    },
    {
        CITY: 'SAN-MANUEL',
        BARANGAY: 'EDEN',
    },
    {
        CITY: 'SAN-MANUEL',
        BARANGAY: 'MALALINTA',
    },
    {
        CITY: 'SAN-MANUEL',
        BARANGAY: 'MARARIGUE',
    },
    {
        CITY: 'SAN-MANUEL',
        BARANGAY: 'NUEVA ERA',
    },
    {
        CITY: 'SAN-MANUEL',
        BARANGAY: 'PISANG',
    },
    {
        CITY: 'SAN-MANUEL',
        BARANGAY: 'SAN FRANCISCO',
    },
    {
        CITY: 'SAN-MANUEL',
        BARANGAY: 'SANDIAT CENTRO',
    },
    {
        CITY: 'SAN-MANUEL',
        BARANGAY: 'SANDIAT EAST',
    },
    {
        CITY: 'SAN-MANUEL',
        BARANGAY: 'SANDIAT WEST',
    },
    {
        CITY: 'SAN-MANUEL',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'SAN-MANUEL',
        BARANGAY: 'VILLANUEVA',
    },
    {
        CITY: 'SAN-MATEO',
        BARANGAY: 'BACARENA',
    },
    {
        CITY: 'SAN-MATEO',
        BARANGAY: 'BAGONG SIKAT',
    },
    {
        CITY: 'SAN-MATEO',
        BARANGAY: 'BARANGAY I (POB.)',
    },
    {
        CITY: 'SAN-MATEO',
        BARANGAY: 'BARANGAY II (POB.)',
    },
    {
        CITY: 'SAN-MATEO',
        BARANGAY: 'BARANGAY III (POB.)',
    },
    {
        CITY: 'SAN-MATEO',
        BARANGAY: 'BARANGAY IV (POB.)',
    },
    {
        CITY: 'SAN-MATEO',
        BARANGAY: 'BELLA LUZ',
    },
    {
        CITY: 'SAN-MATEO',
        BARANGAY: 'DAGUPAN',
    },
    {
        CITY: 'SAN-MATEO',
        BARANGAY: 'DARAMUANGAN NORTE',
    },
    {
        CITY: 'SAN-MATEO',
        BARANGAY: 'DARAMUANGAN SUR',
    },
    {
        CITY: 'SAN-MATEO',
        BARANGAY: 'ESTRELLA',
    },
    {
        CITY: 'SAN-MATEO',
        BARANGAY: 'GADDANAN',
    },
    {
        CITY: 'SAN-MATEO',
        BARANGAY: 'MALASIN',
    },
    {
        CITY: 'SAN-MATEO',
        BARANGAY: 'MARASAT GRANDE',
    },
    {
        CITY: 'SAN-MATEO',
        BARANGAY: 'MARASAT PEQUENO',
    },
    {
        CITY: 'SAN-MATEO',
        BARANGAY: 'OLD CENTRO I',
    },
    {
        CITY: 'SAN-MATEO',
        BARANGAY: 'OLD CENTRO II',
    },
    {
        CITY: 'SAN-MATEO',
        BARANGAY: 'SALINUNGAN EAST',
    },
    {
        CITY: 'SAN-MATEO',
        BARANGAY: 'SALINUNGAN WEST',
    },
    {
        CITY: 'SAN-MATEO',
        BARANGAY: 'SAN ANDRES',
    },
    {
        CITY: 'SAN-MATEO',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'SAN-MATEO',
        BARANGAY: 'SAN IGNACIO',
    },
    {
        CITY: 'SAN-MATEO',
        BARANGAY: 'SAN MANUEL',
    },
    {
        CITY: 'SAN-MATEO',
        BARANGAY: 'SAN MARCOS',
    },
    {
        CITY: 'SAN-MATEO',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'SAN-MATEO',
        BARANGAY: 'SINAMAR NORTE',
    },
    {
        CITY: 'SAN-MATEO',
        BARANGAY: 'SINAMAR SUR',
    },
    {
        CITY: 'SAN-MATEO',
        BARANGAY: 'VICTORIA',
    },
    {
        CITY: 'SAN-MATEO',
        BARANGAY: 'VILLA CRUZ',
    },
    {
        CITY: 'SAN-MATEO',
        BARANGAY: 'VILLA GAMIAO (BUYON)',
    },
    {
        CITY: 'SAN-MATEO',
        BARANGAY: 'VILLA MAGAT',
    },
    {
        CITY: 'SAN-MATEO',
        BARANGAY: 'VILLAFUERTE',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'ANNANUMAN',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'AUITAN',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'BALLACAYU',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'BINGUANG',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'BUNGAD',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'CADDANGAN/LIMBAUAN',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'CALAMAGUI',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'CARALUCUD',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'DALENA',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'GUMINGA',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'MINANGA NORTE',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'MINANGA SUR',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'SIMANU NORTE',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'SIMANU SUR',
    },
    {
        CITY: 'SAN-PABLO',
        BARANGAY: 'TUPA (SAN VICENTE)',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'BANGAD',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'BUENAVISTA',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'CALAMAGUI EAST',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'CALAMAGUI NORTH',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'CALAMAGUI WEST',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'DIVISORIA',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'LINGALING',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'MOZZOZZIN NORTH',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'MOZZOZZIN SUR',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'NAGANACAN',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'POBLACION 1',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'POBLACION 2',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'POBLACION 3',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'QUINAGABIAN',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'SAN ISIDRO EAST',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'SAN ISIDRO WEST',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'SAN RAFAEL EAST',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'SAN RAFAEL WEST',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'VILLABUENA',
    },
    {
        CITY: 'SANTO-TOMAS',
        BARANGAY: 'AMMUGAUAN',
    },
    {
        CITY: 'SANTO-TOMAS',
        BARANGAY: 'ANTAGAN',
    },
    {
        CITY: 'SANTO-TOMAS',
        BARANGAY: 'BAGABAG',
    },
    {
        CITY: 'SANTO-TOMAS',
        BARANGAY: 'BAGUTARI',
    },
    {
        CITY: 'SANTO-TOMAS',
        BARANGAY: 'BALELLENG',
    },
    {
        CITY: 'SANTO-TOMAS',
        BARANGAY: 'BARUMBONG',
    },
    {
        CITY: 'SANTO-TOMAS',
        BARANGAY: 'BIGA OCCIDENTAL',
    },
    {
        CITY: 'SANTO-TOMAS',
        BARANGAY: 'BIGA ORIENTAL',
    },
    {
        CITY: 'SANTO-TOMAS',
        BARANGAY: 'BOLINAO-CULALABO',
    },
    {
        CITY: 'SANTO-TOMAS',
        BARANGAY: 'BUBUG',
    },
    {
        CITY: 'SANTO-TOMAS',
        BARANGAY: 'CALANIGAN NORTE',
    },
    {
        CITY: 'SANTO-TOMAS',
        BARANGAY: 'CALANIGAN SUR',
    },
    {
        CITY: 'SANTO-TOMAS',
        BARANGAY: 'CALINAOAN CENTRO',
    },
    {
        CITY: 'SANTO-TOMAS',
        BARANGAY: 'CALINAOAN MALASIN',
    },
    {
        CITY: 'SANTO-TOMAS',
        BARANGAY: 'CALINAOAN NORTE',
    },
    {
        CITY: 'SANTO-TOMAS',
        BARANGAY: 'CANOGAN ABAJO NORTE',
    },
    {
        CITY: 'SANTO-TOMAS',
        BARANGAY: 'CANOGAN ABAJO SUR',
    },
    {
        CITY: 'SANTO-TOMAS',
        BARANGAY: 'CANOGAN ALTO',
    },
    {
        CITY: 'SANTO-TOMAS',
        BARANGAY: 'CENTRO',
    },
    {
        CITY: 'SANTO-TOMAS',
        BARANGAY: 'COLUNGUAN',
    },
    {
        CITY: 'SANTO-TOMAS',
        BARANGAY: 'MALAPAGAY',
    },
    {
        CITY: 'SANTO-TOMAS',
        BARANGAY: 'SAN RAFAEL ABAJO',
    },
    {
        CITY: 'SANTO-TOMAS',
        BARANGAY: 'SAN RAFAEL ALTO',
    },
    {
        CITY: 'SANTO-TOMAS',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'SANTO-TOMAS',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'SANTO-TOMAS',
        BARANGAY: 'UAUANG-GALICIA',
    },
    {
        CITY: 'SANTO-TOMAS',
        BARANGAY: 'UAUANG-TULIAO',
    },
    {
        CITY: 'JONES',
        BARANGAY: 'ABULAN',
    },
    {
        CITY: 'JONES',
        BARANGAY: 'ADDALAM',
    },
    {
        CITY: 'JONES',
        BARANGAY: 'ARUBUB',
    },
    {
        CITY: 'JONES',
        BARANGAY: 'BANNAWAG',
    },
    {
        CITY: 'JONES',
        BARANGAY: 'BANTAY',
    },
    {
        CITY: 'JONES',
        BARANGAY: 'BARANGAY I (POB.)',
    },
    {
        CITY: 'JONES',
        BARANGAY: 'BARANGAY II (POB.)',
    },
    {
        CITY: 'JONES',
        BARANGAY: 'BARANGCUAG',
    },
    {
        CITY: 'JONES',
        BARANGAY: 'DALIBUBON',
    },
    {
        CITY: 'JONES',
        BARANGAY: 'DALIGAN',
    },
    {
        CITY: 'JONES',
        BARANGAY: 'DIARAO',
    },
    {
        CITY: 'JONES',
        BARANGAY: 'DIBULUAN',
    },
    {
        CITY: 'JONES',
        BARANGAY: 'DICAMAY I',
    },
    {
        CITY: 'JONES',
        BARANGAY: 'DICAMAY II',
    },
    {
        CITY: 'JONES',
        BARANGAY: 'DIPANGIT',
    },
    {
        CITY: 'JONES',
        BARANGAY: 'DISIMPIT',
    },
    {
        CITY: 'JONES',
        BARANGAY: 'DIVINAN',
    },
    {
        CITY: 'JONES',
        BARANGAY: 'DUMAWING',
    },
    {
        CITY: 'JONES',
        BARANGAY: 'FUGU',
    },
    {
        CITY: 'JONES',
        BARANGAY: 'LACAB',
    },
    {
        CITY: 'JONES',
        BARANGAY: 'LINAMANAN',
    },
    {
        CITY: 'JONES',
        BARANGAY: 'LINOMOT',
    },
    {
        CITY: 'JONES',
        BARANGAY: 'MALANNIT',
    },
    {
        CITY: 'JONES',
        BARANGAY: 'MINURI',
    },
    {
        CITY: 'JONES',
        BARANGAY: 'NAMNAMA',
    },
    {
        CITY: 'JONES',
        BARANGAY: 'NAPALIONG',
    },
    {
        CITY: 'JONES',
        BARANGAY: 'PALAGAO',
    },
    {
        CITY: 'JONES',
        BARANGAY: 'PAPAN ESTE',
    },
    {
        CITY: 'JONES',
        BARANGAY: 'PAPAN WESTE',
    },
    {
        CITY: 'JONES',
        BARANGAY: 'PAYAC',
    },
    {
        CITY: 'JONES',
        BARANGAY: 'PONGPONGAN',
    },
    {
        CITY: 'JONES',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'JONES',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'JONES',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'JONES',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'JONES',
        BARANGAY: 'SAN SEBASTIAN',
    },
    {
        CITY: 'JONES',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'JONES',
        BARANGAY: 'SANTA ISABEL',
    },
    {
        CITY: 'JONES',
        BARANGAY: 'SANTO DOMINGO',
    },
    {
        CITY: 'JONES',
        BARANGAY: 'TUPAX',
    },
    {
        CITY: 'JONES',
        BARANGAY: 'USOL',
    },
    {
        CITY: 'JONES',
        BARANGAY: 'VILLA BELLO',
    },
    {
        CITY: 'MALLIG',
        BARANGAY: 'BINMONTON',
    },
    {
        CITY: 'MALLIG',
        BARANGAY: 'CASILI',
    },
    {
        CITY: 'MALLIG',
        BARANGAY: 'CENTRO I (POB.)',
    },
    {
        CITY: 'MALLIG',
        BARANGAY: 'CENTRO II (POB.)',
    },
    {
        CITY: 'MALLIG',
        BARANGAY: 'HOLY FRIDAY',
    },
    {
        CITY: 'MALLIG',
        BARANGAY: 'MALIGAYA',
    },
    {
        CITY: 'MALLIG',
        BARANGAY: 'MANANO',
    },
    {
        CITY: 'MALLIG',
        BARANGAY: 'OLANGO',
    },
    {
        CITY: 'MALLIG',
        BARANGAY: 'RANG-AYAN',
    },
    {
        CITY: 'MALLIG',
        BARANGAY: 'SAN JOSE NORTE I',
    },
    {
        CITY: 'MALLIG',
        BARANGAY: 'SAN JOSE NORTE II',
    },
    {
        CITY: 'MALLIG',
        BARANGAY: 'SAN JOSE SUR',
    },
    {
        CITY: 'MALLIG',
        BARANGAY: 'SAN PEDRO (BARUCBUC SUR)',
    },
    {
        CITY: 'MALLIG',
        BARANGAY: 'SAN RAMON',
    },
    {
        CITY: 'MALLIG',
        BARANGAY: 'SIEMPRE VIVA NORTE',
    },
    {
        CITY: 'MALLIG',
        BARANGAY: 'SIEMPRE VIVA SUR',
    },
    {
        CITY: 'MALLIG',
        BARANGAY: 'TRINIDAD',
    },
    {
        CITY: 'MALLIG',
        BARANGAY: 'VICTORIA',
    },
    {
        CITY: 'RAMON',
        BARANGAY: 'AMBATALI',
    },
    {
        CITY: 'RAMON',
        BARANGAY: 'BANTUG',
    },
    {
        CITY: 'RAMON',
        BARANGAY: 'BUGALLON NORTE',
    },
    {
        CITY: 'RAMON',
        BARANGAY: 'BUGALLON PROPER (POB.)',
    },
    {
        CITY: 'RAMON',
        BARANGAY: 'BURGOS',
    },
    {
        CITY: 'RAMON',
        BARANGAY: 'GENERAL AGUINALDO',
    },
    {
        CITY: 'RAMON',
        BARANGAY: 'NAGBACALAN',
    },
    {
        CITY: 'RAMON',
        BARANGAY: 'OSCARIZ',
    },
    {
        CITY: 'RAMON',
        BARANGAY: 'PABIL',
    },
    {
        CITY: 'RAMON',
        BARANGAY: 'PAGRANG-AYAN',
    },
    {
        CITY: 'RAMON',
        BARANGAY: 'PLANAS',
    },
    {
        CITY: 'RAMON',
        BARANGAY: 'PUROK NI BULAN',
    },
    {
        CITY: 'RAMON',
        BARANGAY: 'RANIAG',
    },
    {
        CITY: 'RAMON',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'RAMON',
        BARANGAY: 'SAN MIGUEL',
    },
    {
        CITY: 'RAMON',
        BARANGAY: 'SAN SEBASTIAN',
    },
    {
        CITY: 'RAMON',
        BARANGAY: 'VILLA BELTRAN',
    },
    {
        CITY: 'RAMON',
        BARANGAY: 'VILLA CARMEN',
    },
    {
        CITY: 'RAMON',
        BARANGAY: 'VILLA MARCOS',
    },
    {
        CITY: 'REINA-MERCEDES',
        BARANGAY: 'BANQUERO',
    },
    {
        CITY: 'REINA-MERCEDES',
        BARANGAY: 'BINARSANG',
    },
    {
        CITY: 'REINA-MERCEDES',
        BARANGAY: 'CUTOG GRANDE',
    },
    {
        CITY: 'REINA-MERCEDES',
        BARANGAY: 'CUTOG PEQUENO',
    },
    {
        CITY: 'REINA-MERCEDES',
        BARANGAY: 'DANGAN',
    },
    {
        CITY: 'REINA-MERCEDES',
        BARANGAY: 'DISTRICT I (POB.)',
    },
    {
        CITY: 'REINA-MERCEDES',
        BARANGAY: 'DISTRICT II (POB.)',
    },
    {
        CITY: 'REINA-MERCEDES',
        BARANGAY: 'LABINAB GRANDE (POB.)',
    },
    {
        CITY: 'REINA-MERCEDES',
        BARANGAY: 'LABINAB PEQUENO (POB.)',
    },
    {
        CITY: 'REINA-MERCEDES',
        BARANGAY: 'MALLALATANG GRANDE',
    },
    {
        CITY: 'REINA-MERCEDES',
        BARANGAY: 'MALLALATANG TUNGGUI',
    },
    {
        CITY: 'REINA-MERCEDES',
        BARANGAY: 'NAPACCU GRANDE',
    },
    {
        CITY: 'REINA-MERCEDES',
        BARANGAY: 'NAPACCU PEQUENO',
    },
    {
        CITY: 'REINA-MERCEDES',
        BARANGAY: 'SALUCONG',
    },
    {
        CITY: 'REINA-MERCEDES',
        BARANGAY: 'SANTIAGO',
    },
    {
        CITY: 'REINA-MERCEDES',
        BARANGAY: 'SANTOR',
    },
    {
        CITY: 'REINA-MERCEDES',
        BARANGAY: 'SINIPPIL',
    },
    {
        CITY: 'REINA-MERCEDES',
        BARANGAY: 'TALLUNGAN (POB.)',
    },
    {
        CITY: 'REINA-MERCEDES',
        BARANGAY: 'TUROD',
    },
    {
        CITY: 'REINA-MERCEDES',
        BARANGAY: 'VILLADOR',
    },
    {
        CITY: 'SAN-GUILLERMO',
        BARANGAY: 'ANONANG',
    },
    {
        CITY: 'SAN-GUILLERMO',
        BARANGAY: 'ARINGAY',
    },
    {
        CITY: 'SAN-GUILLERMO',
        BARANGAY: 'BURGOS',
    },
    {
        CITY: 'SAN-GUILLERMO',
        BARANGAY: 'CALAOAGAN',
    },
    {
        CITY: 'SAN-GUILLERMO',
        BARANGAY: 'CENTRO 1 (POB.)',
    },
    {
        CITY: 'SAN-GUILLERMO',
        BARANGAY: 'CENTRO 2 (POB.)',
    },
    {
        CITY: 'SAN-GUILLERMO',
        BARANGAY: 'COLORADO',
    },
    {
        CITY: 'SAN-GUILLERMO',
        BARANGAY: 'DIETBAN',
    },
    {
        CITY: 'SAN-GUILLERMO',
        BARANGAY: 'DINGADING',
    },
    {
        CITY: 'SAN-GUILLERMO',
        BARANGAY: 'DIPACAMO',
    },
    {
        CITY: 'SAN-GUILLERMO',
        BARANGAY: 'ESTRELLA',
    },
    {
        CITY: 'SAN-GUILLERMO',
        BARANGAY: 'GUAM',
    },
    {
        CITY: 'SAN-GUILLERMO',
        BARANGAY: 'NAKAR',
    },
    {
        CITY: 'SAN-GUILLERMO',
        BARANGAY: 'PALAWAN',
    },
    {
        CITY: 'SAN-GUILLERMO',
        BARANGAY: 'PROGRESO',
    },
    {
        CITY: 'SAN-GUILLERMO',
        BARANGAY: 'RIZAL',
    },
    {
        CITY: 'SAN-GUILLERMO',
        BARANGAY: 'SAN FRANCISCO NORTE',
    },
    {
        CITY: 'SAN-GUILLERMO',
        BARANGAY: 'SAN FRANCISCO SUR',
    },
    {
        CITY: 'SAN-GUILLERMO',
        BARANGAY: 'SAN MARIANO NORTE',
    },
    {
        CITY: 'SAN-GUILLERMO',
        BARANGAY: 'SAN MARIANO SUR',
    },
    {
        CITY: 'SAN-GUILLERMO',
        BARANGAY: 'SAN RAFAEL',
    },
    {
        CITY: 'SAN-GUILLERMO',
        BARANGAY: 'SINALUGAN',
    },
    {
        CITY: 'SAN-GUILLERMO',
        BARANGAY: 'VILLA REMEDIOS',
    },
    {
        CITY: 'SAN-GUILLERMO',
        BARANGAY: 'VILLA ROSE',
    },
    {
        CITY: 'SAN-GUILLERMO',
        BARANGAY: 'VILLA SANCHEZ',
    },
    {
        CITY: 'SAN-GUILLERMO',
        BARANGAY: 'VILLA TERESITA',
    },
    {
        CITY: 'SAN-MARIANO',
        BARANGAY: 'ALIBADABAD',
    },
    {
        CITY: 'SAN-MARIANO',
        BARANGAY: 'BALAGAN',
    },
    {
        CITY: 'SAN-MARIANO',
        BARANGAY: 'BINATUG',
    },
    {
        CITY: 'SAN-MARIANO',
        BARANGAY: 'BITABIAN',
    },
    {
        CITY: 'SAN-MARIANO',
        BARANGAY: 'BUYASAN',
    },
    {
        CITY: 'SAN-MARIANO',
        BARANGAY: 'CADSALAN',
    },
    {
        CITY: 'SAN-MARIANO',
        BARANGAY: 'CASALA',
    },
    {
        CITY: 'SAN-MARIANO',
        BARANGAY: 'CATAGUING',
    },
    {
        CITY: 'SAN-MARIANO',
        BARANGAY: 'DARAGUTAN EAST',
    },
    {
        CITY: 'SAN-MARIANO',
        BARANGAY: 'DARAGUTAN WEST',
    },
    {
        CITY: 'SAN-MARIANO',
        BARANGAY: 'DEL PILAR',
    },
    {
        CITY: 'SAN-MARIANO',
        BARANGAY: 'DIBULUAN',
    },
    {
        CITY: 'SAN-MARIANO',
        BARANGAY: 'DICAMAY',
    },
    {
        CITY: 'SAN-MARIANO',
        BARANGAY: 'DIPUSU',
    },
    {
        CITY: 'SAN-MARIANO',
        BARANGAY: 'DISULAP',
    },
    {
        CITY: 'SAN-MARIANO',
        BARANGAY: 'DISUSUAN',
    },
    {
        CITY: 'SAN-MARIANO',
        BARANGAY: 'GANGALAN',
    },
    {
        CITY: 'SAN-MARIANO',
        BARANGAY: 'IBUJAN',
    },
    {
        CITY: 'SAN-MARIANO',
        BARANGAY: 'LIBERTAD',
    },
    {
        CITY: 'SAN-MARIANO',
        BARANGAY: 'MACAYUCAYU',
    },
    {
        CITY: 'SAN-MARIANO',
        BARANGAY: 'MALLABO',
    },
    {
        CITY: 'SAN-MARIANO',
        BARANGAY: 'MARANNAO',
    },
    {
        CITY: 'SAN-MARIANO',
        BARANGAY: 'MINANGA',
    },
    {
        CITY: 'SAN-MARIANO',
        BARANGAY: 'OLD SAN MARIANO',
    },
    {
        CITY: 'SAN-MARIANO',
        BARANGAY: 'PALUTAN',
    },
    {
        CITY: 'SAN-MARIANO',
        BARANGAY: 'PANNINAN',
    },
    {
        CITY: 'SAN-MARIANO',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'SAN-MARIANO',
        BARANGAY: 'SAN PABLO',
    },
    {
        CITY: 'SAN-MARIANO',
        BARANGAY: 'SAN PEDRO',
    },
    {
        CITY: 'SAN-MARIANO',
        BARANGAY: 'SANTA FILOMINA',
    },
    {
        CITY: 'SAN-MARIANO',
        BARANGAY: 'TAPPA',
    },
    {
        CITY: 'SAN-MARIANO',
        BARANGAY: 'UEG',
    },
    {
        CITY: 'SAN-MARIANO',
        BARANGAY: 'ZAMORA',
    },
    {
        CITY: 'SAN-MARIANO',
        BARANGAY: 'ZONE I (POB.)',
    },
    {
        CITY: 'SAN-MARIANO',
        BARANGAY: 'ZONE II (POB.)',
    },
    {
        CITY: 'SAN-MARIANO',
        BARANGAY: 'ZONE III (POB.)',
    },
    {
        CITY: 'SANTIAGO',
        BARANGAY: 'ABRA',
    },
    {
        CITY: 'SANTIAGO',
        BARANGAY: 'AMBALATUNGAN',
    },
    {
        CITY: 'SANTIAGO',
        BARANGAY: 'BALINTOCATOC',
    },
    {
        CITY: 'SANTIAGO',
        BARANGAY: 'BALUARTE',
    },
    {
        CITY: 'SANTIAGO',
        BARANGAY: 'BANNAWAG NORTE',
    },
    {
        CITY: 'SANTIAGO',
        BARANGAY: 'BATAL',
    },
    {
        CITY: 'SANTIAGO',
        BARANGAY: 'BUENAVISTA',
    },
    {
        CITY: 'SANTIAGO',
        BARANGAY: 'CABULAY',
    },
    {
        CITY: 'SANTIAGO',
        BARANGAY: 'CALAO EAST (POB.)',
    },
    {
        CITY: 'SANTIAGO',
        BARANGAY: 'CALAO WEST (POB.)',
    },
    {
        CITY: 'SANTIAGO',
        BARANGAY: 'CALAOCAN',
    },
    {
        CITY: 'SANTIAGO',
        BARANGAY: 'CENTRO EAST (POB.)',
    },
    {
        CITY: 'SANTIAGO',
        BARANGAY: 'CENTRO WEST (POB.)',
    },
    {
        CITY: 'SANTIAGO',
        BARANGAY: 'DIVISORIA',
    },
    {
        CITY: 'SANTIAGO',
        BARANGAY: 'DUBINAN EAST',
    },
    {
        CITY: 'SANTIAGO',
        BARANGAY: 'DUBINAN WEST',
    },
    {
        CITY: 'SANTIAGO',
        BARANGAY: 'LUNA',
    },
    {
        CITY: 'SANTIAGO',
        BARANGAY: 'MABINI',
    },
    {
        CITY: 'SANTIAGO',
        BARANGAY: 'MALVAR',
    },
    {
        CITY: 'SANTIAGO',
        BARANGAY: 'NABBUAN',
    },
    {
        CITY: 'SANTIAGO',
        BARANGAY: 'NAGGASICAN',
    },
    {
        CITY: 'SANTIAGO',
        BARANGAY: 'PATUL',
    },
    {
        CITY: 'SANTIAGO',
        BARANGAY: 'PLARIDEL',
    },
    {
        CITY: 'SANTIAGO',
        BARANGAY: 'RIZAL',
    },
    {
        CITY: 'SANTIAGO',
        BARANGAY: 'ROSARIO',
    },
    {
        CITY: 'SANTIAGO',
        BARANGAY: 'SAGANA',
    },
    {
        CITY: 'SANTIAGO',
        BARANGAY: 'SALVADOR',
    },
    {
        CITY: 'SANTIAGO',
        BARANGAY: 'SAN ANDRES',
    },
    {
        CITY: 'SANTIAGO',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'SANTIAGO',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'SANTIAGO',
        BARANGAY: 'SANTA ROSA',
    },
    {
        CITY: 'SANTIAGO',
        BARANGAY: 'SINILI',
    },
    {
        CITY: 'SANTIAGO',
        BARANGAY: 'SINSAYON',
    },
    {
        CITY: 'SANTIAGO',
        BARANGAY: 'VICTORY NORTE',
    },
    {
        CITY: 'SANTIAGO',
        BARANGAY: 'VICTORY SUR',
    },
    {
        CITY: 'SANTIAGO',
        BARANGAY: 'VILLA GONZAGA',
    },
    {
        CITY: 'SANTIAGO',
        BARANGAY: 'VILLASIS',
    },
    {
        CITY: 'TUMAUINI',
        BARANGAY: 'ANNAFUNAN',
    },
    {
        CITY: 'TUMAUINI',
        BARANGAY: 'ANTAGAN I',
    },
    {
        CITY: 'TUMAUINI',
        BARANGAY: 'ANTAGAN II',
    },
    {
        CITY: 'TUMAUINI',
        BARANGAY: 'ARCON',
    },
    {
        CITY: 'TUMAUINI',
        BARANGAY: 'BALUG',
    },
    {
        CITY: 'TUMAUINI',
        BARANGAY: 'BANIG',
    },
    {
        CITY: 'TUMAUINI',
        BARANGAY: 'BANTUG',
    },
    {
        CITY: 'TUMAUINI',
        BARANGAY: 'BARANGAY DISTRICT 1 (POB.)',
    },
    {
        CITY: 'TUMAUINI',
        BARANGAY: 'BARANGAY DISTRICT 2 (POB.)',
    },
    {
        CITY: 'TUMAUINI',
        BARANGAY: 'BARANGAY DISTRICT 3 (POB.)',
    },
    {
        CITY: 'TUMAUINI',
        BARANGAY: 'BARANGAY DISTRICT 4 (POB.)',
    },
    {
        CITY: 'TUMAUINI',
        BARANGAY: 'BAYABO EAST',
    },
    {
        CITY: 'TUMAUINI',
        BARANGAY: 'CALIGAYAN',
    },
    {
        CITY: 'TUMAUINI',
        BARANGAY: 'CAMASI',
    },
    {
        CITY: 'TUMAUINI',
        BARANGAY: 'CARPENTERO',
    },
    {
        CITY: 'TUMAUINI',
        BARANGAY: 'COMPANIA',
    },
    {
        CITY: 'TUMAUINI',
        BARANGAY: 'CUMABAO',
    },
    {
        CITY: 'TUMAUINI',
        BARANGAY: 'FERMELDY (HCDA. SAN FRANCISCO)',
    },
    {
        CITY: 'TUMAUINI',
        BARANGAY: 'FUGU ABAJO',
    },
    {
        CITY: 'TUMAUINI',
        BARANGAY: 'FUGU NORTE',
    },
    {
        CITY: 'TUMAUINI',
        BARANGAY: 'FUGU SUR',
    },
    {
        CITY: 'TUMAUINI',
        BARANGAY: 'LALAUANAN',
    },
    {
        CITY: 'TUMAUINI',
        BARANGAY: 'LANNA',
    },
    {
        CITY: 'TUMAUINI',
        BARANGAY: 'LAPOGAN',
    },
    {
        CITY: 'TUMAUINI',
        BARANGAY: 'LINGALING',
    },
    {
        CITY: 'TUMAUINI',
        BARANGAY: 'LIWANAG',
    },
    {
        CITY: 'TUMAUINI',
        BARANGAY: 'MALAMAG EAST',
    },
    {
        CITY: 'TUMAUINI',
        BARANGAY: 'MALAMAG WEST',
    },
    {
        CITY: 'TUMAUINI',
        BARANGAY: 'MALIGAYA',
    },
    {
        CITY: 'TUMAUINI',
        BARANGAY: 'MINANGA',
    },
    {
        CITY: 'TUMAUINI',
        BARANGAY: 'MOLDERO',
    },
    {
        CITY: 'TUMAUINI',
        BARANGAY: 'NAMNAMA',
    },
    {
        CITY: 'TUMAUINI',
        BARANGAY: 'PARAGU',
    },
    {
        CITY: 'TUMAUINI',
        BARANGAY: 'PILITAN',
    },
    {
        CITY: 'TUMAUINI',
        BARANGAY: 'SAN MATEO',
    },
    {
        CITY: 'TUMAUINI',
        BARANGAY: 'SAN PEDRO',
    },
    {
        CITY: 'TUMAUINI',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'TUMAUINI',
        BARANGAY: 'SANTA',
    },
    {
        CITY: 'TUMAUINI',
        BARANGAY: 'SANTA CATALINA',
    },
    {
        CITY: 'TUMAUINI',
        BARANGAY: 'SANTA VISITACION (MAGGAYU)',
    },
    {
        CITY: 'TUMAUINI',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'TUMAUINI',
        BARANGAY: 'SINIPPIL',
    },
    {
        CITY: 'TUMAUINI',
        BARANGAY: 'SISIM ABAJO',
    },
    {
        CITY: 'TUMAUINI',
        BARANGAY: 'SISIM ALTO',
    },
    {
        CITY: 'TUMAUINI',
        BARANGAY: 'TUNGGUI',
    },
    {
        CITY: 'TUMAUINI',
        BARANGAY: 'UGAD',
    },
    {
        CITY: 'RIZAL',
        BARANGAY: 'BABALAG EAST (POB.)',
    },
    {
        CITY: 'RIZAL',
        BARANGAY: 'BABALAG WEST (POB.)',
    },
    {
        CITY: 'RIZAL',
        BARANGAY: 'BULBOL',
    },
    {
        CITY: 'RIZAL',
        BARANGAY: 'CALAOCAN',
    },
    {
        CITY: 'RIZAL',
        BARANGAY: 'LIWAN EAST',
    },
    {
        CITY: 'RIZAL',
        BARANGAY: 'LIWAN WEST',
    },
    {
        CITY: 'RIZAL',
        BARANGAY: 'MACUTAY',
    },
    {
        CITY: 'RIZAL',
        BARANGAY: 'ROMUALDEZ',
    },
    {
        CITY: 'RIZAL',
        BARANGAY: 'SAN FRANCISCO',
    },
    {
        CITY: 'RIZAL',
        BARANGAY: 'SAN PEDRO',
    },
    {
        CITY: 'RIZAL',
        BARANGAY: 'SANTOR',
    },
    {
        CITY: 'PINUKPUK',
        BARANGAY: 'ACIGA',
    },
    {
        CITY: 'PINUKPUK',
        BARANGAY: 'ALLAGUIA',
    },
    {
        CITY: 'PINUKPUK',
        BARANGAY: 'APATAN',
    },
    {
        CITY: 'PINUKPUK',
        BARANGAY: 'ASIBANGLAN',
    },
    {
        CITY: 'PINUKPUK',
        BARANGAY: 'BA-AY',
    },
    {
        CITY: 'PINUKPUK',
        BARANGAY: 'BALLAYANGON',
    },
    {
        CITY: 'PINUKPUK',
        BARANGAY: 'BAYAO',
    },
    {
        CITY: 'PINUKPUK',
        BARANGAY: 'CAMALOG',
    },
    {
        CITY: 'PINUKPUK',
        BARANGAY: 'CAWAGAYAN',
    },
    {
        CITY: 'PINUKPUK',
        BARANGAY: 'KATABBOGAN',
    },
    {
        CITY: 'PINUKPUK',
        BARANGAY: 'LIMOS',
    },
    {
        CITY: 'PINUKPUK',
        BARANGAY: 'MAGAOGAO',
    },
    {
        CITY: 'PINUKPUK',
        BARANGAY: 'MAPACO',
    },
    {
        CITY: 'PINUKPUK',
        BARANGAY: 'PAKAWIT',
    },
    {
        CITY: 'PINUKPUK',
        BARANGAY: 'PINUKPUK JUNCTION',
    },
    {
        CITY: 'PINUKPUK',
        BARANGAY: 'SOCBOT',
    },
    {
        CITY: 'PINUKPUK',
        BARANGAY: 'TAGA (POB.)',
    },
    {
        CITY: 'PINUKPUK',
        BARANGAY: 'TAGGAY',
    },
    {
        CITY: 'PINUKPUK',
        BARANGAY: 'WAGUD',
    },
    {
        CITY: 'TABUK-CITY',
        BARANGAY: 'AGBANNAWAG',
    },
    {
        CITY: 'TABUK-CITY',
        BARANGAY: 'AMLAO',
    },
    {
        CITY: 'TABUK-CITY',
        BARANGAY: 'APPAS',
    },
    {
        CITY: 'TABUK-CITY',
        BARANGAY: 'BADO DANGWA',
    },
    {
        CITY: 'TABUK-CITY',
        BARANGAY: 'BAGUMBAYAN',
    },
    {
        CITY: 'TABUK-CITY',
        BARANGAY: 'BALAWAG',
    },
    {
        CITY: 'TABUK-CITY',
        BARANGAY: 'BALONG',
    },
    {
        CITY: 'TABUK-CITY',
        BARANGAY: 'BANTAY',
    },
    {
        CITY: 'TABUK-CITY',
        BARANGAY: 'BULANAO',
    },
    {
        CITY: 'TABUK-CITY',
        BARANGAY: 'BULANAO',
    },
    {
        CITY: 'TABUK-CITY',
        BARANGAY: 'BULANAO NORTE',
    },
    {
        CITY: 'TABUK-CITY',
        BARANGAY: 'BULO',
    },
    {
        CITY: 'TABUK-CITY',
        BARANGAY: 'CABARITAN',
    },
    {
        CITY: 'TABUK-CITY',
        BARANGAY: 'CABARUAN',
    },
    {
        CITY: 'TABUK-CITY',
        BARANGAY: 'CALACCAD',
    },
    {
        CITY: 'TABUK-CITY',
        BARANGAY: 'CALANAN',
    },
    {
        CITY: 'TABUK-CITY',
        BARANGAY: 'CASIGAYAN',
    },
    {
        CITY: 'TABUK-CITY',
        BARANGAY: 'CUDAL',
    },
    {
        CITY: 'TABUK-CITY',
        BARANGAY: 'DAGUPAN CENTRO (POB.)',
    },
    {
        CITY: 'TABUK-CITY',
        BARANGAY: 'DAGUPAN WESTE',
    },
    {
        CITY: 'TABUK-CITY',
        BARANGAY: 'DILAG',
    },
    {
        CITY: 'TABUK-CITY',
        BARANGAY: 'DUPAG',
    },
    {
        CITY: 'TABUK-CITY',
        BARANGAY: 'GOBGOB',
    },
    {
        CITY: 'TABUK-CITY',
        BARANGAY: 'GUILAYON',
    },
    {
        CITY: 'TABUK-CITY',
        BARANGAY: 'IPIL',
    },
    {
        CITY: 'TABUK-CITY',
        BARANGAY: 'LACNOG',
    },
    {
        CITY: 'TABUK-CITY',
        BARANGAY: 'LANNA',
    },
    {
        CITY: 'TABUK-CITY',
        BARANGAY: 'LAYA EAST',
    },
    {
        CITY: 'TABUK-CITY',
        BARANGAY: 'LAYA WEST',
    },
    {
        CITY: 'TABUK-CITY',
        BARANGAY: 'LUCOG',
    },
    {
        CITY: 'TABUK-CITY',
        BARANGAY: 'MAGNAO',
    },
    {
        CITY: 'TABUK-CITY',
        BARANGAY: 'MAGSAYSAY',
    },
    {
        CITY: 'TABUK-CITY',
        BARANGAY: 'MALIN-AWA',
    },
    {
        CITY: 'TABUK-CITY',
        BARANGAY: 'MASABLANG',
    },
    {
        CITY: 'TABUK-CITY',
        BARANGAY: 'NAMBARAN',
    },
    {
        CITY: 'TABUK-CITY',
        BARANGAY: 'NAMBUCAYAN',
    },
    {
        CITY: 'TABUK-CITY',
        BARANGAY: 'NANENG',
    },
    {
        CITY: 'TABUK-CITY',
        BARANGAY: 'NEW TANGLAG',
    },
    {
        CITY: 'TABUK-CITY',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'TABUK-CITY',
        BARANGAY: 'SAN JULIAN',
    },
    {
        CITY: 'TABUK-CITY',
        BARANGAY: 'SUYANG',
    },
    {
        CITY: 'TABUK-CITY',
        BARANGAY: 'TUGA',
    },
    {
        CITY: 'TANUDAN',
        BARANGAY: 'ANGGACAN',
    },
    {
        CITY: 'TANUDAN',
        BARANGAY: 'ANGGACAN SUR',
    },
    {
        CITY: 'TANUDAN',
        BARANGAY: 'BABBANOY',
    },
    {
        CITY: 'TANUDAN',
        BARANGAY: 'DACALAN',
    },
    {
        CITY: 'TANUDAN',
        BARANGAY: 'DUPLIGAN',
    },
    {
        CITY: 'TANUDAN',
        BARANGAY: 'GAANG',
    },
    {
        CITY: 'TANUDAN',
        BARANGAY: 'LAY-ASAN',
    },
    {
        CITY: 'TANUDAN',
        BARANGAY: 'LOWER LUBO',
    },
    {
        CITY: 'TANUDAN',
        BARANGAY: 'LOWER MANGALI',
    },
    {
        CITY: 'TANUDAN',
        BARANGAY: 'LOWER TALOCTOC',
    },
    {
        CITY: 'TANUDAN',
        BARANGAY: 'MABACA',
    },
    {
        CITY: 'TANUDAN',
        BARANGAY: 'MABACA',
    },
    {
        CITY: 'TANUDAN',
        BARANGAY: 'MANGALI CENTRO',
    },
    {
        CITY: 'TANUDAN',
        BARANGAY: 'PANGOL',
    },
    {
        CITY: 'TANUDAN',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'TANUDAN',
        BARANGAY: 'POBLACION',
    }
];
